var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var _pendingRequestUrl, _abortController, _productForm;
import { u as u$1, x, l as l$1, _, k, H as H$1, K as K$1, t as t$1, d as d$1, y as y$1, A as A$1 } from "main/jsxRuntime.module";
import { r as register } from "main/preact-custom-element.esm";
import { m as membershipService, F as FORTHEM_TIER_NAME_ALLACCESS, a as FORTHEM_TIER_NAME_SUPPORT } from "main/membership-service";
import { membershipTierValidator } from "main/membership-tier-validator";
import "main/subscription-gifts";
import "main/preload-helper";
var _jsxFileName$7 = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/components/icons/Check.tsx";
function Check(props) {
  return u$1("svg", {
    ...props,
    width: "18",
    height: "14",
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: u$1("path", {
      d: "M17.3479 2.49744L6.7479 13.0974C6.65402 13.1921 6.52622 13.2453 6.3929 13.2453C6.25958 13.2453 6.13178 13.1921 6.0379 13.0974L0.6479 7.7074C0.55324 7.6136 0.5 7.4858 0.5 7.3524C0.5 7.2191 0.55324 7.0913 0.6479 6.9974L1.3479 6.2974C1.44178 6.2028 1.56958 6.1495 1.7029 6.1495C1.83622 6.1495 1.96402 6.2028 2.0579 6.2974L6.3879 10.6274L15.9379 1.07744C16.1357 0.885646 16.4501 0.885646 16.6479 1.07744L17.3479 1.78744C17.4426 1.88132 17.4958 2.00912 17.4958 2.14244C17.4958 2.27576 17.4426 2.40355 17.3479 2.49744Z",
      fill: "currentColor"
    }, void 0, false, {
      fileName: _jsxFileName$7,
      lineNumber: 4,
      columnNumber: 9
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$7,
    lineNumber: 3,
    columnNumber: 9
  }, this);
}
function r(e) {
  var t2, f2, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t2 = 0; t2 < o; t2++) e[t2] && (f2 = r(e[t2])) && (n && (n += " "), n += f2);
  } else for (f2 in e) e[f2] && (n && (n += " "), n += f2);
  return n;
}
function clsx() {
  for (var e, t2, f2 = 0, n = "", o = arguments.length; f2 < o; f2++) (e = arguments[f2]) && (t2 = r(e)) && (n && (n += " "), n += t2);
  return n;
}
const CLASS_PART_SEPARATOR = "-";
const createClassGroupUtils = (config) => {
  const classMap = createClassMap(config);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config;
  const getClassGroupId = (className) => {
    const classParts = className.split(CLASS_PART_SEPARATOR);
    if (classParts[0] === "" && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  };
  const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier) => {
    const conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [...conflicts, ...conflictingClassGroupModifiers[classGroupId]];
    }
    return conflicts;
  };
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
};
const getGroupRecursive = (classParts, classPartObject) => {
  var _a;
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[0];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  const classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : void 0;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return void 0;
  }
  const classRest = classParts.join(CLASS_PART_SEPARATOR);
  return (_a = classPartObject.validators.find(({
    validator
  }) => validator(classRest))) == null ? void 0 : _a.classGroupId;
};
const arbitraryPropertyRegex = /^\[(.+)\]$/;
const getGroupIdForArbitraryProperty = (className) => {
  if (arbitraryPropertyRegex.test(className)) {
    const arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    const property = arbitraryPropertyClassName == null ? void 0 : arbitraryPropertyClassName.substring(0, arbitraryPropertyClassName.indexOf(":"));
    if (property) {
      return "arbitrary.." + property;
    }
  }
};
const createClassMap = (config) => {
  const {
    theme,
    prefix
  } = config;
  const classMap = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  const prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
  prefixedClassGroupEntries.forEach(([classGroupId, classGroup]) => {
    processClassesRecursively(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
};
const processClassesRecursively = (classGroup, classPartObject, classGroupId, theme) => {
  classGroup.forEach((classDefinition) => {
    if (typeof classDefinition === "string") {
      const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === "function") {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(([key, classGroup2]) => {
      processClassesRecursively(classGroup2, getPart(classPartObject, key), classGroupId, theme);
    });
  });
};
const getPart = (classPartObject, path) => {
  let currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach((pathPart) => {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
};
const isThemeGetter = (func) => func.isThemeGetter;
const getPrefixedClassGroupEntries = (classGroupEntries, prefix) => {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(([classGroupId, classGroup]) => {
    const prefixedClassGroup = classGroup.map((classDefinition) => {
      if (typeof classDefinition === "string") {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === "object") {
        return Object.fromEntries(Object.entries(classDefinition).map(([key, value]) => [prefix + key, value]));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
};
const createLruCache = (maxCacheSize) => {
  if (maxCacheSize < 1) {
    return {
      get: () => void 0,
      set: () => {
      }
    };
  }
  let cacheSize = 0;
  let cache = /* @__PURE__ */ new Map();
  let previousCache = /* @__PURE__ */ new Map();
  const update = (key, value) => {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ new Map();
    }
  };
  return {
    get(key) {
      let value = cache.get(key);
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache.get(key)) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
};
const IMPORTANT_MODIFIER = "!";
const createParseClassName = (config) => {
  const {
    separator,
    experimentalParseClassName
  } = config;
  const isSeparatorSingleCharacter = separator.length === 1;
  const firstSeparatorCharacter = separator[0];
  const separatorLength = separator.length;
  const parseClassName = (className) => {
    const modifiers = [];
    let bracketDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    for (let index = 0; index < className.length; index++) {
      let currentCharacter = className[index];
      if (bracketDepth === 0) {
        if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
          modifiers.push(className.slice(modifierStart, index));
          modifierStart = index + separatorLength;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index;
          continue;
        }
      }
      if (currentCharacter === "[") {
        bracketDepth++;
      } else if (currentCharacter === "]") {
        bracketDepth--;
      }
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    const hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
    const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    };
  };
  if (experimentalParseClassName) {
    return (className) => experimentalParseClassName({
      className,
      parseClassName
    });
  }
  return parseClassName;
};
const sortModifiers = (modifiers) => {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  const sortedModifiers = [];
  let unsortedModifiers = [];
  modifiers.forEach((modifier) => {
    const isArbitraryVariant = modifier[0] === "[";
    if (isArbitraryVariant) {
      sortedModifiers.push(...unsortedModifiers.sort(), modifier);
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push(...unsortedModifiers.sort());
  return sortedModifiers;
};
const createConfigUtils = (config) => ({
  cache: createLruCache(config.cacheSize),
  parseClassName: createParseClassName(config),
  ...createClassGroupUtils(config)
});
const SPLIT_CLASSES_REGEX = /\s+/;
const mergeClassList = (classList, configUtils) => {
  const {
    parseClassName,
    getClassGroupId,
    getConflictingClassGroupIds
  } = configUtils;
  const classGroupsInConflict = [];
  const classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
  let result = "";
  for (let index = classNames.length - 1; index >= 0; index -= 1) {
    const originalClassName = classNames[index];
    const {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = parseClassName(originalClassName);
    let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
    let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    if (!classGroupId) {
      if (!hasPostfixModifier) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      hasPostfixModifier = false;
    }
    const variantModifier = sortModifiers(modifiers).join(":");
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.includes(classId)) {
      continue;
    }
    classGroupsInConflict.push(classId);
    const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
    for (let i2 = 0; i2 < conflictGroups.length; ++i2) {
      const group = conflictGroups[i2];
      classGroupsInConflict.push(modifierId + group);
    }
    result = originalClassName + (result.length > 0 ? " " + result : result);
  }
  return result;
};
function twJoin() {
  let index = 0;
  let argument;
  let resolvedValue;
  let string = "";
  while (index < arguments.length) {
    if (argument = arguments[index++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}
const toValue = (mix) => {
  if (typeof mix === "string") {
    return mix;
  }
  let resolvedValue;
  let string = "";
  for (let k2 = 0; k2 < mix.length; k2++) {
    if (mix[k2]) {
      if (resolvedValue = toValue(mix[k2])) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
};
function createTailwindMerge(createConfigFirst, ...createConfigRest) {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    const config = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}
const fromTheme = (key) => {
  const themeGetter = (theme) => theme[key] || [];
  themeGetter.isThemeGetter = true;
  return themeGetter;
};
const arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const fractionRegex = /^\d+\/\d+$/;
const stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]);
const tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
const shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const isLength = (value) => isNumber(value) || stringLengths.has(value) || fractionRegex.test(value);
const isArbitraryLength = (value) => getIsArbitraryValue(value, "length", isLengthOnly);
const isNumber = (value) => Boolean(value) && !Number.isNaN(Number(value));
const isArbitraryNumber = (value) => getIsArbitraryValue(value, "number", isNumber);
const isInteger = (value) => Boolean(value) && Number.isInteger(Number(value));
const isPercent = (value) => value.endsWith("%") && isNumber(value.slice(0, -1));
const isArbitraryValue = (value) => arbitraryValueRegex.test(value);
const isTshirtSize = (value) => tshirtUnitRegex.test(value);
const sizeLabels = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
const isArbitrarySize = (value) => getIsArbitraryValue(value, sizeLabels, isNever);
const isArbitraryPosition = (value) => getIsArbitraryValue(value, "position", isNever);
const imageLabels = /* @__PURE__ */ new Set(["image", "url"]);
const isArbitraryImage = (value) => getIsArbitraryValue(value, imageLabels, isImage);
const isArbitraryShadow = (value) => getIsArbitraryValue(value, "", isShadow);
const isAny = () => true;
const getIsArbitraryValue = (value, label, testValue) => {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return typeof label === "string" ? result[1] === label : label.has(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
};
const isLengthOnly = (value) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  lengthUnitRegex.test(value) && !colorFunctionRegex.test(value)
);
const isNever = () => false;
const isShadow = (value) => shadowRegex.test(value);
const isImage = (value) => imageRegex.test(value);
const getDefaultConfig = () => {
  const colors = fromTheme("colors");
  const spacing = fromTheme("spacing");
  const blur = fromTheme("blur");
  const brightness = fromTheme("brightness");
  const borderColor = fromTheme("borderColor");
  const borderRadius = fromTheme("borderRadius");
  const borderSpacing = fromTheme("borderSpacing");
  const borderWidth = fromTheme("borderWidth");
  const contrast = fromTheme("contrast");
  const grayscale = fromTheme("grayscale");
  const hueRotate = fromTheme("hueRotate");
  const invert = fromTheme("invert");
  const gap = fromTheme("gap");
  const gradientColorStops = fromTheme("gradientColorStops");
  const gradientColorStopPositions = fromTheme("gradientColorStopPositions");
  const inset = fromTheme("inset");
  const margin = fromTheme("margin");
  const opacity = fromTheme("opacity");
  const padding = fromTheme("padding");
  const saturate = fromTheme("saturate");
  const scale = fromTheme("scale");
  const sepia = fromTheme("sepia");
  const skew = fromTheme("skew");
  const space = fromTheme("space");
  const translate = fromTheme("translate");
  const getOverscroll = () => ["auto", "contain", "none"];
  const getOverflow = () => ["auto", "hidden", "clip", "visible", "scroll"];
  const getSpacingWithAutoAndArbitrary = () => ["auto", isArbitraryValue, spacing];
  const getSpacingWithArbitrary = () => [isArbitraryValue, spacing];
  const getLengthWithEmptyAndArbitrary = () => ["", isLength, isArbitraryLength];
  const getNumberWithAutoAndArbitrary = () => ["auto", isNumber, isArbitraryValue];
  const getPositions = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  const getLineStyles = () => ["solid", "dashed", "dotted", "double", "none"];
  const getBlendModes = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
  const getAlign = () => ["start", "end", "center", "between", "around", "evenly", "stretch"];
  const getZeroAndEmpty = () => ["", "0", isArbitraryValue];
  const getBreaks = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  const getNumberAndArbitrary = () => [isNumber, isArbitraryValue];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [isAny],
      spacing: [isLength, isArbitraryLength],
      blur: ["none", "", isTshirtSize, isArbitraryValue],
      brightness: getNumberAndArbitrary(),
      borderColor: [colors],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryValue],
      borderSpacing: getSpacingWithArbitrary(),
      borderWidth: getLengthWithEmptyAndArbitrary(),
      contrast: getNumberAndArbitrary(),
      grayscale: getZeroAndEmpty(),
      hueRotate: getNumberAndArbitrary(),
      invert: getZeroAndEmpty(),
      gap: getSpacingWithArbitrary(),
      gradientColorStops: [colors],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: getSpacingWithAutoAndArbitrary(),
      margin: getSpacingWithAutoAndArbitrary(),
      opacity: getNumberAndArbitrary(),
      padding: getSpacingWithArbitrary(),
      saturate: getNumberAndArbitrary(),
      scale: getNumberAndArbitrary(),
      sepia: getZeroAndEmpty(),
      skew: getNumberAndArbitrary(),
      space: getSpacingWithArbitrary(),
      translate: getSpacingWithArbitrary()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": getBreaks()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": getBreaks()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...getPositions(), isArbitraryValue]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: getOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": getOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": getOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: getOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": getOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": getOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [inset]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [inset]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [inset]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [inset]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [inset]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [inset]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [inset]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [inset]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [inset]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", isInteger, isArbitraryValue]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: getSpacingWithAutoAndArbitrary()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: getZeroAndEmpty()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [gap]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [gap]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [gap]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...getAlign()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...getAlign(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...getAlign(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [padding]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [padding]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [padding]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [padding]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [padding]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [padding]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [padding]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [padding]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [padding]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [margin]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [margin]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [margin]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [margin]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [margin]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [margin]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [margin]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [margin]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [margin]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [space]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [space]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", isArbitraryValue, spacing]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [isArbitraryValue, spacing, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [isArbitraryValue, spacing, "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue, spacing, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [isArbitraryValue, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [isArbitraryValue, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [isArbitraryValue, spacing, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isLength, isArbitraryValue]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [colors]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [opacity]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [colors]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [opacity]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...getLineStyles(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength, isArbitraryLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isLength, isArbitraryValue]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [colors]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: getSpacingWithArbitrary()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [opacity]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...getPositions(), isArbitraryPosition]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [colors]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [gradientColorStops]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [borderRadius]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [borderRadius]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [borderRadius]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [borderRadius]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [borderRadius]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [borderRadius]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [borderRadius]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [borderRadius]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [borderRadius]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [borderRadius]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [borderRadius]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [borderRadius]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [borderRadius]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [borderRadius]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [borderRadius]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [borderWidth]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [borderWidth]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [borderWidth]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [borderWidth]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [borderWidth]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [borderWidth]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [borderWidth]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [borderWidth]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [borderWidth]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [opacity]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...getLineStyles(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [borderWidth]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [borderWidth]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [opacity]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: getLineStyles()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [borderColor]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [borderColor]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [borderColor]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [borderColor]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [borderColor]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [borderColor]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [borderColor]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [borderColor]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [borderColor]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [borderColor]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...getLineStyles()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isLength, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [colors]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: getLengthWithEmptyAndArbitrary()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [colors]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [opacity]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [colors]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [opacity]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...getBlendModes(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": getBlendModes()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [blur]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [brightness]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [contrast]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [grayscale]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [hueRotate]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [invert]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [saturate]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [sepia]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [blur]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [brightness]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [contrast]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [grayscale]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [hueRotate]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [invert]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [opacity]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [saturate]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [sepia]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [borderSpacing]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [borderSpacing]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [borderSpacing]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: getNumberAndArbitrary()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: getNumberAndArbitrary()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [scale]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [scale]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [scale]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [translate]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [translate]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [skew]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [skew]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", colors]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [colors]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [colors, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [colors, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
};
const twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
function cn$1(...inputs) {
  return twMerge(clsx(inputs));
}
function g(n, t2) {
  for (var e in t2) n[e] = t2[e];
  return n;
}
function E(n, t2) {
  for (var e in n) if ("__source" !== e && !(e in t2)) return true;
  for (var r2 in t2) if ("__source" !== r2 && n[r2] !== t2[r2]) return true;
  return false;
}
function N(n, t2) {
  this.props = n, this.context = t2;
}
(N.prototype = new x()).isPureReactComponent = true, N.prototype.shouldComponentUpdate = function(n, t2) {
  return E(this.props, n) || E(this.state, t2);
};
var T = l$1.__b;
l$1.__b = function(n) {
  n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), T && T(n);
};
var A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function D(n) {
  function t2(t3) {
    var e = g({}, t3);
    return delete e.ref, n(e, t3.ref || null);
  }
  return t2.$$typeof = A, t2.render = n, t2.prototype.isReactComponent = t2.__f = true, t2.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t2;
}
var L = function(n, t2) {
  return null == n ? null : H$1(H$1(n).map(t2));
}, O = { map: L, forEach: L, count: function(n) {
  return n ? H$1(n).length : 0;
}, only: function(n) {
  var t2 = H$1(n);
  if (1 !== t2.length) throw "Children.only";
  return t2[0];
}, toArray: H$1 }, F = l$1.__e;
l$1.__e = function(n, t2, e, r2) {
  if (n.then) {
    for (var u2, o = t2; o = o.__; ) if ((u2 = o.__c) && u2.__c) return null == t2.__e && (t2.__e = e.__e, t2.__k = e.__k), u2.__c(n, t2);
  }
  F(n, t2, e, r2);
};
var U = l$1.unmount;
function V(n, t2, e) {
  return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n2) {
    "function" == typeof n2.__c && n2.__c();
  }), n.__c.__H = null), null != (n = g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t2), n.__c.__e = true, n.__c = null), n.__k = n.__k && n.__k.map(function(n2) {
    return V(n2, t2, e);
  })), n;
}
function W(n, t2, e) {
  return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n2) {
    return W(n2, t2, e);
  }), n.__c && n.__c.__P === t2 && (n.__e && e.appendChild(n.__e), n.__c.__e = true, n.__c.__P = e)), n;
}
function P() {
  this.__u = 0, this.o = null, this.__b = null;
}
function j(n) {
  var t2 = n.__.__c;
  return t2 && t2.__a && t2.__a(n);
}
function B() {
  this.i = null, this.l = null;
}
l$1.unmount = function(n) {
  var t2 = n.__c;
  t2 && t2.__R && t2.__R(), t2 && 32 & n.__u && (n.type = null), U && U(n);
}, (P.prototype = new x()).__c = function(n, t2) {
  var e = t2.__c, r2 = this;
  null == r2.o && (r2.o = []), r2.o.push(e);
  var u2 = j(r2.__v), o = false, i2 = function() {
    o || (o = true, e.__R = null, u2 ? u2(l2) : l2());
  };
  e.__R = i2;
  var l2 = function() {
    if (!--r2.__u) {
      if (r2.state.__a) {
        var n2 = r2.state.__a;
        r2.__v.__k[0] = W(n2, n2.__c.__P, n2.__c.__O);
      }
      var t3;
      for (r2.setState({ __a: r2.__b = null }); t3 = r2.o.pop(); ) t3.forceUpdate();
    }
  };
  r2.__u++ || 32 & t2.__u || r2.setState({ __a: r2.__b = r2.__v.__k[0] }), n.then(i2, i2);
}, P.prototype.componentWillUnmount = function() {
  this.o = [];
}, P.prototype.render = function(n, e) {
  if (this.__b) {
    if (this.__v.__k) {
      var r2 = document.createElement("div"), o = this.__v.__k[0].__c;
      this.__v.__k[0] = V(this.__b, r2, o.__O = o.__P);
    }
    this.__b = null;
  }
  var i2 = e.__a && _(k, null, n.fallback);
  return i2 && (i2.__u &= -33), [_(k, null, e.__a ? null : n.children), i2];
};
var H = function(n, t2, e) {
  if (++e[1] === e[0] && n.l.delete(t2), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for (e = n.i; e; ) {
    for (; e.length > 3; ) e.pop()();
    if (e[1] < e[0]) break;
    n.i = e = e[2];
  }
};
(B.prototype = new x()).__a = function(n) {
  var t2 = this, e = j(t2.__v), r2 = t2.l.get(n);
  return r2[0]++, function(u2) {
    var o = function() {
      t2.props.revealOrder ? (r2.push(u2), H(t2, n, r2)) : u2();
    };
    e ? e(o) : o();
  };
}, B.prototype.render = function(n) {
  this.i = null, this.l = /* @__PURE__ */ new Map();
  var t2 = H$1(n.children);
  n.revealOrder && "b" === n.revealOrder[0] && t2.reverse();
  for (var e = t2.length; e--; ) this.l.set(t2[e], this.i = [1, 0, this.i]);
  return n.children;
}, B.prototype.componentDidUpdate = B.prototype.componentDidMount = function() {
  var n = this;
  this.l.forEach(function(t2, e) {
    H(n, e, t2);
  });
};
var q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, K = /[A-Z0-9]/g, Q = "undefined" != typeof document, X = function(n) {
  return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
x.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(t2) {
  Object.defineProperty(x.prototype, t2, { configurable: true, get: function() {
    return this["UNSAFE_" + t2];
  }, set: function(n) {
    Object.defineProperty(this, t2, { configurable: true, writable: true, value: n });
  } });
});
var en = l$1.event;
function rn() {
}
function un() {
  return this.cancelBubble;
}
function on() {
  return this.defaultPrevented;
}
l$1.event = function(n) {
  return en && (n = en(n)), n.persist = rn, n.isPropagationStopped = un, n.isDefaultPrevented = on, n.nativeEvent = n;
};
var cn = { enumerable: false, configurable: true, get: function() {
  return this.class;
} }, fn = l$1.vnode;
l$1.vnode = function(n) {
  "string" == typeof n.type && function(n2) {
    var t2 = n2.props, e = n2.type, u2 = {}, o = -1 === e.indexOf("-");
    for (var i2 in t2) {
      var l2 = t2[i2];
      if (!("value" === i2 && "defaultValue" in t2 && null == l2 || Q && "children" === i2 && "noscript" === e || "class" === i2 || "className" === i2)) {
        var c2 = i2.toLowerCase();
        "defaultValue" === i2 && "value" in t2 && null == t2.value ? i2 = "value" : "download" === i2 && true === l2 ? l2 = "" : "translate" === c2 && "no" === l2 ? l2 = false : "o" === c2[0] && "n" === c2[1] ? "ondoubleclick" === c2 ? i2 = "ondblclick" : "onchange" !== c2 || "input" !== e && "textarea" !== e || X(t2.type) ? "onfocus" === c2 ? i2 = "onfocusin" : "onblur" === c2 ? i2 = "onfocusout" : J.test(i2) && (i2 = c2) : c2 = i2 = "oninput" : o && G.test(i2) ? i2 = i2.replace(K, "-$&").toLowerCase() : null === l2 && (l2 = void 0), "oninput" === c2 && u2[i2 = c2] && (i2 = "oninputCapture"), u2[i2] = l2;
      }
    }
    "select" == e && u2.multiple && Array.isArray(u2.value) && (u2.value = H$1(t2.children).forEach(function(n3) {
      n3.props.selected = -1 != u2.value.indexOf(n3.props.value);
    })), "select" == e && null != u2.defaultValue && (u2.value = H$1(t2.children).forEach(function(n3) {
      n3.props.selected = u2.multiple ? -1 != u2.defaultValue.indexOf(n3.props.value) : u2.defaultValue == n3.props.value;
    })), t2.class && !t2.className ? (u2.class = t2.class, Object.defineProperty(u2, "className", cn)) : (t2.className && !t2.class || t2.class && t2.className) && (u2.class = u2.className = t2.className), n2.props = u2;
  }(n), n.$$typeof = q, fn && fn(n);
};
var an = l$1.__r;
l$1.__r = function(n) {
  an && an(n), n.__c;
};
var sn = l$1.diffed;
l$1.diffed = function(n) {
  sn && sn(n);
  var t2 = n.props, e = n.__e;
  null != e && "textarea" === n.type && "value" in t2 && t2.value !== e.value && (e.value = null == t2.value ? "" : t2.value);
};
function mn(n) {
  return !!n && n.$$typeof === q;
}
function _n(n) {
  return mn(n) ? K$1.apply(null, arguments) : n;
}
function setRef(ref, value) {
  if (typeof ref === "function") {
    return ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
function composeRefs(...refs) {
  return (node) => {
    let hasCleanup = false;
    const cleanups = refs.map((ref) => {
      const cleanup = setRef(ref, node);
      if (!hasCleanup && typeof cleanup == "function") {
        hasCleanup = true;
      }
      return cleanup;
    });
    if (hasCleanup) {
      return () => {
        for (let i2 = 0; i2 < cleanups.length; i2++) {
          const cleanup = cleanups[i2];
          if (typeof cleanup == "function") {
            cleanup();
          } else {
            setRef(refs[i2], null);
          }
        }
      };
    }
  };
}
// @__NO_SIDE_EFFECTS__
function createSlot(ownerName) {
  const SlotClone = /* @__PURE__ */ createSlotClone(ownerName);
  const Slot2 = D((props, forwardedRef) => {
    const { children, ...slotProps } = props;
    const childrenArray = O.toArray(children);
    const slottable = childrenArray.find(isSlottable);
    if (slottable) {
      const newElement = slottable.props.children;
      const newChildren = childrenArray.map((child) => {
        if (child === slottable) {
          if (O.count(newElement) > 1) return O.only(null);
          return mn(newElement) ? newElement.props.children : null;
        } else {
          return child;
        }
      });
      return /* @__PURE__ */ u$1(SlotClone, { ...slotProps, ref: forwardedRef, children: mn(newElement) ? _n(newElement, void 0, newChildren) : null });
    }
    return /* @__PURE__ */ u$1(SlotClone, { ...slotProps, ref: forwardedRef, children });
  });
  Slot2.displayName = `${ownerName}.Slot`;
  return Slot2;
}
var Slot = /* @__PURE__ */ createSlot("Slot");
// @__NO_SIDE_EFFECTS__
function createSlotClone(ownerName) {
  const SlotClone = D((props, forwardedRef) => {
    const { children, ...slotProps } = props;
    if (mn(children)) {
      const childrenRef = getElementRef(children);
      const props2 = mergeProps(slotProps, children.props);
      if (children.type !== k) {
        props2.ref = forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef;
      }
      return _n(children, props2);
    }
    return O.count(children) > 1 ? O.only(null) : null;
  });
  SlotClone.displayName = `${ownerName}.SlotClone`;
  return SlotClone;
}
var SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
function isSlottable(child) {
  return mn(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === SLOTTABLE_IDENTIFIER;
}
function mergeProps(slotProps, childProps) {
  const overrideProps = { ...childProps };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          const result = childPropValue(...args);
          slotPropValue(...args);
          return result;
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = { ...slotPropValue, ...childPropValue };
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return { ...slotProps, ...overrideProps };
}
function getElementRef(element) {
  var _a, _b;
  let getter = (_a = Object.getOwnPropertyDescriptor(element.props, "ref")) == null ? void 0 : _a.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_b = Object.getOwnPropertyDescriptor(element, "ref")) == null ? void 0 : _b.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
const falsyToString = (value) => typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const cx = clsx;
const cva = (base, config) => (props) => {
  var _config_compoundVariants;
  if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
  const { variants, defaultVariants } = config;
  const getVariantClassNames = Object.keys(variants).map((variant) => {
    const variantProp = props === null || props === void 0 ? void 0 : props[variant];
    const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
    if (variantProp === null) return null;
    const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
    return variants[variant][variantKey];
  });
  const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param) => {
    let [key, value] = param;
    if (value === void 0) {
      return acc;
    }
    acc[key] = value;
    return acc;
  }, {});
  const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param) => {
    let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
    return Object.entries(compoundVariantOptions).every((param2) => {
      let [key, value] = param2;
      return Array.isArray(value) ? value.includes({
        ...defaultVariants,
        ...propsWithoutUndefined
      }[key]) : {
        ...defaultVariants,
        ...propsWithoutUndefined
      }[key] === value;
    }) ? [
      ...acc,
      cvClass,
      cvClassName
    ] : acc;
  }, []);
  return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
};
var _jsxFileName$6 = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/components/ui/button.tsx";
const buttonVariants = cva("rs-inline-flex !rs-no-underline rs-items-center rs-justify-center rs-gap-2 rs-whitespace-nowrap rs-rounded-md rs-text-sm rs-font-medium rs-ring-offset-white rs-transition-colors focus-visible:rs-outline-none focus-visible:rs-ring-2 focus-visible:rs-ring-slate-950 focus-visible:rs-ring-offset-2 disabled:rs-pointer-events-none disabled:rs-opacity-50 [&_svg]:rs-pointer-events-none [&_svg]:rs-size-4 [&_svg]:rs-shrink-0", {
  variants: {
    variant: {
      default: "rs-bg-slate-900 rs-text-slate-50 hover:rs-bg-slate-900/90",
      destructive: "rs-bg-red-500 rs-text-slate-50 hover:rs-bg-red-500/90",
      outline: "rs-border rs-border-slate-200 rs-bg-white hover:rs-bg-slate-100 hover:rs-text-slate-900",
      secondary: "rs-bg-cream rs-text-black hover:rs-bg-opacity-80 ",
      ghost: "hover:rs-bg-slate-100 hover:rs-text-slate-900",
      link: "rs-text-slate-900 rs-underline-offset-4 hover:rs-underline"
    },
    size: {
      default: "rs-h-10 rs-px-4 rs-py-2",
      sm: "rs-h-9 rs-rounded-md rs-px-3",
      lg: "rs-h-11 rs-rounded-md rs-px-8",
      icon: "rs-h-10 rs-w-10",
      fullWidth: "rs-h-10 rs-w-full"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
});
const buttonStyles = ({
  variant,
  size,
  className
}) => {
  return cn$1(buttonVariants({
    variant,
    size,
    className
  }));
};
const Button = D(({
  className,
  variant,
  size,
  asChild = false,
  ...props
}, ref) => {
  const Comp = asChild ? Slot : "button";
  return u$1(Comp, {
    className: buttonStyles({
      variant,
      size,
      className
    }),
    ref,
    ...props
  }, void 0, false, {
    fileName: _jsxFileName$6,
    lineNumber: 49,
    columnNumber: 7
  }, void 0);
});
Button.displayName = "Button";
var _jsxFileName$5 = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/components/membership-table.tsx";
const whatYouGetPerks = [{
  title: "EXCLUSIVE CONTENT",
  included_in: {
    "All Access": {
      monthly: true,
      quarterly: true,
      annually: true
    },
    Media: {
      monthly: true,
      quarterly: true,
      annually: true
    },
    Support: {
      monthly: true,
      quarterly: true,
      annually: true
    }
  }
}, {
  title: "NEWSLETTERS",
  included_in: {
    "All Access": {
      monthly: true,
      quarterly: true,
      annually: true
    },
    Media: {
      monthly: true,
      quarterly: true,
      annually: true
    },
    Support: {
      monthly: true,
      quarterly: true,
      annually: true
    }
  }
}, {
  title: "READ AD-FREE",
  included_in: {
    "All Access": {
      monthly: true,
      quarterly: true,
      annually: true
    },
    Media: {
      monthly: true,
      quarterly: true,
      annually: true
    },
    Support: {
      monthly: true,
      quarterly: true,
      annually: true
    }
  }
}, {
  title: "30% OFF PRODUCTS",
  included_in: {
    "All Access": {
      monthly: true,
      quarterly: true,
      annually: true
    },
    Media: {
      monthly: false,
      quarterly: false,
      annually: false
    },
    Support: {
      monthly: true,
      quarterly: true,
      annually: true
    }
  }
}, {
  title: "PERKS FROM OUR PARTNERS",
  included_in: {
    "All Access": {
      monthly: true,
      quarterly: true,
      annually: true
    },
    Media: {
      monthly: false,
      quarterly: false,
      annually: false
    },
    Support: {
      monthly: true,
      quarterly: true,
      annually: true
    }
  }
}, {
  title: "SPONSOR GENDER AFFIRMING PRODUCT DONATIONS",
  included_in: {
    "All Access": {
      monthly: false,
      quarterly: false,
      annually: false
    },
    Media: {
      monthly: false,
      quarterly: false,
      annually: false
    },
    Support: {
      monthly: false,
      quarterly: false,
      annually: true
    }
  }
}];
const printMagazinePerks = [{
  title: "PRINT ZINE DELIVERED",
  included_in: {
    "All Access": {
      monthly: false,
      quarterly: true,
      annually: true
    },
    Media: {
      monthly: false,
      quarterly: false,
      annually: false
    },
    Support: {
      monthly: false,
      quarterly: true,
      annually: true
    }
  }
}];
const freeGiftsPerks = [{
  title: "STICKERS",
  included_in: {
    "All Access": {
      monthly: false,
      quarterly: false,
      annually: true
    },
    Media: {
      monthly: false,
      quarterly: false,
      annually: true
    },
    Support: {
      monthly: false,
      quarterly: false,
      annually: true
    }
  }
}, {
  title: "GIFT BOX (WORTH $100+)",
  included_in: {
    "All Access": {
      monthly: false,
      quarterly: false,
      annually: false
    },
    Media: {
      monthly: false,
      quarterly: false,
      annually: false
    },
    Support: {
      monthly: false,
      quarterly: false,
      annually: true
    }
  }
}];
function MembershipSelection({
  showMediaColumn = true,
  title = "Compare Plans",
  description = ""
}) {
  var _a, _b, _c;
  const [billingCycle, setBillingCycle] = t$1(d$1("QUARTERLY"), "billingCycle");
  const [selectedTier, setSelectedTier] = t$1(d$1("All Access"), "selectedTier");
  const getCartItems = () => {
    let productVariantID = null;
    let sellingPlanID = null;
    if (selectedTier === "All Access") {
      productVariantID = 44792925257894;
      if (billingCycle === "MONTHLY") {
        sellingPlanID = 1574961318;
      } else if (billingCycle === "QUARTERLY") {
        sellingPlanID = 1580236966;
      } else if (billingCycle === "ANNUALLY") {
        sellingPlanID = 1574994086;
      }
    } else if (selectedTier === "Support") {
      productVariantID = 46214081347750;
      if (billingCycle === "MONTHLY") {
        sellingPlanID = 2021261478;
      } else if (billingCycle === "QUARTERLY") {
        sellingPlanID = 2080374950;
      } else if (billingCycle === "ANNUALLY") {
        sellingPlanID = 2021294246;
      }
    } else if (selectedTier === "Media") {
      productVariantID = 44792925585574;
      if (billingCycle === "MONTHLY") {
        sellingPlanID = 1575026854;
      } else if (billingCycle === "QUARTERLY") {
        sellingPlanID = 1580204198;
      } else if (billingCycle === "ANNUALLY") {
        sellingPlanID = 1575059622;
      }
    }
    if (productVariantID && sellingPlanID) {
      return {
        id: productVariantID,
        quantity: 1,
        selling_plan: sellingPlanID
      };
    } else {
      return null;
    }
  };
  const [pricingData, setPricingData] = t$1(d$1({
    Media: {
      monthly: 0,
      // Product variant ID for Media Monthly
      quarterly: 0,
      // Product variant ID for Media Quarterly
      annually: 0
      // Product variant ID for Media Annually
    },
    "All Access": {
      monthly: 0,
      // Product variant ID for All Access Monthly
      quarterly: 0,
      // Product variant ID for All Access Quarterly
      annually: 0
      // Product variant ID for All Access Annually
    },
    Support: {
      monthly: 0,
      // Product variant ID for Support Monthly
      quarterly: 0,
      // Product variant ID for Support Quarterly
      annually: 0
      // Product variant ID for Support Annually
    }
  }), "pricingData");
  const productVariantMap = {
    Media: 44792925585574,
    "All Access": 44792925257894,
    Support: 46214081347750
  };
  const fetchPricingData = async () => {
    Object.values(pricingData).map((option) => option.monthly);
    const query = `
      query {
        nodes(ids: ["gid://shopify/ProductVariant/44792925257894", "gid://shopify/ProductVariant/44792925585574", "gid://shopify/ProductVariant/46214081347750"]) {
          ... on ProductVariant {
            id
            price {
              amount
            }
            sellingPlanAllocations(first: 3) {
              edges {
                node {
                  sellingPlan {
                    id
                    name
                  }
                  checkoutChargeAmount {
                    amount
                  }
                }
              }
            }
          }
        }
      }
    `;
    try {
      const response = await fetch("https://for-them-store.myshopify.com/api/2025-04/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "8325b00bc1524b6c8863c616e9226760"
        },
        body: JSON.stringify({
          query
        })
      });
      const data = await response.json();
      const nodes = data.data.nodes;
      const updatedPricingData = {
        Media: {
          monthly: 0,
          quarterly: 0,
          annually: 0
        },
        "All Access": {
          monthly: 0,
          quarterly: 0,
          annually: 0
        },
        Support: {
          monthly: 0,
          quarterly: 0,
          annually: 0
        }
      };
      nodes.forEach((node) => {
        const variantId = node.id;
        const sellingPlans = node.sellingPlanAllocations.edges;
        sellingPlans.forEach((plan) => {
          const planName = plan.node.sellingPlan.name;
          const chargeAmount = plan.node.checkoutChargeAmount.amount;
          Object.keys(productVariantMap).forEach((mappedVariantId) => {
            if (
              // @ts-ignore
              productVariantMap[mappedVariantId] === parseInt(variantId.split("/").pop())
            ) {
              updatedPricingData[mappedVariantId][planName.toLowerCase()] = parseInt(chargeAmount).toFixed(0);
            }
          });
        });
      });
      setPricingData(updatedPricingData);
    } catch (error) {
      console.error("Error fetching pricing data:", error);
    }
  };
  y$1(() => {
    fetchPricingData();
  }, []);
  const getChargeText = (cycle) => {
    switch (cycle) {
      case "MONTHLY":
        return "Charged Monthly";
      case "QUARTERLY":
        return "Charged Quarterly";
      case "ANNUALLY":
        return "Charged Annually";
      default:
        return "/ Month";
    }
  };
  const getTierImage = (cycle) => {
    switch (cycle) {
      case "MONTHLY":
        return {
          media: "https://autostraddle.forthem.com/images/media-monthly.png",
          "all access": "https://autostraddle.forthem.com/images/all-access-monthly.png",
          support: "https://autostraddle.forthem.com/images/support-monthly.png"
        };
      case "QUARTERLY":
        return {
          media: "https://autostraddle.forthem.com/images/media-monthly.png",
          "all access": "https://autostraddle.forthem.com/images/all-access-quarterly.png",
          support: "https://autostraddle.forthem.com/images/support-quarterly.png"
        };
      case "ANNUALLY":
        return {
          media: "https://autostraddle.forthem.com/images/media-monthly.png",
          "all access": "https://autostraddle.forthem.com/images/all-access-annually.png",
          support: "https://autostraddle.forthem.com/images/support-annually.png"
        };
      default:
        return {
          media: "https://autostraddle.forthem.com/images/media-monthly.png",
          "all access": "https://autostraddle.forthem.com/images/all-access-monthly.png",
          support: "https://autostraddle.forthem.com/images/support-monthly.png"
        };
    }
  };
  const shouldShowPills = () => {
    return billingCycle === "QUARTERLY" || billingCycle === "ANNUALLY";
  };
  const handleContinue = async () => {
    const cartItem = getCartItems();
    if (cartItem) {
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            items: [cartItem]
          })
        });
        if (response.ok) {
          document.dispatchEvent(new CustomEvent("theme:cart:refresh", {
            bubbles: true
          }));
          document.dispatchEvent(new CustomEvent("theme:product:added", {
            bubbles: true
          }));
        } else {
          console.error("Failed to add item to cart");
          const errorData = await response.json();
          console.error("Cart error:", errorData);
        }
      } catch (error) {
        console.error("Error adding item to cart:", error);
      }
    }
  };
  const visibleTiers = showMediaColumn ? ["Media", "All Access", "Support"] : ["All Access", "Support"];
  const getMonthsForCycle = (cycle) => {
    switch (cycle) {
      case "MONTHLY":
        return 1;
      case "QUARTERLY":
        return 3;
      case "ANNUALLY":
        return 12;
      default:
        return 1;
    }
  };
  const getSavingsPercent = (tier, cycle) => {
    if (cycle === "MONTHLY") return 0;
    const monthlyPrice = Number(pricingData[tier]["monthly"]);
    const cyclePrice = Number(pricingData[tier][cycle.toLowerCase()]);
    const months = getMonthsForCycle(cycle);
    if (!monthlyPrice || !cyclePrice) return 0;
    const effectiveMonthly = cyclePrice / months;
    const savings = effectiveMonthly / monthlyPrice * 100;
    return Math.floor(100 - savings);
  };
  return u$1("div", {
    class: "rs-container rs-mx-auto membership-table",
    children: u$1("div", {
      className: "rs-w-full rs-font-primary",
      children: [u$1("div", {
        className: "rs-relative rs-mb-10",
        children: u$1("div", {
          className: "rs-flex rs-justify-center rs-items-center",
          children: u$1("div", {
            className: "rs-grid rs-grid-cols-3 rs-gap-2 rs-border rs-border-[#808080] rs-rounded-full rs-p-2.5 rs-relative rs-max-w-md rs-w-full dark:rs-border-slate-800",
            children: [u$1("button", {
              onClick: () => setBillingCycle("MONTHLY"),
              className: cn$1("rs-py-[11px] rs-px-[15px] md:rs-py-[15px] md:rs-px-[17px] rs-rounded-full rs-text-center rs-text-[11px] md:rs-text-[13px] rs-font-tertiary rs-border rs-border-[#808080] dark:rs-border-slate-800 rs-font-bold", billingCycle === "MONTHLY" ? "rs-bg-black rs-text-white" : "rs-bg-transparent rs-text-black"),
              children: "MONTHLY"
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 423,
              columnNumber: 13
            }, this), u$1("button", {
              onClick: () => setBillingCycle("QUARTERLY"),
              className: cn$1("rs-py-[11px] rs-px-[15px] md:rs-py-[15px] md:rs-px-[17px] rs-rounded-full rs-text-center rs-text-[11px] md:rs-text-[13px] rs-font-tertiary rs-border rs-border-[#808080] dark:rs-border-slate-800 rs-font-bold", billingCycle === "QUARTERLY" ? "rs-bg-black rs-text-white" : "rs-bg-transparent rs-text-black"),
              children: "QUARTERLY"
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 434,
              columnNumber: 13
            }, this), u$1("button", {
              onClick: () => setBillingCycle("ANNUALLY"),
              className: cn$1("rs-py-[11px] rs-px-[15px] md:rs-py-[15px] md:rs-px-[17px] rs-rounded-full rs-text-center rs-text-[11px] md:rs-text-[13px] rs-border rs-font-tertiary rs-border-[#808080] dark:rs-border-slate-800 rs-font-bold", billingCycle === "ANNUALLY" ? "rs-bg-black rs-text-white" : "rs-bg-transparent rs-text-black"),
              children: "ANNUALLY"
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 445,
              columnNumber: 13
            }, this), u$1("div", {
              className: "rs-absolute rs-right-0 -rs-top-4 rs-rounded-full rs-p-1 rs-text-[10px] rs-font-quaternary",
              children: u$1("div", {
                className: "rs-relative",
                children: [u$1("svg", {
                  width: "43",
                  height: "44",
                  viewBox: "0 43 44",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: u$1("path", {
                    d: "M26.9629 5.30469L27.0869 5.41797L27.2539 5.39941L34.335 4.60645L35.7705 11.5869L35.8047 11.752L35.9502 11.835L42.1455 15.3564L39.2041 21.8467L39.1348 22L39.2041 22.1533L42.1455 28.6426L35.9502 32.165L35.8047 32.248L35.7705 32.4131L34.335 39.3926L27.2539 38.6006L27.0869 38.582L26.9629 38.6953L21.6992 43.498L16.4355 38.6953L16.3115 38.582L16.1445 38.6006L9.0625 39.3926L7.62793 32.4131L7.59375 32.248L7.44824 32.165L1.25195 28.6426L4.19434 22.1533L4.26367 22L4.19434 21.8467L1.25195 15.3564L7.44824 11.835L7.59375 11.752L7.62793 11.5869L9.0625 4.60645L16.1445 5.39941L16.3115 5.41797L16.4355 5.30469L21.6992 0.500977L26.9629 5.30469Z",
                    fill: "#CEC6BA",
                    stroke: "#CEC6BA",
                    strokeWidth: "0.740816"
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 465,
                    columnNumber: 19
                  }, this)
                }, void 0, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 458,
                  columnNumber: 17
                }, this), u$1("div", {
                  className: "rs-absolute rs-text-center rs-top-0 rs-left-0 rs-w-full rs-h-full rs-flex rs-items-center rs-justify-center",
                  children: ["FREE", u$1("br", {}, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 474,
                    columnNumber: 19
                  }, this), "GIFTS"]
                }, void 0, true, {
                  fileName: _jsxFileName$5,
                  lineNumber: 472,
                  columnNumber: 17
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName$5,
                lineNumber: 457,
                columnNumber: 15
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 456,
              columnNumber: 13
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$5,
            lineNumber: 422,
            columnNumber: 11
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$5,
          lineNumber: 421,
          columnNumber: 9
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$5,
        lineNumber: 420,
        columnNumber: 7
      }, this), u$1("div", {
        className: "rs-mx-auto",
        children: [u$1("table", {
          className: "rs-w-full rs-border-collapse",
          children: [u$1("colgroup", {
            children: [u$1("col", {
              className: cn$1("rs-w-full", showMediaColumn ? "lg:rs-w-1/4" : "lg:rs-w-1/3")
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 487,
              columnNumber: 13
            }, this), u$1("col", {
              className: cn$1("rs-w-full", showMediaColumn ? "lg:rs-w-3/4" : "lg:rs-w-2/3")
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 493,
              columnNumber: 13
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$5,
            lineNumber: 486,
            columnNumber: 11
          }, this), u$1("tr", {
            className: "rs-flex lg:rs-table-row rs-w-full rs-justify-center",
            children: [u$1("td", {
              className: "rs-align-bottom rs-hidden lg:rs-table-cell",
              children: u$1("div", {
                className: "rs-h-full lg:rs-border-b rs-border-[#808080]",
                children: " "
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 502,
                columnNumber: 15
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 501,
              columnNumber: 13
            }, this), u$1("td", {
              className: "rs-w-full lg:rs-w-auto",
              children: u$1("div", {
                className: cn$1("rs-grid rs-w-full rs-gap-2.5 lg:rs-gap-0 rs-items-end", showMediaColumn ? "rs-grid-cols-3" : "rs-grid-cols-2"),
                children: u$1(k, {
                  children: [showMediaColumn && u$1("button", {
                    onClick: () => setSelectedTier("Media"),
                    className: cn$1("rs-border rs-border-[#808080] lg:rs-p-4 rs-p-2 rs-cursor-pointer rs-transition-colors lg:rs-min-h-[110px] md:rs-max-w-none rs-gap-3 rs-flex rs-flex-col rs-justify-center rs-items-center lg:rs-block rs-text-center lg:rs-text-left", selectedTier === "Media" ? "rs-bg-[#BABA00]" : "rs-bg-stone-tint"),
                    children: [u$1("div", {
                      className: "lg:rs-flex rs-items-baseline rs-w-full rs-justify-between",
                      children: [u$1("div", {
                        className: "rs-text-lg lg:rs-text-[32px] rs-tracking-tight md:rs-tracking-tighter rs-whitespace-nowrap",
                        children: "Media"
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 523,
                        columnNumber: 25
                      }, this), u$1("div", {
                        className: "rs-mt-auto rs-hidden lg:rs-flex rs-items-center rs-justify-center rs-h-6",
                        children: selectedTier === "Media" ? u$1("div", {
                          className: "rs-min-h-4 rs-min-w-4 lg:rs-size-[22px] rs-rounded-full rs-bg-black rs-flex rs-items-center rs-justify-center",
                          children: u$1(Check, {
                            className: "rs-size-2 lg:rs-size-4 rs-text-white"
                          }, void 0, false, {
                            fileName: _jsxFileName$5,
                            lineNumber: 529,
                            columnNumber: 31
                          }, this)
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 528,
                          columnNumber: 29
                        }, this) : u$1("div", {
                          className: "rs-min-h-4 rs-min-w-4 lg:rs-size-[22px] rs-rounded-full rs-border first-line:rs-border-[#808080] dark:rs-border-slate-800"
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 532,
                          columnNumber: 29
                        }, this)
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 526,
                        columnNumber: 25
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$5,
                      lineNumber: 522,
                      columnNumber: 23
                    }, this), u$1("div", {
                      className: "rs-flex rs-flex-col rs-items-baseline lg:rs-mt-4 lg:rs-gap-3 rs-justify-between",
                      children: [u$1("span", {
                        className: "lg:rs-text-lg rs-text-xs !rs-leading-none",
                        children: [billingCycle !== "MONTHLY" && Number(pricingData["Media"]["monthly"]).toFixed(0) !== (Number(pricingData["Media"][billingCycle.toLowerCase()]) / getMonthsForCycle(billingCycle)).toFixed(0) && u$1("span", {
                          className: "rs-line-through rs-opacity-20 rs-mr-2.5",
                          children: ["$", Number(pricingData["Media"]["monthly"]).toFixed(0)]
                        }, void 0, true, {
                          fileName: _jsxFileName$5,
                          lineNumber: 549,
                          columnNumber: 31
                        }, this), "$", (Number(pricingData["Media"][billingCycle.toLowerCase()]) / getMonthsForCycle(billingCycle)).toFixed(0), " ", u$1("span", {
                          className: "rs-hidden lg:rs-inline-block",
                          children: ["/ month", " "]
                        }, void 0, true, {
                          fileName: _jsxFileName$5,
                          lineNumber: 565,
                          columnNumber: 27
                        }, this), u$1("div", {
                          className: "lg:rs-hidden rs-text-xs",
                          children: "per month "
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 568,
                          columnNumber: 27
                        }, this)]
                      }, void 0, true, {
                        fileName: _jsxFileName$5,
                        lineNumber: 537,
                        columnNumber: 25
                      }, this), u$1("p", {
                        className: "rs-uppercase rs-hidden lg:rs-block rs-font-tertiary rs-text-xs rs-tracking-widest",
                        children: getChargeText(billingCycle)
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 570,
                        columnNumber: 25
                      }, this), shouldShowPills() && u$1("div", {
                        className: "rs-flex lg:rs-flex-row lg:rs-mt-0 rs-flex-col rs-flex-wrap rs-items-center rs-gap-1.5 rs-justify-center lg:rs-justify-end max-md:rs-min-h-10",
                        children: u$1(k, {
                          children: getSavingsPercent("Media", billingCycle) > 0 ? u$1("div", {
                            className: "rs-border rs-border-[#808080] rs-text-center rs-rounded-full rs-text-xs rs-py-[2px] lg:rs-py-1 rs-px-[5px] rs-font-tertiary rs-tracking-widest rs-leading-none rs-h-[17px] lg:rs-h-auto",
                            children: ["SAVE", " ", getSavingsPercent("Media", billingCycle), "%"]
                          }, void 0, true, {
                            fileName: _jsxFileName$5,
                            lineNumber: 577,
                            columnNumber: 33
                          }, this) : u$1("div", {
                            className: "rs-h-[17px]"
                          }, void 0, false, {
                            fileName: _jsxFileName$5,
                            lineNumber: 582,
                            columnNumber: 33
                          }, this)
                        }, void 0, false)
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 574,
                        columnNumber: 27
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$5,
                      lineNumber: 536,
                      columnNumber: 23
                    }, this), u$1("div", {
                      className: "rs-mt-auto lg:rs-hidden rs-px-6 rs-rounded-full rs-text-center rs-items-center rs-justify-center",
                      children: selectedTier === "Media" ? u$1("div", {
                        className: "rs-min-h-4 rs-min-w-4 lg:rs-size-[22px] rs-rounded-full rs-bg-black rs-flex rs-items-center rs-justify-center",
                        children: u$1(Check, {
                          className: "rs-size-2 lg:rs-size-4 rs-text-white"
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 593,
                          columnNumber: 29
                        }, this)
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 592,
                        columnNumber: 27
                      }, this) : u$1("div", {
                        className: "rs-min-h-4 rs-min-w-4 lg:rs-size-[22px] rs-rounded-full rs-border first-line:rs-border-[#808080] dark:rs-border-slate-800"
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 596,
                        columnNumber: 27
                      }, this)
                    }, void 0, false, {
                      fileName: _jsxFileName$5,
                      lineNumber: 590,
                      columnNumber: 23
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName$5,
                    lineNumber: 513,
                    columnNumber: 21
                  }, this), u$1("div", {
                    children: [u$1("div", {
                      children: u$1("div", {
                        className: "rs-bg-black rs-text-white rs-text-[10px] rs-py-1 md:rs-px-4 rs-font-tertiary rs-tracking-[.1em] rs-text-center",
                        children: "MOST POPULAR"
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 604,
                        columnNumber: 23
                      }, this)
                    }, void 0, false, {
                      fileName: _jsxFileName$5,
                      lineNumber: 603,
                      columnNumber: 21
                    }, this), u$1("button", {
                      onClick: () => setSelectedTier("All Access"),
                      className: cn$1("rs-border rs-border-[#808080] lg:rs-p-4 rs-p-2 rs-cursor-pointer rs-transition-colors rs-relative lg:rs-min-h-[110px] rs-w-full rs-flex rs-gap-3 rs-flex-col rs-justify-center rs-items-center lg:rs-block rs-text-center lg:rs-text-left", selectedTier === "All Access" ? "rs-bg-[#BABA00]" : "rs-bg-stone-tint"),
                      children: [u$1("div", {
                        className: "lg:rs-flex rs-items-baseline rs-w-full rs-justify-between",
                        children: [u$1("div", {
                          className: "rs-text-lg lg:rs-text-[32px] rs-tracking-tight md:rs-tracking-tighter rs-whitespace-nowrap",
                          children: "All Access"
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 618,
                          columnNumber: 25
                        }, this), u$1("div", {
                          className: "rs-mt-auto rs-hidden lg:rs-flex rs-items-center rs-justify-center rs-h-6",
                          children: selectedTier === "All Access" ? u$1("div", {
                            className: "rs-min-h-4 rs-min-w-4 lg:rs-size-[22px] rs-rounded-full rs-bg-black rs-flex rs-items-center rs-justify-center",
                            children: u$1(Check, {
                              className: "rs-size-2 lg:rs-size-4 rs-text-white"
                            }, void 0, false, {
                              fileName: _jsxFileName$5,
                              lineNumber: 624,
                              columnNumber: 31
                            }, this)
                          }, void 0, false, {
                            fileName: _jsxFileName$5,
                            lineNumber: 623,
                            columnNumber: 29
                          }, this) : u$1("div", {
                            className: "rs-min-h-4 rs-min-w-4 lg:rs-size-[22px] rs-rounded-full rs-border first-line:rs-border-[#808080] dark:rs-border-slate-800"
                          }, void 0, false, {
                            fileName: _jsxFileName$5,
                            lineNumber: 627,
                            columnNumber: 29
                          }, this)
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 621,
                          columnNumber: 25
                        }, this)]
                      }, void 0, true, {
                        fileName: _jsxFileName$5,
                        lineNumber: 617,
                        columnNumber: 23
                      }, this), u$1("div", {
                        className: "rs-flex rs-flex-col rs-items-baseline lg:rs-mt-4 lg:rs-gap-3 rs-justify-between",
                        children: [u$1("span", {
                          className: "lg:rs-text-lg rs-text-xs !rs-leading-none",
                          children: [billingCycle !== "MONTHLY" && Number(pricingData["All Access"]["monthly"]).toFixed(0) !== (Number(pricingData["All Access"][billingCycle.toLowerCase()]) / getMonthsForCycle(billingCycle)).toFixed(0) && u$1("span", {
                            className: "rs-line-through rs-opacity-20 rs-mr-2.5",
                            children: ["$", Number(pricingData["All Access"]["monthly"]).toFixed(0)]
                          }, void 0, true, {
                            fileName: _jsxFileName$5,
                            lineNumber: 644,
                            columnNumber: 31
                          }, this), "$", (Number(pricingData["All Access"][billingCycle.toLowerCase()]) / getMonthsForCycle(billingCycle)).toFixed(0), " ", u$1("span", {
                            className: "rs-hidden lg:rs-inline-block",
                            children: ["/ month", " "]
                          }, void 0, true, {
                            fileName: _jsxFileName$5,
                            lineNumber: 660,
                            columnNumber: 27
                          }, this), u$1("div", {
                            className: "lg:rs-hidden rs-text-xs",
                            children: "per month "
                          }, void 0, false, {
                            fileName: _jsxFileName$5,
                            lineNumber: 663,
                            columnNumber: 27
                          }, this)]
                        }, void 0, true, {
                          fileName: _jsxFileName$5,
                          lineNumber: 632,
                          columnNumber: 25
                        }, this), u$1("p", {
                          className: "rs-uppercase rs-hidden lg:rs-block rs-font-tertiary rs-text-xs rs-tracking-widest",
                          children: getChargeText(billingCycle)
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 665,
                          columnNumber: 25
                        }, this), shouldShowPills() && u$1("div", {
                          className: "rs-flex lg:rs-flex-row lg:rs-mt-0 rs-flex-col rs-flex-wrap rs-items-center rs-gap-1.5 rs-justify-center lg:rs-justify-end max-md:rs-min-h-10",
                          children: u$1(k, {
                            children: [u$1("div", {
                              className: "rs-border rs-border-[#808080] rs-text-center rs-rounded-full rs-text-xs rs-py-[2px] lg:rs-py-1 rs-px-[5px] rs-font-tertiary rs-tracking-widest rs-leading-none rs-h-[17px] lg:rs-h-auto",
                              children: "FREE ZINE"
                            }, void 0, false, {
                              fileName: _jsxFileName$5,
                              lineNumber: 671,
                              columnNumber: 31
                            }, this), getSavingsPercent("All Access", billingCycle) > 0 && u$1("div", {
                              className: "rs-border rs-border-[#808080] rs-text-center rs-rounded-full rs-text-xs rs-py-[2px] lg:rs-py-1 rs-px-[5px] rs-font-tertiary rs-tracking-widest rs-leading-none rs-h-[17px] lg:rs-h-auto",
                              children: ["SAVE", " ", getSavingsPercent("All Access", billingCycle), "%"]
                            }, void 0, true, {
                              fileName: _jsxFileName$5,
                              lineNumber: 676,
                              columnNumber: 33
                            }, this)]
                          }, void 0, true)
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 669,
                          columnNumber: 27
                        }, this)]
                      }, void 0, true, {
                        fileName: _jsxFileName$5,
                        lineNumber: 631,
                        columnNumber: 23
                      }, this), u$1("div", {
                        className: "lg:rs-hidden rs-px-6 rs-rounded-full rs-text-center rs-items-center rs-justify-center",
                        children: selectedTier === "All Access" ? u$1("div", {
                          className: "rs-min-h-4 rs-min-w-4 lg:rs-size-[22px] rs-rounded-full rs-bg-black rs-flex rs-items-center rs-justify-center",
                          children: u$1(Check, {
                            className: "rs-size-2 lg:rs-size-4 rs-text-white"
                          }, void 0, false, {
                            fileName: _jsxFileName$5,
                            lineNumber: 692,
                            columnNumber: 29
                          }, this)
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 691,
                          columnNumber: 27
                        }, this) : u$1("div", {
                          className: "rs-min-h-4 rs-min-w-4 lg:rs-size-[22px] rs-rounded-full rs-border first-line:rs-border-[#808080] dark:rs-border-slate-800"
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 695,
                          columnNumber: 27
                        }, this)
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 689,
                        columnNumber: 23
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$5,
                      lineNumber: 608,
                      columnNumber: 21
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName$5,
                    lineNumber: 602,
                    columnNumber: 19
                  }, this), u$1("button", {
                    onClick: () => setSelectedTier("Support"),
                    className: cn$1("rs-border rs-border-[#808080] lg:rs-p-4 rs-p-2 rs-cursor-pointer rs-transition-colors lg:rs-min-h-[110px] md:rs-max-w-none rs-gap-3 rs-flex rs-flex-col rs-justify-center rs-items-center lg:rs-block rs-text-center lg:rs-text-left", selectedTier === "Support" ? "rs-bg-[#BABA00]" : "rs-bg-stone-tint"),
                    children: [u$1("div", {
                      className: "lg:rs-flex rs-items-baseline rs-w-full rs-justify-between",
                      children: [u$1("div", {
                        className: "rs-text-lg lg:rs-text-[32px] rs-tracking-tight md:rs-tracking-tighter rs-whitespace-nowrap",
                        children: "Support"
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 711,
                        columnNumber: 23
                      }, this), u$1("div", {
                        className: "rs-mt-auto rs-hidden lg:rs-flex rs-items-center rs-justify-center rs-h-6",
                        children: selectedTier === "Support" ? u$1("div", {
                          className: "rs-min-h-4 rs-min-w-4 lg:rs-size-[22px] rs-rounded-full rs-bg-black rs-flex rs-items-center rs-justify-center",
                          children: u$1(Check, {
                            className: "rs-size-2 lg:rs-size-4 rs-text-white"
                          }, void 0, false, {
                            fileName: _jsxFileName$5,
                            lineNumber: 717,
                            columnNumber: 29
                          }, this)
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 716,
                          columnNumber: 27
                        }, this) : u$1("div", {
                          className: "rs-min-h-4 rs-min-w-4 lg:rs-size-[22px] rs-rounded-full rs-border first-line:rs-border-[#808080] dark:rs-border-slate-800"
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 720,
                          columnNumber: 27
                        }, this)
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 714,
                        columnNumber: 23
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$5,
                      lineNumber: 710,
                      columnNumber: 21
                    }, this), u$1("div", {
                      className: "rs-flex rs-flex-col rs-items-baseline lg:rs-mt-4 lg:rs-gap-3 rs-justify-between",
                      children: [u$1("span", {
                        className: "lg:rs-text-lg rs-text-xs !rs-leading-none",
                        children: [billingCycle !== "MONTHLY" && Number(pricingData["Support"]["monthly"]).toFixed(0) !== (Number(pricingData["Support"][billingCycle.toLowerCase()]) / getMonthsForCycle(billingCycle)).toFixed(0) && u$1("span", {
                          className: "rs-line-through rs-opacity-20 rs-mr-2.5",
                          children: ["$", Number(pricingData["Support"]["monthly"]).toFixed(0)]
                        }, void 0, true, {
                          fileName: _jsxFileName$5,
                          lineNumber: 737,
                          columnNumber: 29
                        }, this), "$", (Number(pricingData["Support"][billingCycle.toLowerCase()]) / getMonthsForCycle(billingCycle)).toFixed(0), " ", u$1("span", {
                          className: "rs-hidden lg:rs-inline-block",
                          children: "/ month "
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 753,
                          columnNumber: 25
                        }, this), u$1("div", {
                          className: "lg:rs-hidden rs-text-xs",
                          children: "per month "
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 754,
                          columnNumber: 25
                        }, this)]
                      }, void 0, true, {
                        fileName: _jsxFileName$5,
                        lineNumber: 725,
                        columnNumber: 23
                      }, this), u$1("p", {
                        className: "rs-uppercase rs-hidden lg:rs-block rs-font-tertiary rs-text-xs rs-tracking-widest",
                        children: getChargeText(billingCycle)
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 756,
                        columnNumber: 23
                      }, this), shouldShowPills() && u$1("div", {
                        className: "rs-flex lg:rs-flex-row lg:rs-mt-0 rs-flex-col rs-flex-wrap rs-items-center rs-gap-1.5 rs-justify-center lg:rs-justify-end max-md:rs-min-h-10",
                        children: u$1(k, {
                          children: [u$1("div", {
                            className: "rs-border rs-border-[#808080] rs-text-center rs-rounded-full rs-text-xs rs-py-[2px] lg:rs-py-1 rs-px-[5px] rs-font-tertiary rs-tracking-widest rs-leading-none rs-h-[17px] lg:rs-h-auto",
                            children: "FREE ZINE"
                          }, void 0, false, {
                            fileName: _jsxFileName$5,
                            lineNumber: 762,
                            columnNumber: 29
                          }, this), getSavingsPercent("Support", billingCycle) > 0 && u$1("div", {
                            className: "rs-border rs-border-[#808080] rs-text-center rs-rounded-full rs-text-xs rs-py-[2px] lg:rs-py-1 rs-px-[5px] rs-font-tertiary rs-tracking-widest rs-leading-none rs-h-[17px] lg:rs-h-auto",
                            children: ["SAVE", " ", getSavingsPercent("Support", billingCycle), "%"]
                          }, void 0, true, {
                            fileName: _jsxFileName$5,
                            lineNumber: 766,
                            columnNumber: 31
                          }, this)]
                        }, void 0, true)
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 760,
                        columnNumber: 25
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$5,
                      lineNumber: 724,
                      columnNumber: 21
                    }, this), u$1("div", {
                      className: "lg:rs-hidden rs-px-6 rs-rounded-full rs-text-center rs-items-center rs-justify-center",
                      children: selectedTier === "Support" ? u$1("div", {
                        className: "rs-min-h-4 rs-min-w-4 lg:rs-size-[22px] rs-rounded-full rs-bg-black rs-flex rs-items-center rs-justify-center",
                        children: u$1(Check, {
                          className: "rs-size-2 lg:rs-size-4 rs-text-white"
                        }, void 0, false, {
                          fileName: _jsxFileName$5,
                          lineNumber: 778,
                          columnNumber: 27
                        }, this)
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 777,
                        columnNumber: 25
                      }, this) : u$1("div", {
                        className: "rs-min-h-4 rs-min-w-4 lg:rs-size-[22px] rs-rounded-full rs-border first-line:rs-border-[#808080] dark:rs-border-slate-800"
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 781,
                        columnNumber: 25
                      }, this)
                    }, void 0, false, {
                      fileName: _jsxFileName$5,
                      lineNumber: 775,
                      columnNumber: 21
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName$5,
                    lineNumber: 701,
                    columnNumber: 19
                  }, this)]
                }, void 0, true)
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 505,
                columnNumber: 15
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 504,
              columnNumber: 13
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$5,
            lineNumber: 500,
            columnNumber: 11
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$5,
          lineNumber: 485,
          columnNumber: 9
        }, this), u$1("table", {
          className: "rs-w-full",
          children: [u$1("colgroup", {
            children: [u$1("col", {
              className: "rs-w-full lg:rs-w-1/4"
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 792,
              columnNumber: 13
            }, this), u$1("col", {
              className: "rs-w-full lg:rs-w-3/4"
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 793,
              columnNumber: 13
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$5,
            lineNumber: 791,
            columnNumber: 11
          }, this), u$1("tr", {
            children: [u$1("td", {}, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 796,
              columnNumber: 13
            }, this), u$1("td", {
              children: u$1("div", {
                className: "rs-justify-center rs-my-8 rs-hidden lg:rs-flex rs-w-full",
                children: u$1("div", {
                  className: "rs-max-w-[300px] rs-w-full",
                  children: u$1(Button, {
                    size: "fullWidth",
                    onClick: handleContinue,
                    className: "rs-text-sm",
                    children: "CONTINUE"
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 800,
                    columnNumber: 19
                  }, this)
                }, void 0, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 799,
                  columnNumber: 17
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 798,
                columnNumber: 15
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 797,
              columnNumber: 13
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$5,
            lineNumber: 795,
            columnNumber: 11
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$5,
          lineNumber: 790,
          columnNumber: 9
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$5,
        lineNumber: 484,
        columnNumber: 7
      }, this), u$1("div", {
        className: cn$1("rs-grid rs-justify-center rs-items-center rs-gap-4 rs-mb-8 lg:rs-hidden rs-mt-5", showMediaColumn ? "rs-grid-cols-3" : "rs-grid-cols-2"),
        children: [showMediaColumn && u$1("div", {
          className: "rs-text-center rs-flex rs-items-center rs-justify-center",
          children: u$1("img", {
            src: (_a = getTierImage(billingCycle)) == null ? void 0 : _a["media"],
            alt: `Products for ${billingCycle} media plan`,
            className: "rs-h-12"
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 823,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$5,
          lineNumber: 822,
          columnNumber: 11
        }, this), u$1("div", {
          className: "rs-text-center rs-flex rs-items-center rs-justify-center",
          children: u$1("img", {
            src: (_b = getTierImage(billingCycle)) == null ? void 0 : _b["all access"],
            alt: `Products for ${billingCycle} all access plan`,
            className: "rs-h-12"
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 831,
            columnNumber: 11
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$5,
          lineNumber: 830,
          columnNumber: 9
        }, this), u$1("div", {
          className: "rs-text-center rs-flex rs-items-center rs-justify-center",
          children: u$1("img", {
            src: (_c = getTierImage(billingCycle)) == null ? void 0 : _c["support"],
            alt: `Products for ${billingCycle} support plan`,
            className: "rs-h-12"
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 838,
            columnNumber: 11
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$5,
          lineNumber: 837,
          columnNumber: 9
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$5,
        lineNumber: 815,
        columnNumber: 7
      }, this), u$1("div", {
        className: "rs-flex rs-justify-center rs-mb-12 lg:rs-hidden",
        children: u$1(Button, {
          onClick: handleContinue,
          className: "rs-text-xs",
          children: "CONTINUE"
        }, void 0, false, {
          fileName: _jsxFileName$5,
          lineNumber: 848,
          columnNumber: 9
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$5,
        lineNumber: 847,
        columnNumber: 7
      }, this), u$1("div", {
        className: "rs-mx-auto",
        children: [u$1("div", {
          className: "rs-mb-12",
          children: [u$1("h2", {
            className: "rs-mb-0 rs-text-2xl lg:rs-text-3xl rs-font-bold lg:rs-hidden",
            children: "What You Get"
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 857,
            columnNumber: 11
          }, this), u$1("div", {
            className: "rs-overflow-x-auto",
            children: u$1("table", {
              className: "rs-w-full rs-border-collapse rs-table-fixed rs-border-b rs-border-[#808080]",
              children: [u$1("colgroup", {
                children: [u$1("col", {
                  className: "lg:rs-w-1/4 rs-w-2/5"
                }, void 0, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 863,
                  columnNumber: 17
                }, this), visibleTiers.map((_2, i2) => u$1("col", {
                  className: "lg:rs-w-1/4 rs-w-1/5"
                }, i2, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 865,
                  columnNumber: 19
                }, this))]
              }, void 0, true, {
                fileName: _jsxFileName$5,
                lineNumber: 862,
                columnNumber: 15
              }, this), u$1("thead", {
                children: u$1("tr", {
                  children: [u$1("th", {
                    className: "rs-text-left rs-text-2xl rs-font-bold rs-tracking-tighter lg:rs-border-t-0 rs-border-t rs-border-[#808080] rs-align-bottom",
                    children: u$1("span", {
                      className: "rs-hidden lg:rs-inline-block rs-capitalize rs-mb-4",
                      children: "What you get"
                    }, void 0, false, {
                      fileName: _jsxFileName$5,
                      lineNumber: 871,
                      columnNumber: 21
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 870,
                    columnNumber: 19
                  }, this), visibleTiers.map((tier) => {
                    var _a2;
                    return u$1("th", {
                      className: cn$1("rs-py-2 rs-font-tertiary rs-font-normal rs-text-center rs-text-xs lg:rs-border-t-0 rs-border-t rs-border-[#808080]"),
                      children: [u$1("span", {
                        className: "lg:rs-hidden",
                        children: tier
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 882,
                        columnNumber: 23
                      }, this), u$1("img", {
                        // @ts-ignore
                        src: (_a2 = getTierImage(billingCycle)) == null ? void 0 : _a2[tier == null ? void 0 : tier.toLowerCase()],
                        alt: `Products for ${billingCycle} ${tier} plan`,
                        className: "rs-hidden lg:rs-block rs-mx-auto rs-max-w-[80%]"
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 883,
                        columnNumber: 23
                      }, this)]
                    }, tier, true, {
                      fileName: _jsxFileName$5,
                      lineNumber: 876,
                      columnNumber: 21
                    }, this);
                  })]
                }, void 0, true, {
                  fileName: _jsxFileName$5,
                  lineNumber: 869,
                  columnNumber: 17
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 868,
                columnNumber: 15
              }, this), u$1("tbody", {
                className: "rs-font-tertiary rs-text-xs rs-tracking-wider",
                children: whatYouGetPerks.map((perk, idx) => u$1("tr", {
                  className: "rs-border-t rs-border-[#808080]",
                  children: [u$1("th", {
                    className: "rs-py-3 rs-text-left rs-font-normal rs-text-sm rs-tracking-wider rs-h-[50px] rs-align-middle",
                    children: perk.title
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 896,
                    columnNumber: 21
                  }, this), visibleTiers.includes("Media") && u$1("td", {
                    className: cn$1("rs-p-2 rs-text-center rs-border-l rs-border-[#808080] rs-h-[50px] rs-align-middle", selectedTier === "Media" ? "rs-bg-[#EAEAB7]" : ""),
                    children: perk.included_in["Media"][billingCycle.toLowerCase()] && u$1(Check, {
                      className: "rs-mx-auto rs-w-5 rs-h-5"
                    }, void 0, false, {
                      fileName: _jsxFileName$5,
                      lineNumber: 908,
                      columnNumber: 30
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 900,
                    columnNumber: 23
                  }, this), u$1("td", {
                    className: cn$1("rs-p-2 rs-text-center rs-border-l rs-border-[#808080] rs-h-[50px] rs-align-middle", selectedTier === "All Access" ? "rs-bg-[#EAEAB7]" : ""),
                    children: perk.included_in["All Access"][billingCycle.toLowerCase()] && u$1(Check, {
                      className: "rs-mx-auto rs-w-5 rs-h-5"
                    }, void 0, false, {
                      fileName: _jsxFileName$5,
                      lineNumber: 919,
                      columnNumber: 28
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 911,
                    columnNumber: 21
                  }, this), u$1("td", {
                    className: cn$1("rs-p-2 rs-text-center rs-border-l rs-border-[#808080] rs-h-[50px] rs-align-middle", selectedTier === "Support" ? "rs-bg-[#EAEAB7]" : ""),
                    children: perk.included_in["Support"][billingCycle.toLowerCase()] && u$1(Check, {
                      className: "rs-mx-auto rs-w-5 rs-h-5"
                    }, void 0, false, {
                      fileName: _jsxFileName$5,
                      lineNumber: 929,
                      columnNumber: 28
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 921,
                    columnNumber: 21
                  }, this)]
                }, perk.title, true, {
                  fileName: _jsxFileName$5,
                  lineNumber: 895,
                  columnNumber: 19
                }, this))
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 893,
                columnNumber: 15
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$5,
              lineNumber: 861,
              columnNumber: 13
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 860,
            columnNumber: 11
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$5,
          lineNumber: 856,
          columnNumber: 9
        }, this), u$1("div", {
          className: "rs-mb-12",
          children: [u$1("div", {
            className: "rs-flex rs-justify-between rs-items-center lg:rs-hidden",
            children: [u$1("h2", {
              className: "rs-mb-0 rs-text-2xl lg:rs-text-3xl rs-font-bold",
              children: "Print Magazine"
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 941,
              columnNumber: 13
            }, this), u$1("img", {
              src: "https://autostraddle.forthem.com/assets/print-icon.png",
              alt: "Magazine",
              className: "rs-h-10"
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 944,
              columnNumber: 13
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$5,
            lineNumber: 940,
            columnNumber: 11
          }, this), u$1("div", {
            className: "rs-overflow-x-auto",
            children: u$1("table", {
              className: "rs-w-full rs-border-collapse rs-table-fixed rs-border-b rs-border-[#808080]",
              children: [u$1("colgroup", {
                children: [u$1("col", {
                  className: "lg:rs-w-1/4 rs-w-2/5"
                }, void 0, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 949,
                  columnNumber: 17
                }, this), visibleTiers.map((_2, i2) => u$1("col", {
                  className: "lg:rs-w-1/4 rs-w-1/5"
                }, i2, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 951,
                  columnNumber: 19
                }, this))]
              }, void 0, true, {
                fileName: _jsxFileName$5,
                lineNumber: 948,
                columnNumber: 15
              }, this), u$1("thead", {
                children: u$1("tr", {
                  children: [u$1("th", {
                    className: "rs-text-left rs-text-2xl rs-font-bold rs-tracking-tighter lg:rs-border-t-0 rs-border-[#808080]",
                    children: u$1("span", {
                      className: "rs-hidden lg:rs-inline-flex rs-items-end rs-capitalize rs-mb-4 rs-gap-2.5",
                      children: ["Print Magazine", " ", u$1("img", {
                        src: "https://autostraddle.forthem.com/assets/print-icon.png",
                        alt: "Magazine",
                        className: "rs-h-10"
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 959,
                        columnNumber: 23
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$5,
                      lineNumber: 957,
                      columnNumber: 21
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 956,
                    columnNumber: 19
                  }, this), visibleTiers.map((tier) => u$1("th", {
                    className: "rs-border-0"
                  }, tier, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 967,
                    columnNumber: 21
                  }, this))]
                }, void 0, true, {
                  fileName: _jsxFileName$5,
                  lineNumber: 955,
                  columnNumber: 17
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 954,
                columnNumber: 15
              }, this), u$1("tbody", {
                className: "rs-font-tertiary rs-text-xs rs-tracking-wider",
                children: printMagazinePerks.map((perk) => u$1("tr", {
                  className: "rs-border-t rs-border-[#808080]",
                  children: [u$1("th", {
                    className: "rs-py-3 rs-text-left rs-font-normal rs-text-sm rs-tracking-wider rs-h-[50px] rs-align-middle",
                    children: perk.title
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 974,
                    columnNumber: 21
                  }, this), visibleTiers.includes("Media") && u$1("td", {
                    className: cn$1("rs-p-2 rs-text-center rs-border-l rs-border-[#808080] rs-h-[50px] rs-align-middle", selectedTier === "Media" ? "rs-bg-[#EAEAB7]" : ""),
                    children: perk.included_in["Media"][billingCycle.toLowerCase()] && u$1(Check, {
                      className: "rs-mx-auto rs-w-5 rs-h-5"
                    }, void 0, false, {
                      fileName: _jsxFileName$5,
                      lineNumber: 986,
                      columnNumber: 30
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 978,
                    columnNumber: 23
                  }, this), u$1("td", {
                    className: cn$1("rs-p-2 rs-text-center rs-border-l rs-border-[#808080] rs-h-[50px] rs-align-middle", selectedTier === "All Access" ? "rs-bg-[#EAEAB7]" : ""),
                    children: perk.included_in["All Access"][billingCycle.toLowerCase()] && u$1(Check, {
                      className: "rs-mx-auto rs-w-5 rs-h-5"
                    }, void 0, false, {
                      fileName: _jsxFileName$5,
                      lineNumber: 997,
                      columnNumber: 28
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 989,
                    columnNumber: 21
                  }, this), u$1("td", {
                    className: cn$1("rs-p-2 rs-text-center rs-border-l rs-border-[#808080] rs-h-[50px] rs-align-middle", selectedTier === "Support" ? "rs-bg-[#EAEAB7]" : ""),
                    children: perk.included_in["Support"][billingCycle.toLowerCase()] && u$1(Check, {
                      className: "rs-mx-auto rs-w-5 rs-h-5"
                    }, void 0, false, {
                      fileName: _jsxFileName$5,
                      lineNumber: 1007,
                      columnNumber: 28
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 999,
                    columnNumber: 21
                  }, this)]
                }, perk.title, true, {
                  fileName: _jsxFileName$5,
                  lineNumber: 973,
                  columnNumber: 19
                }, this))
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 971,
                columnNumber: 15
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$5,
              lineNumber: 947,
              columnNumber: 13
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 946,
            columnNumber: 11
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$5,
          lineNumber: 939,
          columnNumber: 9
        }, this), u$1("div", {
          children: [u$1("div", {
            className: "rs-flex rs-justify-between rs-items-center lg:rs-hidden",
            children: [u$1("h2", {
              className: "rs-mb-0 rs-text-2xl lg:rs-text-3xl rs-font-bold",
              children: "Free Gifts!"
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 1019,
              columnNumber: 13
            }, this), u$1("img", {
              src: "https://autostraddle.forthem.com/assets/free-gift-icon.png",
              alt: "Magazine",
              className: "rs-h-10"
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 1020,
              columnNumber: 13
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$5,
            lineNumber: 1018,
            columnNumber: 11
          }, this), u$1("div", {
            className: "rs-overflow-x-auto",
            children: u$1("table", {
              className: "rs-w-full rs-border-collapse rs-table-fixed rs-border-b rs-border-[#808080]",
              children: [u$1("colgroup", {
                children: [u$1("col", {
                  className: "lg:rs-w-1/4 rs-w-2/5"
                }, void 0, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 1029,
                  columnNumber: 17
                }, this), visibleTiers.map((_2, i2) => u$1("col", {
                  className: "lg:rs-w-1/4 rs-w-1/5"
                }, i2, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 1031,
                  columnNumber: 19
                }, this))]
              }, void 0, true, {
                fileName: _jsxFileName$5,
                lineNumber: 1028,
                columnNumber: 15
              }, this), u$1("thead", {
                children: u$1("tr", {
                  children: [u$1("th", {
                    className: "rs-text-left rs-text-2xl rs-font-bold rs-tracking-tighter lg:rs-border-t-0 rs-border-[#808080]",
                    children: u$1("span", {
                      className: "rs-hidden lg:rs-inline-flex rs-items-end rs-gap-2.5 rs-capitalize rs-mb-4",
                      children: ["Free Gifts!", " ", u$1("img", {
                        src: "https://autostraddle.forthem.com/assets/free-gift-icon.png",
                        alt: "Magazine",
                        className: "rs-h-10"
                      }, void 0, false, {
                        fileName: _jsxFileName$5,
                        lineNumber: 1039,
                        columnNumber: 23
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$5,
                      lineNumber: 1037,
                      columnNumber: 21
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 1036,
                    columnNumber: 19
                  }, this), visibleTiers.map((tier) => u$1("th", {
                    className: cn$1("rs-border-0")
                  }, tier, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 1047,
                    columnNumber: 21
                  }, this))]
                }, void 0, true, {
                  fileName: _jsxFileName$5,
                  lineNumber: 1035,
                  columnNumber: 17
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 1034,
                columnNumber: 15
              }, this), u$1("tbody", {
                className: "rs-font-tertiary rs-text-xs rs-tracking-wider",
                children: freeGiftsPerks.map((perk) => u$1("tr", {
                  className: "rs-border-t rs-border-[#808080]",
                  children: [u$1("th", {
                    className: "rs-py-3 rs-text-left rs-font-normal rs-text-sm rs-tracking-wider rs-h-[50px] rs-align-middle",
                    children: perk.title
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 1054,
                    columnNumber: 21
                  }, this), visibleTiers.includes("Media") && u$1("td", {
                    className: cn$1("rs-p-2 rs-text-center rs-border-l rs-border-[#808080] rs-h-[50px] rs-align-middle", selectedTier === "Media" ? "rs-bg-[#EAEAB7]" : ""),
                    children: perk.included_in["Media"][billingCycle.toLowerCase()] && u$1(Check, {
                      className: "rs-mx-auto rs-w-5 rs-h-5"
                    }, void 0, false, {
                      fileName: _jsxFileName$5,
                      lineNumber: 1066,
                      columnNumber: 30
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 1058,
                    columnNumber: 23
                  }, this), u$1("td", {
                    className: cn$1("rs-p-2 rs-text-center rs-border-l rs-border-[#808080] rs-h-[50px] rs-align-middle", selectedTier === "All Access" ? "rs-bg-[#EAEAB7]" : ""),
                    children: perk.included_in["All Access"][billingCycle.toLowerCase()] && u$1(Check, {
                      className: "rs-mx-auto rs-w-5 rs-h-5"
                    }, void 0, false, {
                      fileName: _jsxFileName$5,
                      lineNumber: 1077,
                      columnNumber: 28
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 1069,
                    columnNumber: 21
                  }, this), u$1("td", {
                    className: cn$1("rs-p-2 rs-text-center rs-border-l rs-border-[#808080] rs-h-[50px] rs-align-middle", selectedTier === "Support" ? "rs-bg-[#EAEAB7]" : ""),
                    children: perk.included_in["Support"][billingCycle.toLowerCase()] && u$1(Check, {
                      className: "rs-mx-auto rs-w-5 rs-h-5"
                    }, void 0, false, {
                      fileName: _jsxFileName$5,
                      lineNumber: 1087,
                      columnNumber: 28
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 1079,
                    columnNumber: 21
                  }, this)]
                }, perk.title, true, {
                  fileName: _jsxFileName$5,
                  lineNumber: 1053,
                  columnNumber: 19
                }, this))
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 1051,
                columnNumber: 15
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$5,
              lineNumber: 1027,
              columnNumber: 13
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 1026,
            columnNumber: 11
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$5,
          lineNumber: 1017,
          columnNumber: 9
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$5,
        lineNumber: 854,
        columnNumber: 7
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$5,
      lineNumber: 418,
      columnNumber: 5
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$5,
    lineNumber: 417,
    columnNumber: 5
  }, this);
}
register(MembershipSelection, "membership-table");
var _jsxFileName$4 = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/components/membership-images.tsx";
const MembershipImages = ({
  "product-id": productId,
  "default-frequency": defaultFrequency = "quarterly",
  class: className
}) => {
  const [currentFrequency, setCurrentFrequency] = t$1(d$1(defaultFrequency), "currentFrequency");
  const [currentVariant, setCurrentVariant] = t$1(d$1(null), "currentVariant");
  const [currentImage, setCurrentImage] = t$1(d$1(""), "currentImage");
  const [isLoading, setIsLoading] = t$1(d$1(false), "isLoading");
  const [productData, setProductData] = t$1(d$1(null), "productData");
  const imgRef = t$1(A$1(null), "imgRef");
  y$1(() => {
    var _a, _b;
    const productScript = document.querySelector("[data-product-json]");
    if (productScript == null ? void 0 : productScript.textContent) {
      try {
        const data = JSON.parse(productScript.textContent);
        setProductData(data);
        const urlParams = new URLSearchParams(window.location.search);
        const variantParam = urlParams.get("variant");
        let selectedVariant = (_a = data.variants) == null ? void 0 : _a[0];
        if (variantParam) {
          selectedVariant = ((_b = data.variants) == null ? void 0 : _b.find((v2) => v2.id === parseInt(variantParam))) || selectedVariant;
        }
        setCurrentVariant(selectedVariant);
      } catch (error) {
        console.error("Failed to parse product data:", error);
      }
    }
  }, []);
  y$1(() => {
    var _a;
    if (currentVariant) {
      const imageKey = `image_${currentFrequency}`;
      const membershipImage = currentVariant[imageKey];
      if (membershipImage && membershipImage !== "null" && membershipImage !== "") {
        setCurrentImage(membershipImage);
      } else {
        const fallbackImage = ((_a = currentVariant.featured_image) == null ? void 0 : _a.src) || currentVariant.image_annual || currentVariant.image_quarterly || currentVariant.image_monthly;
        setCurrentImage(fallbackImage || "");
      }
    }
  }, [currentVariant, currentFrequency]);
  y$1(() => {
    const handleFrequencyChange = (event) => {
      var _a;
      const newFrequency = ((_a = event.detail) == null ? void 0 : _a.frequency) || event.detail;
      if (newFrequency && ["annually", "monthly", "quarterly"].includes(newFrequency)) {
        setCurrentFrequency(newFrequency);
      }
    };
    const handleVariantChange = (event) => {
      var _a, _b, _c;
      const variantId = ((_b = (_a = event.detail) == null ? void 0 : _a.variant) == null ? void 0 : _b.id) || ((_c = event.detail) == null ? void 0 : _c.id);
      if (variantId && (productData == null ? void 0 : productData.variants)) {
        const newVariant = productData.variants.find((v2) => v2.id === variantId);
        if (newVariant) {
          setCurrentVariant(newVariant);
        }
      }
    };
    document.addEventListener("frequency-changed", handleFrequencyChange);
    document.addEventListener("membershipVariantChanged", handleVariantChange);
    document.addEventListener("variant:change", handleVariantChange);
    const handleSellingPlanChange = (event) => {
      const target = event.target;
      if (target.type === "radio" && target.name === "selling_plan") {
        const frequency = target.getAttribute("data-frequency-option") || "";
        if (frequency && ["annually", "monthly", "quarterly"].includes(frequency)) {
          setCurrentFrequency(frequency);
        }
      }
    };
    const handleMembershipVariantClick = (event) => {
      const target = event.target;
      const variantOption = target.closest("[data-variant-option]");
      if (variantOption) {
        const variantId = parseInt(variantOption.getAttribute("data-variant-id") || "");
        if (variantId && (productData == null ? void 0 : productData.variants)) {
          const newVariant = productData.variants.find((v2) => v2.id === variantId);
          if (newVariant) {
            setCurrentVariant(newVariant);
          }
        }
      }
    };
    document.addEventListener("change", handleSellingPlanChange);
    document.addEventListener("click", handleMembershipVariantClick);
    return () => {
      document.removeEventListener("frequency-changed", handleFrequencyChange);
      document.removeEventListener("membershipVariantChanged", handleVariantChange);
      document.removeEventListener("variant:change", handleVariantChange);
      document.removeEventListener("change", handleSellingPlanChange);
      document.removeEventListener("click", handleMembershipVariantClick);
    };
  }, [productData]);
  const handleImageLoad = () => {
    setIsLoading(false);
  };
  const handleImageLoadStart = () => {
    setIsLoading(true);
  };
  y$1(() => {
    if (currentImage && imgRef.current) {
      setIsLoading(true);
      imgRef.current.src = currentImage;
    }
  }, [currentImage]);
  if (!currentVariant || !currentImage) {
    return u$1("div", {
      className: `membership-images ${className || ""}`,
      children: u$1("div", {
        className: "membership-images__container",
        children: u$1("div", {
          className: "membership-images__error",
          children: u$1("p", {
            children: "No membership images available"
          }, void 0, false, {
            fileName: _jsxFileName$4,
            lineNumber: 174,
            columnNumber: 13
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$4,
          lineNumber: 173,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$4,
        lineNumber: 172,
        columnNumber: 9
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$4,
      lineNumber: 171,
      columnNumber: 7
    }, void 0);
  }
  return u$1("div", {
    className: `membership-images ${className || ""}`,
    children: u$1("div", {
      className: `membership-images__container ${isLoading ? "loading" : ""}`,
      children: u$1("div", {
        className: "membership-images__main-image",
        children: u$1("img", {
          ref: imgRef,
          className: "membership-image",
          src: currentImage,
          alt: `Product Image - ${currentFrequency}`,
          loading: "lazy",
          onLoad: handleImageLoad,
          onLoadStart: handleImageLoadStart
        }, void 0, false, {
          fileName: _jsxFileName$4,
          lineNumber: 185,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$4,
        lineNumber: 184,
        columnNumber: 9
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$4,
      lineNumber: 183,
      columnNumber: 7
    }, void 0)
  }, void 0, false, {
    fileName: _jsxFileName$4,
    lineNumber: 182,
    columnNumber: 5
  }, void 0);
};
register(MembershipImages, "membership-images", ["product-id", "default-frequency", "class"]);
var _jsxFileName$3 = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/components/MembersOnlyModal.tsx";
function MembersOnlyModal({
  isOpen = false,
  onClose,
  onAddToCart,
  onSignIn,
  productTitle = "this product",
  productImage = ""
}) {
  const dialogRef = t$1(A$1(null), "dialogRef");
  const [membershipStatus, setMembershipStatus] = t$1(d$1("not-member"), "membershipStatus");
  const [isLoading, setIsLoading] = t$1(d$1(true), "isLoading");
  y$1(() => {
    if (isOpen) {
      setIsLoading(true);
      membershipService.getCurrentMembershipStatus().then((result) => {
        setMembershipStatus(result.status);
        setIsLoading(false);
      }).catch((error) => {
        setMembershipStatus("not-member");
        setIsLoading(false);
      });
    }
  }, [isOpen]);
  y$1(() => {
    const dialog = dialogRef.current;
    if (!dialog) {
      return;
    }
    if (isOpen && !dialog.open) {
      try {
        dialog.showModal();
      } catch (error) {
        dialog.setAttribute("open", "");
        dialog.style.display = "flex";
      }
      document.body.style.overflow = "hidden";
    } else if (!isOpen && dialog.open) {
      dialog.close();
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      if (dialog.open) {
        dialog.close();
      }
    };
  }, [isOpen]);
  const dispatchCustomEvent = (eventName, detail) => {
    const event = new CustomEvent(eventName, {
      bubbles: true,
      detail
    });
    document.dispatchEvent(event);
  };
  const handleBackdropClick = (e) => {
    const dialog = dialogRef.current;
    if (e.target === dialog) {
      handleClose();
    }
  };
  const handleClose = () => {
    const dialog = dialogRef.current;
    if (dialog && dialog.open) {
      dialog.close();
    }
    document.body.style.overflow = "";
    dispatchCustomEvent("members-only:close");
    onClose == null ? void 0 : onClose();
  };
  const handleAddToCart = () => {
    dispatchCustomEvent("members-only:add-to-cart");
    onAddToCart == null ? void 0 : onAddToCart();
  };
  const handleSignIn = () => {
    dispatchCustomEvent("members-only:sign-in");
    onSignIn == null ? void 0 : onSignIn();
  };
  const handleUpgrade = () => {
    dispatchCustomEvent("members-only:upgrade");
  };
  if (!isOpen) {
    return null;
  }
  if (isLoading) {
    return u$1("dialog", {
      ref: dialogRef,
      className: "rs-fixed rs-inset-0 rs-z-[6000] rs-w-full rs-h-full rs-max-w-full rs-max-h-full rs-p-0 rs-m-0 rs-bg-black/50 backdrop:rs-bg-transparent",
      children: u$1("div", {
        className: "rs-flex rs-items-center rs-justify-center rs-min-h-full rs-p-4",
        children: u$1("div", {
          className: "rs-bg-[#baba00] rs-border rs-border-black rs-relative rs-rounded-lg rs-w-full rs-max-w-[672px] rs-h-auto rs-min-h-[500px] rs-overflow-hidden",
          children: u$1("div", {
            className: "rs-flex rs-items-center rs-justify-center rs-h-[500px]",
            children: u$1("div", {
              className: "rs-text-black rs-text-lg",
              children: "Loading..."
            }, void 0, false, {
              fileName: _jsxFileName$3,
              lineNumber: 137,
              columnNumber: 15
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 136,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$3,
          lineNumber: 135,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$3,
        lineNumber: 134,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$3,
      lineNumber: 130,
      columnNumber: 7
    }, this);
  }
  const renderContent = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n2, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    switch (membershipStatus) {
      case "upgradable":
        return u$1("div", {
          className: "rs-flex rs-flex-col rs-items-center rs-justify-center rs-p-[66px_22px] lg:rs-p-[74px_74px_50px] rs-gap-9 rs-min-h-full",
          children: [u$1("h3", {
            className: "rs-font-primary rs-text-[50px] lg:rs-text-[60px] rs-leading-[0.9] rs-tracking-[-3px] rs-text-black rs-text-center rs-font-normal",
            children: ((_b = (_a = window.theme) == null ? void 0 : _a.settings) == null ? void 0 : _b.members_only_modal_title) || "All-Access Members Only"
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 152,
            columnNumber: 13
          }, this), u$1("div", {
            className: "rs-flex rs-flex-col rs-items-center rs-gap-3 rs-text-center",
            children: [u$1("p", {
              className: "rs-font-primary rs-text-[16px] lg:rs-text-[18px] rs-leading-[0.9] rs-tracking-[-0.9px] rs-text-black",
              children: ((_d = (_c = window.theme) == null ? void 0 : _c.settings) == null ? void 0 : _d.members_only_modal_upgradable_subtitle) || "Upgrade to All-Access to buy"
            }, void 0, false, {
              fileName: _jsxFileName$3,
              lineNumber: 158,
              columnNumber: 15
            }, this), u$1("p", {
              className: "rs-font-primary rs-text-[30px] rs-leading-[0.9] rs-tracking-[-1.5px] rs-text-black",
              children: ((_g = (_f = (_e = window.theme) == null ? void 0 : _e.settings) == null ? void 0 : _f.members_only_modal_not_member_product_text) == null ? void 0 : _g.replace("{{product_title}}", productTitle)) || productTitle
            }, void 0, false, {
              fileName: _jsxFileName$3,
              lineNumber: 161,
              columnNumber: 15
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$3,
            lineNumber: 157,
            columnNumber: 13
          }, this), u$1("div", {
            className: "rs-flex rs-items-center rs-justify-center rs-gap-5 rs-w-[261px]",
            children: [u$1("div", {
              className: "rs-w-[68px] rs-h-[53px] rs-bg-gray-600 rs-rounded rs-overflow-hidden rs-flex rs-items-center rs-justify-center",
              children: productImage ? u$1("img", {
                src: productImage,
                alt: productTitle,
                className: "rs-w-full rs-h-full rs-object-cover"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 171,
                columnNumber: 19
              }, this) : u$1("svg", {
                width: "40",
                height: "32",
                viewBox: "0 0 40 32",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: u$1("path", {
                  d: "M8 0C6.4 0 5 1.4 5 3V29C5 30.6 6.4 32 8 32H32C33.6 32 35 30.6 35 29V3C35 1.4 33.6 0 32 0H8ZM20 8C22.2 8 24 9.8 24 12C24 14.2 22.2 16 20 16C17.8 16 16 14.2 16 12C16 9.8 17.8 8 20 8ZM8 24V20L12 16L16 20L24 12L32 20V24H8Z",
                  fill: "white"
                }, void 0, false, {
                  fileName: _jsxFileName$3,
                  lineNumber: 184,
                  columnNumber: 21
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 177,
                columnNumber: 19
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$3,
              lineNumber: 169,
              columnNumber: 15
            }, this), u$1("div", {
              className: "rs-w-[35.613px] rs-h-[35.613px]",
              children: u$1("svg", {
                width: "36",
                height: "36",
                viewBox: "0 0 36 36",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: u$1("path", {
                  d: "M18 0L18 36M0 18L36 18",
                  stroke: "black",
                  strokeWidth: "2"
                }, void 0, false, {
                  fileName: _jsxFileName$3,
                  lineNumber: 201,
                  columnNumber: 19
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 194,
                columnNumber: 17
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$3,
              lineNumber: 193,
              columnNumber: 15
            }, this), u$1("svg", {
              width: "50",
              height: "49",
              viewBox: "0 0 50 49",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [u$1("path", {
                d: "M39.177 23.0124C39.177 23.3016 39.4115 23.5361 39.7008 23.5361H42.3029C42.5921 23.5361 42.8266 23.7706 42.8266 24.0599V25.5476C42.8266 25.8369 42.5921 26.0714 42.3029 26.0714H39.7008C39.4115 26.0714 39.177 26.3059 39.177 26.5952V29.6599C39.177 29.9492 38.9425 30.1837 38.6533 30.1837H37.0583C36.7691 30.1837 36.5346 29.9492 36.5346 29.6599V26.5952C36.5346 26.3059 36.3001 26.0714 36.0108 26.0714H33.3988C33.1095 26.0714 32.875 25.8369 32.875 25.5476V24.0599C32.875 23.7706 33.1095 23.5361 33.3988 23.5361H36.0108C36.3001 23.5361 36.5346 23.3016 36.5346 23.0124V20.1273C36.5346 19.838 36.7691 19.6035 37.0583 19.6035H38.6533C38.9425 19.6035 39.177 19.838 39.177 20.1273V23.0124Z",
                fill: "black"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 211,
                columnNumber: 21
              }, this), u$1("path", {
                d: "M14.003 19.5813C16.9662 19.4611 18.2953 22.4337 18.1994 24.6894C18.1798 25.1459 18.1537 25.6024 18.158 26.0588C18.1689 27.504 18.1842 28.9491 18.2234 30.3942C18.2321 30.7527 18.2757 31.109 18.3214 31.4631C18.3868 31.9752 18.2321 32.2335 17.6939 32.189C16.8464 32.1199 15.9901 32.1044 15.1491 31.9841C14.9486 31.9552 14.7111 31.639 14.6261 31.4052C14.3669 30.6926 14.2797 30.6481 13.7917 31.1736C12.7131 32.3315 11.3601 32.5608 9.89593 32.3248C9.3229 32.2313 8.76948 32.0175 8.20952 31.8483C6.68217 31.3851 6.20719 29.842 6.42507 28.4503C6.81508 25.9742 8.25746 25.2372 10.8176 24.9588C11.6412 24.8698 12.4713 24.8096 13.2796 24.6382C13.6587 24.558 14.247 24.3175 14.2862 24.0392C14.3603 23.5204 14.088 22.8769 13.7372 22.5184C12.9071 21.6678 11.2991 21.975 10.8154 23.0617C10.5234 23.7163 10.1487 23.7297 9.51028 23.7943C8.87188 23.8588 8.29667 23.8277 7.69314 23.89C6.96106 23.9657 6.72792 23.723 6.91966 23.0305C7.50141 20.9263 8.93071 19.7528 11.0856 19.6103C11.6956 19.5702 12.3101 19.5457 12.9201 19.5234C13.2883 19.5346 13.6348 19.5947 14.0008 19.5813H14.003ZM12.0377 29.9088C13.4627 29.8999 14.6392 28.5817 14.4802 27.1922C14.43 26.7513 14.2165 26.4596 13.7808 26.5398C12.9942 26.6845 12.2033 26.8471 11.4472 27.1076C10.6433 27.386 10.1748 28.172 10.3143 28.7977C10.4472 29.3989 11.2468 29.9155 12.0355 29.9088H12.0377Z",
                fill: "black"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 212,
                columnNumber: 21
              }, this), u$1("path", {
                d: "M29.7398 23.4048C29.7242 22.9192 29.3164 22.9516 28.6735 22.9354C27.4347 22.903 27.121 22.8545 25.8822 22.8383C24.0004 22.8059 24.0161 22.9192 24.0631 20.9443C24.0631 20.2806 24.3611 20.0378 24.9413 20.054C25.7881 20.054 26.6349 20.0702 27.4974 20.0864C28.2815 20.1026 29.0499 20.1997 29.8339 20.1511C30.0692 20.1511 30.4612 19.9407 30.4926 19.5846C30.5553 18.8723 30.571 18.1439 30.6023 17.4316C30.618 16.9136 30.3357 16.7355 29.881 16.7193C26.7133 16.6708 23.5613 16.6546 20.4093 16.5898C19.8291 16.5898 19.6252 16.8003 19.6095 17.3669C19.6095 18.9532 19.5625 20.5396 19.5625 22.126C19.5625 25.2017 19.5939 28.2935 19.5625 31.3692C19.5625 32.049 19.8761 32.2433 20.4407 32.2757C21.3188 32.3242 22.1813 32.3566 23.0595 32.4052C23.8436 32.4375 24.1102 32.1624 24.0945 31.353C24.0788 29.9608 24.0788 28.5687 24.0474 27.1766C24.0474 26.5452 24.3297 26.2377 24.9099 26.2377C25.8038 26.2377 26.7133 26.3186 27.6071 26.2862C28.2501 26.2701 28.6265 26.3186 29.1753 26.3024C29.3948 26.3024 29.5673 26.3186 29.6301 25.7197C29.6771 25.1855 29.7555 24.1495 29.7242 23.3887L29.7398 23.4048Z",
                fill: "black"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 213,
                columnNumber: 21
              }, this), u$1("circle", {
                cx: "24.8066",
                cy: "24.5",
                r: "23.3301",
                stroke: "black",
                "stroke-width": "2"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 214,
                columnNumber: 21
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$3,
              lineNumber: 210,
              columnNumber: 15
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$3,
            lineNumber: 167,
            columnNumber: 13
          }, this), u$1("div", {
            className: "rs-flex rs-flex-col rs-items-center rs-gap-6 rs-w-[296px]",
            children: [u$1("div", {
              className: "rs-flex rs-flex-col rs-items-center rs-gap-4 rs-w-full",
              children: [u$1("button", {
                onClick: handleUpgrade,
                className: "rs-w-full rs-bg-black rs-text-white rs-rounded-lg rs-px-[18px] rs-py-3.5 rs-font-primary rs-font-bold rs-text-[12px] rs-uppercase rs-tracking-wide hover:rs-bg-gray-800 rs-transition-colors",
                children: ((_i = (_h = window.theme) == null ? void 0 : _h.settings) == null ? void 0 : _i.members_only_modal_upgradable_button) || "UPGRADE"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 222,
                columnNumber: 17
              }, this), u$1("a", {
                href: "/products/af-membership?variant=44792925257894",
                className: "rs-font-primary rs-text-[14px] rs-text-black rs-underline rs-bg-transparent rs-border-none rs-cursor-pointer hover:rs-opacity-70 rs-transition-opacity",
                children: ((_k = (_j = window.theme) == null ? void 0 : _j.settings) == null ? void 0 : _k.members_only_modal_not_member_learn_more) || "Learn More"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 230,
                columnNumber: 17
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$3,
              lineNumber: 220,
              columnNumber: 15
            }, this), u$1("div", {
              style: {
                visibility: "hidden",
                height: "20px"
              },
              children: u$1("p", {
                className: "rs-font-primary rs-text-[14px] rs-text-black rs-text-center",
                children: " "
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 240,
                columnNumber: 17
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$3,
              lineNumber: 239,
              columnNumber: 15
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$3,
            lineNumber: 219,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$3,
          lineNumber: 150,
          columnNumber: 11
        }, this);
      case "not-member":
      default:
        return u$1("div", {
          className: "rs-flex rs-flex-col rs-items-center rs-justify-center rs-p-[66px_22px] lg:rs-p-[74px_74px_50px] rs-gap-9 rs-min-h-full",
          children: [u$1("h3", {
            className: "rs-font-primary rs-text-[50px] lg:rs-text-[60px] rs-leading-[0.9] rs-tracking-[-3px] rs-text-black rs-text-center rs-font-normal",
            children: ((_m = (_l = window.theme) == null ? void 0 : _l.settings) == null ? void 0 : _m.members_only_modal_title) || "All-Access Members Only"
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 253,
            columnNumber: 13
          }, this), u$1("div", {
            className: "rs-flex rs-flex-col rs-items-center rs-gap-3 rs-text-center",
            children: [u$1("p", {
              className: "rs-font-primary rs-text-[16px] lg:rs-text-[18px] rs-leading-[0.9] rs-tracking-[-0.9px] rs-text-black",
              children: ((_o = (_n2 = window.theme) == null ? void 0 : _n2.settings) == null ? void 0 : _o.members_only_modal_not_member_subtitle) || "Join AF+ to access"
            }, void 0, false, {
              fileName: _jsxFileName$3,
              lineNumber: 259,
              columnNumber: 15
            }, this), u$1("p", {
              className: "rs-font-primary rs-text-[30px] rs-leading-[0.9] rs-tracking-[-1.5px] rs-text-black",
              children: ((_r = (_q = (_p = window.theme) == null ? void 0 : _p.settings) == null ? void 0 : _q.members_only_modal_not_member_product_text) == null ? void 0 : _r.replace("{{product_title}}", productTitle)) || productTitle
            }, void 0, false, {
              fileName: _jsxFileName$3,
              lineNumber: 262,
              columnNumber: 15
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$3,
            lineNumber: 258,
            columnNumber: 13
          }, this), u$1("div", {
            className: "rs-flex rs-items-center rs-justify-center rs-gap-5 rs-w-[261px]",
            children: [u$1("div", {
              className: "rs-w-[68px] rs-h-[53px] rs-bg-gray-600 rs-rounded rs-overflow-hidden rs-flex rs-items-center rs-justify-center",
              children: productImage ? u$1("img", {
                src: productImage,
                alt: productTitle,
                className: "rs-w-full rs-h-full rs-object-cover"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 272,
                columnNumber: 19
              }, this) : u$1("svg", {
                width: "40",
                height: "32",
                viewBox: "0 0 40 32",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: u$1("path", {
                  d: "M8 0C6.4 0 5 1.4 5 3V29C5 30.6 6.4 32 8 32H32C33.6 32 35 30.6 35 29V3C35 1.4 33.6 0 32 0H8ZM20 8C22.2 8 24 9.8 24 12C24 14.2 22.2 16 20 16C17.8 16 16 14.2 16 12C16 9.8 17.8 8 20 8ZM8 24V20L12 16L16 20L24 12L32 20V24H8Z",
                  fill: "white"
                }, void 0, false, {
                  fileName: _jsxFileName$3,
                  lineNumber: 285,
                  columnNumber: 21
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 278,
                columnNumber: 19
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$3,
              lineNumber: 270,
              columnNumber: 15
            }, this), u$1("div", {
              className: "rs-w-[35.613px] rs-h-[35.613px]",
              children: u$1("svg", {
                width: "36",
                height: "36",
                viewBox: "0 0 36 36",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: u$1("path", {
                  d: "M18 0L18 36M0 18L36 18",
                  stroke: "black",
                  strokeWidth: "2"
                }, void 0, false, {
                  fileName: _jsxFileName$3,
                  lineNumber: 302,
                  columnNumber: 19
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 295,
                columnNumber: 17
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$3,
              lineNumber: 294,
              columnNumber: 15
            }, this), u$1("svg", {
              width: "50",
              height: "49",
              viewBox: "0 0 50 49",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [u$1("path", {
                d: "M39.177 23.0124C39.177 23.3016 39.4115 23.5361 39.7008 23.5361H42.3029C42.5921 23.5361 42.8266 23.7706 42.8266 24.0599V25.5476C42.8266 25.8369 42.5921 26.0714 42.3029 26.0714H39.7008C39.4115 26.0714 39.177 26.3059 39.177 26.5952V29.6599C39.177 29.9492 38.9425 30.1837 38.6533 30.1837H37.0583C36.7691 30.1837 36.5346 29.9492 36.5346 29.6599V26.5952C36.5346 26.3059 36.3001 26.0714 36.0108 26.0714H33.3988C33.1095 26.0714 32.875 25.8369 32.875 25.5476V24.0599C32.875 23.7706 33.1095 23.5361 33.3988 23.5361H36.0108C36.3001 23.5361 36.5346 23.3016 36.5346 23.0124V20.1273C36.5346 19.838 36.7691 19.6035 37.0583 19.6035H38.6533C38.9425 19.6035 39.177 19.838 39.177 20.1273V23.0124Z",
                fill: "black"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 312,
                columnNumber: 21
              }, this), u$1("path", {
                d: "M14.003 19.5813C16.9662 19.4611 18.2953 22.4337 18.1994 24.6894C18.1798 25.1459 18.1537 25.6024 18.158 26.0588C18.1689 27.504 18.1842 28.9491 18.2234 30.3942C18.2321 30.7527 18.2757 31.109 18.3214 31.4631C18.3868 31.9752 18.2321 32.2335 17.6939 32.189C16.8464 32.1199 15.9901 32.1044 15.1491 31.9841C14.9486 31.9552 14.7111 31.639 14.6261 31.4052C14.3669 30.6926 14.2797 30.6481 13.7917 31.1736C12.7131 32.3315 11.3601 32.5608 9.89593 32.3248C9.3229 32.2313 8.76948 32.0175 8.20952 31.8483C6.68217 31.3851 6.20719 29.842 6.42507 28.4503C6.81508 25.9742 8.25746 25.2372 10.8176 24.9588C11.6412 24.8698 12.4713 24.8096 13.2796 24.6382C13.6587 24.558 14.247 24.3175 14.2862 24.0392C14.3603 23.5204 14.088 22.8769 13.7372 22.5184C12.9071 21.6678 11.2991 21.975 10.8154 23.0617C10.5234 23.7163 10.1487 23.7297 9.51028 23.7943C8.87188 23.8588 8.29667 23.8277 7.69314 23.89C6.96106 23.9657 6.72792 23.723 6.91966 23.0305C7.50141 20.9263 8.93071 19.7528 11.0856 19.6103C11.6956 19.5702 12.3101 19.5457 12.9201 19.5234C13.2883 19.5346 13.6348 19.5947 14.0008 19.5813H14.003ZM12.0377 29.9088C13.4627 29.8999 14.6392 28.5817 14.4802 27.1922C14.43 26.7513 14.2165 26.4596 13.7808 26.5398C12.9942 26.6845 12.2033 26.8471 11.4472 27.1076C10.6433 27.386 10.1748 28.172 10.3143 28.7977C10.4472 29.3989 11.2468 29.9155 12.0355 29.9088H12.0377Z",
                fill: "black"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 313,
                columnNumber: 21
              }, this), u$1("path", {
                d: "M29.7398 23.4048C29.7242 22.9192 29.3164 22.9516 28.6735 22.9354C27.4347 22.903 27.121 22.8545 25.8822 22.8383C24.0004 22.8059 24.0161 22.9192 24.0631 20.9443C24.0631 20.2806 24.3611 20.0378 24.9413 20.054C25.7881 20.054 26.6349 20.0702 27.4974 20.0864C28.2815 20.1026 29.0499 20.1997 29.8339 20.1511C30.0692 20.1511 30.4612 19.9407 30.4926 19.5846C30.5553 18.8723 30.571 18.1439 30.6023 17.4316C30.618 16.9136 30.3357 16.7355 29.881 16.7193C26.7133 16.6708 23.5613 16.6546 20.4093 16.5898C19.8291 16.5898 19.6252 16.8003 19.6095 17.3669C19.6095 18.9532 19.5625 20.5396 19.5625 22.126C19.5625 25.2017 19.5939 28.2935 19.5625 31.3692C19.5625 32.049 19.8761 32.2433 20.4407 32.2757C21.3188 32.3242 22.1813 32.3566 23.0595 32.4052C23.8436 32.4375 24.1102 32.1624 24.0945 31.353C24.0788 29.9608 24.0788 28.5687 24.0474 27.1766C24.0474 26.5452 24.3297 26.2377 24.9099 26.2377C25.8038 26.2377 26.7133 26.3186 27.6071 26.2862C28.2501 26.2701 28.6265 26.3186 29.1753 26.3024C29.3948 26.3024 29.5673 26.3186 29.6301 25.7197C29.6771 25.1855 29.7555 24.1495 29.7242 23.3887L29.7398 23.4048Z",
                fill: "black"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 314,
                columnNumber: 21
              }, this), u$1("circle", {
                cx: "24.8066",
                cy: "24.5",
                r: "23.3301",
                stroke: "black",
                "stroke-width": "2"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 315,
                columnNumber: 21
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$3,
              lineNumber: 311,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$3,
            lineNumber: 268,
            columnNumber: 13
          }, this), u$1("div", {
            className: "rs-flex rs-flex-col rs-items-center rs-gap-6 rs-w-[296px]",
            children: [u$1("div", {
              className: "rs-flex rs-flex-col rs-items-center rs-gap-4 rs-w-full",
              children: [u$1("button", {
                onClick: handleAddToCart,
                className: "rs-w-full rs-bg-black rs-text-white rs-rounded-lg rs-px-[18px] rs-py-3.5 rs-font-primary rs-font-bold rs-text-[12px] rs-uppercase rs-tracking-wide hover:rs-bg-gray-800 rs-transition-colors",
                children: ((_t = (_s = window.theme) == null ? void 0 : _s.settings) == null ? void 0 : _t.members_only_modal_not_member_button) || "ADD TO CART"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 324,
                columnNumber: 17
              }, this), u$1("a", {
                href: "/products/af-membership?variant=44792925257894",
                className: "rs-font-primary rs-text-[14px] rs-text-black rs-underline rs-bg-transparent rs-border-none rs-cursor-pointer hover:rs-opacity-70 rs-transition-opacity",
                children: ((_v = (_u = window.theme) == null ? void 0 : _u.settings) == null ? void 0 : _v.members_only_modal_not_member_learn_more) || "Learn More"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 332,
                columnNumber: 17
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$3,
              lineNumber: 322,
              columnNumber: 15
            }, this), u$1("p", {
              className: "rs-font-primary rs-text-[14px] rs-text-black rs-text-center",
              children: [((_x = (_w = window.theme) == null ? void 0 : _w.settings) == null ? void 0 : _x.members_only_modal_not_member_sign_in_text) || "Already a member?", " ", u$1("button", {
                onClick: handleSignIn,
                className: "rs-underline rs-bg-transparent rs-border-none rs-cursor-pointer rs-font-primary rs-text-[14px] rs-text-black hover:rs-opacity-70 rs-transition-opacity",
                children: ((_z = (_y = window.theme) == null ? void 0 : _y.settings) == null ? void 0 : _z.members_only_modal_not_member_sign_in_link) || "Sign In"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 343,
                columnNumber: 17
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$3,
              lineNumber: 341,
              columnNumber: 15
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$3,
            lineNumber: 321,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$3,
          lineNumber: 251,
          columnNumber: 11
        }, this);
    }
  };
  return u$1("dialog", {
    ref: dialogRef,
    className: "rs-fixed rs-inset-0 rs-z-[6000] rs-w-full rs-h-full rs-max-w-full rs-max-h-full rs-p-0 rs-m-0 rs-bg-black/50 backdrop:rs-bg-transparent",
    onClick: handleBackdropClick,
    children: u$1("div", {
      className: "rs-flex rs-items-center rs-justify-center rs-min-h-full rs-p-4",
      children: u$1("div", {
        className: "rs-bg-[#baba00] rs-border rs-border-black rs-relative rs-rounded-lg rs-w-full rs-max-w-[672px] rs-h-auto rs-min-h-[500px] rs-overflow-hidden",
        onClick: (e) => {
          e.stopPropagation();
        },
        children: [u$1("button", {
          onClick: handleClose,
          className: "rs-absolute rs-top-[7.65px] rs-right-[7.65px] rs-w-[50.359px] rs-h-[50.359px] rs-flex rs-items-center rs-justify-center rs-z-10 rs-bg-transparent rs-border-none rs-cursor-pointer",
          "aria-label": "Close modal",
          children: u$1("div", {
            className: "rs-w-[35.613px] rs-h-[35.613px] rs-transform rs-rotate-45",
            children: u$1("svg", {
              width: "36",
              height: "36",
              viewBox: "0 0 36 36",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: u$1("path", {
                d: "M18 0L18 36M0 18L36 18",
                stroke: "black",
                strokeWidth: "2"
              }, void 0, false, {
                fileName: _jsxFileName$3,
                lineNumber: 383,
                columnNumber: 17
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$3,
              lineNumber: 376,
              columnNumber: 15
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 375,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$3,
          lineNumber: 370,
          columnNumber: 11
        }, this), renderContent()]
      }, void 0, true, {
        fileName: _jsxFileName$3,
        lineNumber: 363,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$3,
      lineNumber: 362,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$3,
    lineNumber: 357,
    columnNumber: 5
  }, this);
}
register(MembersOnlyModal, "members-only-modal", ["is-open", "product-title", "product-image"], {
  shadow: false
});
var _jsxFileName$2 = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/components/FreeProductWithMembershipModal.tsx";
function FreeProductWithMembershipModal({
  isOpen = false,
  onClose,
  onAddToCart,
  onSignIn,
  onPayFullPrice,
  productTitle = "this product",
  productImage = "",
  productPrice = "25"
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n2, _o;
  const dialogRef = t$1(A$1(null), "dialogRef");
  const [membershipStatus, setMembershipStatus] = t$1(d$1("not-member"), "membershipStatus");
  const [isLoading, setIsLoading] = t$1(d$1(true), "isLoading");
  y$1(() => {
    if (isOpen) {
      setIsLoading(true);
      membershipService.getCurrentMembershipStatus().then((result) => {
        setMembershipStatus(result.status);
        setIsLoading(false);
      }).catch((error) => {
        setMembershipStatus("not-member");
        setIsLoading(false);
      });
    }
  }, [isOpen]);
  y$1(() => {
    const dialog = dialogRef.current;
    if (!dialog) {
      return;
    }
    if (isOpen && !dialog.open) {
      try {
        dialog.showModal();
      } catch (error) {
        dialog.setAttribute("open", "");
        dialog.style.display = "flex";
      }
      document.body.style.overflow = "hidden";
    } else if (!isOpen && dialog.open) {
      dialog.close();
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      if (dialog.open) {
        dialog.close();
      }
    };
  }, [isOpen]);
  const dispatchCustomEvent = (eventName, detail) => {
    const event = new CustomEvent(eventName, {
      bubbles: true,
      detail
    });
    document.dispatchEvent(event);
  };
  const handleBackdropClick = (e) => {
    const dialog = dialogRef.current;
    if (e.target === dialog) {
      handleClose();
    }
  };
  const handleClose = () => {
    const dialog = dialogRef.current;
    if (dialog && dialog.open) {
      dialog.close();
    }
    document.body.style.overflow = "";
    dispatchCustomEvent("free-product-with-membership:close");
    onClose == null ? void 0 : onClose();
  };
  const handleAddToCart = () => {
    dispatchCustomEvent("free-product-with-membership:add-to-cart");
    onAddToCart == null ? void 0 : onAddToCart();
  };
  const handleSignIn = () => {
    dispatchCustomEvent("free-product-with-membership:sign-in");
    onSignIn == null ? void 0 : onSignIn();
  };
  const handlePayFullPrice = () => {
    dispatchCustomEvent("free-product-with-membership:pay-full-price");
    onPayFullPrice == null ? void 0 : onPayFullPrice();
  };
  if (!isOpen) {
    return null;
  }
  if (isLoading) {
    return u$1("dialog", {
      ref: dialogRef,
      className: "rs-fixed rs-inset-0 rs-z-[6000] rs-w-full rs-h-full rs-max-w-full rs-max-h-full rs-p-0 rs-m-0 rs-bg-black/50 backdrop:rs-bg-transparent",
      children: u$1("div", {
        className: "rs-flex rs-items-center rs-justify-center rs-min-h-full rs-p-4",
        children: u$1("div", {
          className: "rs-bg-[#baba00] rs-border rs-border-black rs-relative rs-rounded-lg rs-w-full rs-max-w-[672px] rs-h-auto rs-min-h-[500px] rs-overflow-hidden",
          children: u$1("div", {
            className: "rs-flex rs-items-center rs-justify-center rs-h-[500px]",
            children: u$1("div", {
              className: "rs-text-black rs-text-lg",
              children: ((_b = (_a = window.theme) == null ? void 0 : _a.settings) == null ? void 0 : _b.free_product_modal_loading_text) || "Loading..."
            }, void 0, false, {
              fileName: _jsxFileName$2,
              lineNumber: 137,
              columnNumber: 15
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$2,
            lineNumber: 136,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$2,
          lineNumber: 135,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$2,
        lineNumber: 134,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$2,
      lineNumber: 130,
      columnNumber: 7
    }, this);
  }
  return u$1("dialog", {
    ref: dialogRef,
    className: "rs-fixed rs-inset-0 rs-z-[6000] rs-w-full rs-h-full rs-max-w-full rs-max-h-full rs-p-0 rs-m-0 rs-bg-black/50 backdrop:rs-bg-transparent",
    onClick: handleBackdropClick,
    children: u$1("div", {
      className: "rs-flex rs-items-center rs-justify-center rs-min-h-full rs-p-4",
      children: u$1("div", {
        className: "rs-bg-[#baba00] rs-border rs-border-black rs-relative rs-rounded-lg rs-w-full rs-max-w-[672px] rs-h-auto rs-min-h-[500px] rs-overflow-hidden",
        onClick: (e) => {
          e.stopPropagation();
        },
        children: [u$1("button", {
          onClick: handleClose,
          className: "rs-absolute rs-top-[7.65px] rs-right-[7.65px] rs-w-[50.359px] rs-h-[50.359px] rs-flex rs-items-center rs-justify-center rs-z-10 rs-bg-transparent rs-border-none rs-cursor-pointer",
          "aria-label": "Close modal",
          children: u$1("div", {
            className: "rs-w-[35.613px] rs-h-[35.613px] rs-transform rs-rotate-45",
            children: u$1("svg", {
              width: "36",
              height: "36",
              viewBox: "0 0 36 36",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: u$1("path", {
                d: "M18 0L18 36M0 18L36 18",
                stroke: "black",
                strokeWidth: "2"
              }, void 0, false, {
                fileName: _jsxFileName$2,
                lineNumber: 174,
                columnNumber: 17
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$2,
              lineNumber: 167,
              columnNumber: 15
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$2,
            lineNumber: 166,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$2,
          lineNumber: 161,
          columnNumber: 11
        }, this), u$1("div", {
          className: "rs-flex rs-flex-col rs-items-center rs-justify-center rs-p-[78px_74px_50px] rs-gap-9 rs-min-h-full",
          children: [u$1("h3", {
            className: "rs-font-primary rs-text-[60px] rs-leading-[0.9] rs-tracking-[-3px] rs-text-black rs-text-center rs-font-normal",
            dangerouslySetInnerHTML: {
              __html: (() => {
                var _a2, _b2;
                const template = ((_b2 = (_a2 = window.theme) == null ? void 0 : _a2.settings) == null ? void 0 : _b2.free_product_modal_price_template) || "Pay {{crossed_price}} $0";
                const crossedPrice = `<span class="rs-line-through">$${productPrice}</span>`;
                return template.replace("{{crossed_price}}", crossedPrice).replace("{{product_price}}", productPrice);
              })()
            }
          }, void 0, false, {
            fileName: _jsxFileName$2,
            lineNumber: 187,
            columnNumber: 13
          }, this), u$1("div", {
            className: "rs-flex rs-flex-col rs-items-center rs-gap-3 rs-text-center",
            children: [u$1("p", {
              className: "rs-font-primary rs-text-[18px] rs-leading-[0.9] rs-tracking-[-0.9px] rs-text-black",
              children: ((_d = (_c = window.theme) == null ? void 0 : _c.settings) == null ? void 0 : _d.free_product_modal_subtitle) || "Join AF+ All Access to receive"
            }, void 0, false, {
              fileName: _jsxFileName$2,
              lineNumber: 202,
              columnNumber: 15
            }, this), u$1("p", {
              className: "rs-font-primary rs-text-[30px] rs-leading-[0.9] rs-tracking-[-1.5px] rs-text-black",
              children: ((_g = (_f = (_e = window.theme) == null ? void 0 : _e.settings) == null ? void 0 : _f.free_product_modal_product_template) == null ? void 0 : _g.replace("{{product_title}}", productTitle)) || `FREE ${productTitle}`
            }, void 0, false, {
              fileName: _jsxFileName$2,
              lineNumber: 205,
              columnNumber: 15
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$2,
            lineNumber: 201,
            columnNumber: 13
          }, this), u$1("div", {
            className: "rs-flex rs-items-center rs-justify-center rs-gap-5 rs-w-[261px]",
            children: [u$1("div", {
              className: "rs-w-[68px] rs-h-[53px] rs-bg-gray-600 rs-rounded rs-overflow-hidden rs-flex rs-items-center rs-justify-center",
              children: productImage ? u$1("img", {
                src: productImage,
                alt: productTitle,
                className: "rs-w-full rs-h-full rs-object-cover"
              }, void 0, false, {
                fileName: _jsxFileName$2,
                lineNumber: 215,
                columnNumber: 19
              }, this) : u$1("svg", {
                width: "40",
                height: "32",
                viewBox: "0 0 40 32",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: u$1("path", {
                  d: "M8 0C6.4 0 5 1.4 5 3V29C5 30.6 6.4 32 8 32H32C33.6 32 35 30.6 35 29V3C35 1.4 33.6 0 32 0H8ZM20 8C22.2 8 24 9.8 24 12C24 14.2 22.2 16 20 16C17.8 16 16 14.2 16 12C16 9.8 17.8 8 20 8ZM8 24V20L12 16L16 20L24 12L32 20V24H8Z",
                  fill: "white"
                }, void 0, false, {
                  fileName: _jsxFileName$2,
                  lineNumber: 228,
                  columnNumber: 21
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$2,
                lineNumber: 221,
                columnNumber: 19
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$2,
              lineNumber: 213,
              columnNumber: 15
            }, this), u$1("div", {
              className: "rs-w-[35.613px] rs-h-[35.613px]",
              children: u$1("svg", {
                width: "36",
                height: "36",
                viewBox: "0 0 36 36",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: u$1("path", {
                  d: "M18 0L18 36M0 18L36 18",
                  stroke: "black",
                  strokeWidth: "2"
                }, void 0, false, {
                  fileName: _jsxFileName$2,
                  lineNumber: 245,
                  columnNumber: 19
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$2,
                lineNumber: 238,
                columnNumber: 17
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$2,
              lineNumber: 237,
              columnNumber: 15
            }, this), u$1("svg", {
              width: "50",
              height: "49",
              viewBox: "0 0 50 49",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [u$1("path", {
                d: "M39.177 23.0124C39.177 23.3016 39.4115 23.5361 39.7008 23.5361H42.3029C42.5921 23.5361 42.8266 23.7706 42.8266 24.0599V25.5476C42.8266 25.8369 42.5921 26.0714 42.3029 26.0714H39.7008C39.4115 26.0714 39.177 26.3059 39.177 26.5952V29.6599C39.177 29.9492 38.9425 30.1837 38.6533 30.1837H37.0583C36.7691 30.1837 36.5346 29.9492 36.5346 29.6599V26.5952C36.5346 26.3059 36.3001 26.0714 36.0108 26.0714H33.3988C33.1095 26.0714 32.875 25.8369 32.875 25.5476V24.0599C32.875 23.7706 33.1095 23.5361 33.3988 23.5361H36.0108C36.3001 23.5361 36.5346 23.3016 36.5346 23.0124V20.1273C36.5346 19.838 36.7691 19.6035 37.0583 19.6035H38.6533C38.9425 19.6035 39.177 19.838 39.177 20.1273V23.0124Z",
                fill: "black"
              }, void 0, false, {
                fileName: _jsxFileName$2,
                lineNumber: 255,
                columnNumber: 17
              }, this), u$1("path", {
                d: "M14.003 19.5813C16.9662 19.4611 18.2953 22.4337 18.1994 24.6894C18.1798 25.1459 18.1537 25.6024 18.158 26.0588C18.1689 27.504 18.1842 28.9491 18.2234 30.3942C18.2321 30.7527 18.2757 31.109 18.3214 31.4631C18.3868 31.9752 18.2321 32.2335 17.6939 32.189C16.8464 32.1199 15.9901 32.1044 15.1491 31.9841C14.9486 31.9552 14.7111 31.639 14.6261 31.4052C14.3669 30.6926 14.2797 30.6481 13.7917 31.1736C12.7131 32.3315 11.3601 32.5608 9.89593 32.3248C9.3229 32.2313 8.76948 32.0175 8.20952 31.8483C6.68217 31.3851 6.20719 29.842 6.42507 28.4503C6.81508 25.9742 8.25746 25.2372 10.8176 24.9588C11.6412 24.8698 12.4713 24.8096 13.2796 24.6382C13.6587 24.558 14.247 24.3175 14.2862 24.0392C14.3603 23.5204 14.088 22.8769 13.7372 22.5184C12.9071 21.6678 11.2991 21.975 10.8154 23.0617C10.5234 23.7163 10.1487 23.7297 9.51028 23.7943C8.87188 23.8588 8.29667 23.8277 7.69314 23.89C6.96106 23.9657 6.72792 23.723 6.91966 23.0305C7.50141 20.9263 8.93071 19.7528 11.0856 19.6103C11.6956 19.5702 12.3101 19.5457 12.9201 19.5234C13.2883 19.5346 13.6348 19.5947 14.0008 19.5813H14.003ZM12.0377 29.9088C13.4627 29.8999 14.6392 28.5817 14.4802 27.1922C14.43 26.7513 14.2165 26.4596 13.7808 26.5398C12.9942 26.6845 12.2033 26.8471 11.4472 27.1076C10.6433 27.386 10.1748 28.172 10.3143 28.7977C10.4472 29.3989 11.2468 29.9155 12.0355 29.9088H12.0377Z",
                fill: "black"
              }, void 0, false, {
                fileName: _jsxFileName$2,
                lineNumber: 256,
                columnNumber: 17
              }, this), u$1("path", {
                d: "M29.7398 23.4048C29.7242 22.9192 29.3164 22.9516 28.6735 22.9354C27.4347 22.903 27.121 22.8545 25.8822 22.8383C24.0004 22.8059 24.0161 22.9192 24.0631 20.9443C24.0631 20.2806 24.3611 20.0378 24.9413 20.054C25.7881 20.054 26.6349 20.0702 27.4974 20.0864C28.2815 20.1026 29.0499 20.1997 29.8339 20.1511C30.0692 20.1511 30.4612 19.9407 30.4926 19.5846C30.5553 18.8723 30.571 18.1439 30.6023 17.4316C30.618 16.9136 30.3357 16.7355 29.881 16.7193C26.7133 16.6708 23.5613 16.6546 20.4093 16.5898C19.8291 16.5898 19.6252 16.8003 19.6095 17.3669C19.6095 18.9532 19.5625 20.5396 19.5625 22.126C19.5625 25.2017 19.5939 28.2935 19.5625 31.3692C19.5625 32.049 19.8761 32.2433 20.4407 32.2757C21.3188 32.3242 22.1813 32.3566 23.0595 32.4052C23.8436 32.4375 24.1102 32.1624 24.0945 31.353C24.0788 29.9608 24.0788 28.5687 24.0474 27.1766C24.0474 26.5452 24.3297 26.2377 24.9099 26.2377C25.8038 26.2377 26.7133 26.3186 27.6071 26.2862C28.2501 26.2701 28.6265 26.3186 29.1753 26.3024C29.3948 26.3024 29.5673 26.3186 29.6301 25.7197C29.6771 25.1855 29.7555 24.1495 29.7242 23.3887L29.7398 23.4048Z",
                fill: "black"
              }, void 0, false, {
                fileName: _jsxFileName$2,
                lineNumber: 257,
                columnNumber: 17
              }, this), u$1("circle", {
                cx: "24.8066",
                cy: "24.5",
                r: "23.3301",
                stroke: "black",
                "stroke-width": "2"
              }, void 0, false, {
                fileName: _jsxFileName$2,
                lineNumber: 258,
                columnNumber: 17
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$2,
              lineNumber: 254,
              columnNumber: 15
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$2,
            lineNumber: 211,
            columnNumber: 13
          }, this), u$1("div", {
            className: "rs-flex rs-flex-col rs-items-center rs-gap-6 rs-w-[296px]",
            children: [u$1("div", {
              className: "rs-flex rs-flex-col rs-items-center rs-gap-4 rs-w-full",
              children: [u$1("button", {
                onClick: handleAddToCart,
                className: "rs-w-full rs-bg-black rs-text-white rs-rounded-lg rs-px-[18px] rs-py-3.5 rs-font-primary rs-font-bold rs-text-[12px] rs-uppercase rs-tracking-wide hover:rs-bg-gray-800 rs-transition-colors",
                children: ((_i = (_h = window.theme) == null ? void 0 : _h.settings) == null ? void 0 : _i.free_product_modal_button) || "ADD TO CART"
              }, void 0, false, {
                fileName: _jsxFileName$2,
                lineNumber: 266,
                columnNumber: 17
              }, this), u$1("p", {
                className: "rs-font-primary rs-text-[14px] rs-text-black rs-text-center",
                children: [((_k = (_j = window.theme) == null ? void 0 : _j.settings) == null ? void 0 : _k.free_product_modal_sign_in_text) || "Already a Quarterly member?", " ", u$1("button", {
                  onClick: handleSignIn,
                  className: "rs-underline rs-bg-transparent rs-border-none rs-cursor-pointer rs-font-primary rs-text-[14px] rs-text-black hover:rs-opacity-70 rs-transition-opacity",
                  children: ((_m = (_l = window.theme) == null ? void 0 : _l.settings) == null ? void 0 : _m.free_product_modal_sign_in_link) || "Sign in"
                }, void 0, false, {
                  fileName: _jsxFileName$2,
                  lineNumber: 276,
                  columnNumber: 19
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName$2,
                lineNumber: 274,
                columnNumber: 17
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$2,
              lineNumber: 264,
              columnNumber: 15
            }, this), u$1("button", {
              onClick: handlePayFullPrice,
              className: "rs-underline rs-bg-transparent rs-border-none rs-cursor-pointer rs-font-primary rs-text-[14px] rs-text-black hover:rs-opacity-70 rs-transition-opacity rs-tracking-[-0.42px]",
              children: ((_o = (_n2 = window.theme) == null ? void 0 : _n2.settings) == null ? void 0 : _o.free_product_modal_pay_full_price) || "I prefer to pay full price"
            }, void 0, false, {
              fileName: _jsxFileName$2,
              lineNumber: 286,
              columnNumber: 15
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$2,
            lineNumber: 263,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$2,
          lineNumber: 184,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$2,
        lineNumber: 154,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$2,
      lineNumber: 153,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$2,
    lineNumber: 148,
    columnNumber: 5
  }, this);
}
register(FreeProductWithMembershipModal, "free-product-with-membership-modal", ["is-open", "product-title", "product-image", "product-price"], {
  shadow: false
});
var _jsxFileName$1 = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/components/MembershipUpgradeModal.tsx";
function MembershipUpgradeModal({
  "is-open": isOpen = false,
  onClose,
  onAddMembership,
  onSignIn,
  onPayFullPrice,
  "product-title": productTitle = "this product",
  "product-handle": productHandle = "",
  "membership-status": membershipStatus = "not-member"
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n2;
  const dialogRef = t$1(A$1(null), "dialogRef");
  const [isLoading, setIsLoading] = t$1(d$1(false), "isLoading");
  const isModalOpen = typeof isOpen === "string" ? isOpen === "true" : isOpen;
  const isSubscriptionProduct = () => {
    var _a2, _b2;
    if (((_b2 = (_a2 = window.product) == null ? void 0 : _a2.selling_plan_groups) == null ? void 0 : _b2.length) > 0) {
      return true;
    }
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]:checked, select[name="selling_plan"]');
    if (sellingPlanInput == null ? void 0 : sellingPlanInput.value) {
      return true;
    }
    return false;
  };
  if (isSubscriptionProduct()) {
    return null;
  }
  const isUpgradable = membershipStatus === "upgradable";
  const buttonText = isUpgradable ? "UPGRADE MEMBERSHIP" : "ADD MEMBERSHIP";
  const loadingText = isUpgradable ? "UPGRADING..." : "ADDING...";
  y$1(() => {
    const dialog = dialogRef.current;
    if (!dialog) {
      return;
    }
    if (isModalOpen && !dialog.open) {
      try {
        dialog.showModal();
        document.body.style.overflow = "hidden";
      } catch (error) {
        dialog.setAttribute("open", "");
        dialog.style.display = "flex";
        document.body.style.overflow = "hidden";
      }
    } else if (!isModalOpen && dialog.open) {
      dialog.close();
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      if (dialog.open) {
        dialog.close();
      }
    };
  }, [isModalOpen]);
  const handleBackdropClick = (e) => {
    const dialog = dialogRef.current;
    if (dialog && e.target === dialog) {
      handleClose();
    }
  };
  const handleClose = () => {
    const dialog = dialogRef.current;
    if (dialog && dialog.open) {
      dialog.close();
    }
    document.body.style.overflow = "";
    onClose == null ? void 0 : onClose();
  };
  const handleAddMembership = async () => {
    setIsLoading(true);
    try {
      await (onAddMembership == null ? void 0 : onAddMembership());
      handleClose();
    } catch (error) {
      console.error("Error adding membership:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSignIn = () => {
    onSignIn == null ? void 0 : onSignIn();
    handleClose();
  };
  const handlePayFullPrice = () => {
    onPayFullPrice == null ? void 0 : onPayFullPrice();
    handleClose();
  };
  if (!isModalOpen) {
    return null;
  }
  return u$1("dialog", {
    ref: dialogRef,
    className: "rs-fixed rs-inset-0 rs-z-[6000] rs-w-full rs-h-full rs-max-w-full rs-max-h-full rs-p-0 rs-m-0 rs-bg-black/50 backdrop:rs-bg-transparent",
    onClick: handleBackdropClick,
    children: u$1("div", {
      className: "rs-flex rs-items-center rs-justify-center rs-min-h-full rs-p-4",
      children: u$1("div", {
        className: "rs-bg-black rs-relative rs-rounded-lg rs-w-full rs-max-w-[672px] rs-h-auto rs-border rs-border-white rs-border-solid lg:rs-pt-[78px] lg:rs-pb-[50px] lg:rs-px-[74px] rs-px-6 rs-py-[92px]",
        onClick: (e) => {
          e.stopPropagation();
        },
        children: [u$1("button", {
          onClick: handleClose,
          className: "rs-absolute rs-top-[8.15px] rs-right-[8.15px] rs-w-[50.359px] rs-h-[50.359px] rs-flex rs-items-center rs-justify-center rs-z-10 rs-bg-transparent rs-border-none rs-cursor-pointer rs-transform rs-rotate-45",
          "aria-label": "Close modal",
          children: u$1("div", {
            className: "rs-w-[35.613px] rs-h-[35.613px]",
            children: u$1("svg", {
              width: "36",
              height: "36",
              viewBox: "0 0 36 36",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: u$1("path", {
                d: "M18 0L18 36M0 18L36 18",
                stroke: "white",
                strokeWidth: "2"
              }, void 0, false, {
                fileName: _jsxFileName$1,
                lineNumber: 160,
                columnNumber: 19
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$1,
              lineNumber: 153,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 152,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$1,
          lineNumber: 147,
          columnNumber: 13
        }, this), u$1("div", {
          className: "rs-flex rs-flex-col rs-gap-9 rs-items-center rs-justify-start rs-p-0 rs-mx-auto",
          children: [u$1("div", {
            className: "rs-flex rs-flex-col rs-justify-end rs-leading-[0.9] rs-min-w-full",
            children: u$1("p", {
              className: "rs-block rs-leading-[0.9] rs-font-normal rs-text-white rs-text-[60px] rs-text-center rs-tracking-[-3px] rs-font-primary",
              children: ((_b = (_a = window.theme) == null ? void 0 : _a.settings) == null ? void 0 : _b.membership_upgrade_modal_title) || "Save 30%"
            }, void 0, false, {
              fileName: _jsxFileName$1,
              lineNumber: 173,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 172,
            columnNumber: 15
          }, this), u$1("div", {
            className: "rs-flex rs-flex-col rs-gap-3 rs-items-start rs-justify-center rs-p-0 rs-w-full",
            children: u$1("div", {
              className: "rs-font-normal rs-leading-[0.9] rs-text-white rs-text-[18px] rs-text-center rs-tracking-[-0.9px] rs-w-full rs-font-primary",
              children: u$1("p", {
                className: "rs-block rs-leading-[0.9]",
                children: ((_d = (_c = window.theme) == null ? void 0 : _c.settings) == null ? void 0 : _d.membership_upgrade_modal_subtitle) || "Become a Member to get 30% off every order."
              }, void 0, false, {
                fileName: _jsxFileName$1,
                lineNumber: 181,
                columnNumber: 19
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$1,
              lineNumber: 180,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 179,
            columnNumber: 15
          }, this), u$1("div", {
            className: "rs-flex rs-flex-row rs-gap-5 rs-items-center rs-justify-center rs-p-0 rs-w-[261px]",
            children: u$1("div", {
              className: "rs-relative rs-shrink-0 rs-w-[44.66px] rs-h-[44.66px]",
              children: u$1("div", {
                className: "rs-absolute rs-inset-[-4.478%]",
                children: u$1("svg", {
                  width: "50",
                  height: "49",
                  viewBox: "0 0 50 49",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [u$1("path", {
                    d: "M39.3723 22.8444C39.3723 23.1337 39.6068 23.3682 39.8961 23.3682H42.4982C42.7874 23.3682 43.0219 23.6027 43.0219 23.8919V25.3796C43.0219 25.6689 42.7874 25.9034 42.4982 25.9034H39.8961C39.6068 25.9034 39.3723 26.1379 39.3723 26.4272V29.4919C39.3723 29.7812 39.1378 30.0157 38.8486 30.0157H37.2536C36.9644 30.0157 36.7299 29.7812 36.7299 29.4919V26.4272C36.7299 26.1379 36.4954 25.9034 36.2061 25.9034H33.5941C33.3048 25.9034 33.0703 25.6689 33.0703 25.3796V23.8919C33.0703 23.6027 33.3048 23.3682 33.5941 23.3682H36.2061C36.4954 23.3682 36.7299 23.1337 36.7299 22.8444V19.9593C36.7299 19.67 36.9644 19.4355 37.2536 19.4355H38.8486C39.1378 19.4355 39.3723 19.67 39.3723 19.9593V22.8444Z",
                    fill: "white"
                  }, void 0, false, {
                    fileName: _jsxFileName$1,
                    lineNumber: 192,
                    columnNumber: 23
                  }, this), u$1("path", {
                    d: "M14.1983 19.4134C17.1615 19.2931 18.4906 22.2658 18.3947 24.5214C18.3751 24.9779 18.349 25.4344 18.3533 25.8909C18.3642 27.336 18.3795 28.7811 18.4187 30.2263C18.4274 30.5848 18.471 30.941 18.5167 31.2951C18.5821 31.8072 18.4274 32.0655 17.8892 32.021C17.0417 31.952 16.1854 31.9364 15.3444 31.8161C15.1439 31.7872 14.9064 31.471 14.8215 31.2372C14.5622 30.5246 14.475 30.4801 13.987 31.0056C12.9085 32.1635 11.5554 32.3929 10.0912 32.1568C9.51821 32.0633 8.96479 31.8495 8.40483 31.6803C6.87748 31.2172 6.4025 29.674 6.62038 28.2824C7.01039 25.8062 8.45277 25.0692 11.0129 24.7909C11.8365 24.7018 12.6666 24.6417 13.4749 24.4702C13.8541 24.3901 14.4423 24.1496 14.4816 23.8712C14.5556 23.3524 14.2833 22.7089 13.9325 22.3504C13.1024 21.4998 11.4944 21.8071 11.0107 22.8937C10.7187 23.5484 10.344 23.5617 9.70559 23.6263C9.0672 23.6909 8.49199 23.6597 7.88845 23.722C7.15637 23.7978 6.92324 23.555 7.11497 22.8625C7.69672 20.7583 9.12602 19.5848 11.2809 19.4423C11.8909 19.4022 12.5054 19.3777 13.1154 19.3555C13.4837 19.3666 13.8301 19.4267 14.1961 19.4134H14.1983ZM12.233 29.7408C13.658 29.7319 14.8345 28.4137 14.6755 27.0243C14.6254 26.5834 14.4118 26.2917 13.9761 26.3718C13.1895 26.5166 12.3986 26.6791 11.6426 26.9396C10.8386 27.218 10.3701 28.004 10.5096 28.6297C10.6425 29.2309 11.4421 29.7475 12.2308 29.7408H12.233Z",
                    fill: "white"
                  }, void 0, false, {
                    fileName: _jsxFileName$1,
                    lineNumber: 193,
                    columnNumber: 23
                  }, this), u$1("path", {
                    d: "M29.9352 23.2369C29.9195 22.7512 29.5118 22.7836 28.8688 22.7674C27.63 22.7351 27.3163 22.6865 26.0775 22.6703C24.1957 22.6379 24.2114 22.7512 24.2584 20.7764C24.2584 20.1127 24.5564 19.8698 25.1366 19.886C25.9834 19.886 26.8302 19.9022 27.6927 19.9184C28.4768 19.9346 29.2452 20.0317 30.0292 19.9832C30.2645 19.9832 30.6565 19.7727 30.6879 19.4166C30.7506 18.7043 30.7663 17.9759 30.7976 17.2636C30.8133 16.7456 30.5311 16.5676 30.0763 16.5514C26.9086 16.5028 23.7566 16.4866 20.6046 16.4219C20.0244 16.4219 19.8205 16.6323 19.8049 17.1989C19.8049 18.7853 19.7578 20.3717 19.7578 21.958C19.7578 25.0337 19.7892 28.1255 19.7578 31.2012C19.7578 31.8811 20.0714 32.0753 20.636 32.1077C21.5141 32.1563 22.3766 32.1886 23.2548 32.2372C24.0389 32.2696 24.3055 31.9944 24.2898 31.185C24.2741 29.7929 24.2741 28.4007 24.2427 27.0086C24.2427 26.3773 24.525 26.0697 25.1052 26.0697C25.9991 26.0697 26.9086 26.1506 27.8025 26.1183C28.4454 26.1021 28.8218 26.1506 29.3706 26.1345C29.5902 26.1345 29.7627 26.1506 29.8254 25.5517C29.8724 25.0175 29.9508 23.9815 29.9195 23.2207L29.9352 23.2369Z",
                    fill: "white"
                  }, void 0, false, {
                    fileName: _jsxFileName$1,
                    lineNumber: 194,
                    columnNumber: 23
                  }, this), u$1("circle", {
                    cx: "25.002",
                    cy: "24.3301",
                    r: "23.3301",
                    stroke: "white",
                    "stroke-width": "2"
                  }, void 0, false, {
                    fileName: _jsxFileName$1,
                    lineNumber: 195,
                    columnNumber: 23
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$1,
                  lineNumber: 191,
                  columnNumber: 21
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$1,
                lineNumber: 190,
                columnNumber: 19
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$1,
              lineNumber: 189,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 188,
            columnNumber: 15
          }, this), u$1("div", {
            className: "rs-flex rs-flex-col rs-gap-6 rs-items-center rs-justify-start rs-p-0 rs-w-[296px]",
            children: [u$1("div", {
              className: "rs-flex rs-flex-col rs-gap-4 rs-items-center rs-justify-start rs-p-0 rs-w-full",
              children: [u$1("div", {
                className: "rs-flex rs-flex-row rs-gap-4 rs-items-start rs-justify-start rs-p-0 rs-w-full",
                children: u$1("button", {
                  onClick: handleAddMembership,
                  disabled: isLoading,
                  className: "rs-basis-0 rs-bg-[#baba00] rs-flex rs-flex-row rs-gap-[3px] rs-grow rs-items-center rs-justify-center rs-min-h-px rs-min-w-px rs-px-[18px] rs-py-3.5 rs-rounded-lg rs-shrink-0 rs-border-none rs-cursor-pointer disabled:rs-opacity-50 disabled:rs-cursor-not-allowed",
                  children: u$1("div", {
                    className: "rs-font-bold rs-leading-[1.1] rs-text-black rs-text-[12px] rs-text-center rs-whitespace-nowrap rs-uppercase rs-font-primary",
                    children: isLoading ? ((_f = (_e = window.theme) == null ? void 0 : _e.settings) == null ? void 0 : _f.membership_upgrade_modal_loading_text) || loadingText : ((_h = (_g = window.theme) == null ? void 0 : _g.settings) == null ? void 0 : _h.membership_upgrade_modal_button) || buttonText
                  }, void 0, false, {
                    fileName: _jsxFileName$1,
                    lineNumber: 212,
                    columnNumber: 23
                  }, this)
                }, void 0, false, {
                  fileName: _jsxFileName$1,
                  lineNumber: 207,
                  columnNumber: 21
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$1,
                lineNumber: 206,
                columnNumber: 19
              }, this), u$1("div", {
                className: "rs-font-normal rs-leading-[1.4] rs-text-white rs-text-[14px] rs-text-center rs-w-full rs-font-primary",
                children: u$1("p", {
                  className: "rs-leading-[1.4] rs-whitespace-pre-wrap",
                  children: [u$1("span", {
                    children: [((_j = (_i = window.theme) == null ? void 0 : _i.settings) == null ? void 0 : _j.membership_upgrade_modal_sign_in_text) || "Already a member?", " "]
                  }, void 0, true, {
                    fileName: _jsxFileName$1,
                    lineNumber: 221,
                    columnNumber: 23
                  }, this), u$1("button", {
                    onClick: handleSignIn,
                    className: "rs-underline hover:rs-no-underline rs-bg-transparent rs-border-none rs-cursor-pointer rs-text-white rs-font-normal rs-text-[14px] rs-font-primary",
                    children: ((_l = (_k = window.theme) == null ? void 0 : _k.settings) == null ? void 0 : _l.membership_upgrade_modal_sign_in_link) || "Sign in"
                  }, void 0, false, {
                    fileName: _jsxFileName$1,
                    lineNumber: 222,
                    columnNumber: 23
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$1,
                  lineNumber: 220,
                  columnNumber: 21
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName$1,
                lineNumber: 219,
                columnNumber: 19
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$1,
              lineNumber: 204,
              columnNumber: 17
            }, this), u$1("div", {
              className: "rs-flex rs-justify-center rs-font-normal rs-leading-[1.4] rs-text-white rs-text-center rs-tracking-[-0.42px] rs-w-full rs-font-primary",
              children: u$1("button", {
                onClick: handlePayFullPrice,
                className: "rs-underline hover:rs-no-underline rs-bg-transparent rs-border-none rs-cursor-pointer rs-block rs-leading-[1.4] rs-text-[14px] rs-font-normal rs-font-primary rs-text-white",
                children: ((_n2 = (_m = window.theme) == null ? void 0 : _m.settings) == null ? void 0 : _n2.membership_upgrade_modal_pay_full_price) || "I prefer to pay full price"
              }, void 0, false, {
                fileName: _jsxFileName$1,
                lineNumber: 234,
                columnNumber: 19
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName$1,
              lineNumber: 233,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$1,
            lineNumber: 202,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1,
          lineNumber: 170,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1,
        lineNumber: 140,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$1,
      lineNumber: 139,
      columnNumber: 9
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$1,
    lineNumber: 134,
    columnNumber: 7
  }, this);
}
register(MembershipUpgradeModal, "membership-upgrade-modal", ["is-open", "product-title", "product-handle", "onClose", "onAddMembership", "onSignIn", "onPayFullPrice"], {
  shadow: false
});
var _jsxFileName = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/components/MembershipAddToCartHandler.tsx";
function MembershipAddToCartHandler({
  "product-form-id": productFormId,
  "is-membership-product": isMembershipProduct = "false",
  class: className = ""
}) {
  const [validationMessage, setValidationMessage] = t$1(d$1(""), "validationMessage");
  const [messageType, setMessageType] = t$1(d$1("cart-change"), "messageType");
  const [isValidating, setIsValidating] = t$1(d$1(false), "isValidating");
  const isEnabled = isMembershipProduct === "true";
  y$1(() => {
    if (!isEnabled) return;
    console.log("[MembershipHandler] Component enabled for form:", productFormId);
    const handleFormSubmit = async (e) => {
      const form = e.target;
      if (form.id !== productFormId) return;
      console.log("[MembershipHandler] Form submit intercepted:", form.id);
      if (form.hasAttribute("data-membership-validating")) {
        console.log("[MembershipHandler] Already validating, allowing submission");
        return;
      }
      const formData = new FormData(form);
      const sellingPlanId = formData.get("selling_plan");
      console.log("[MembershipHandler] Selling plan ID found:", sellingPlanId);
      if (!sellingPlanId) {
        console.log("[MembershipHandler] No selling plan found, allowing normal submission");
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      form.setAttribute("data-membership-validating", "true");
      setIsValidating(true);
      try {
        const validation = await membershipTierValidator.validateMembershipAddToCart(parseInt(sellingPlanId.toString()));
        console.log("[MembershipHandler] Validation result:", validation);
        if (validation.canAddToCart) {
          setValidationMessage("");
          setIsValidating(false);
          form.removeAttribute("data-membership-validating");
          console.log("[MembershipHandler] Validation passed, submitting form");
          form.dispatchEvent(new Event("submit", {
            bubbles: true,
            cancelable: false
          }));
        } else {
          setValidationMessage(validation.reason);
          setMessageType(validation.messageType);
          setIsValidating(false);
          form.removeAttribute("data-membership-validating");
          console.log("[MembershipHandler] Validation failed:", validation.reason);
          const addToCartButton = form.querySelector("[data-add-to-cart]");
          if (addToCartButton) {
            addToCartButton.disabled = true;
            addToCartButton.setAttribute("data-membership-blocked", "true");
            console.log("[MembershipHandler] Button disabled");
          }
        }
      } catch (error) {
        console.error("[MembershipHandler] Error validating membership:", error);
        setValidationMessage("Unable to validate membership. Please try again.");
        setMessageType("cart-change");
        setIsValidating(false);
        form.removeAttribute("data-membership-validating");
      }
    };
    const handleSellingPlanChange = () => {
      console.log("[MembershipHandler] Selling plan changed, resetting validation");
      setValidationMessage("");
      const form = document.getElementById(productFormId);
      if (form) {
        const addToCartButton = form.querySelector("[data-add-to-cart]");
        if (addToCartButton && addToCartButton.hasAttribute("data-membership-blocked")) {
          addToCartButton.disabled = false;
          addToCartButton.removeAttribute("data-membership-blocked");
          console.log("[MembershipHandler] Button re-enabled");
        }
      }
    };
    document.addEventListener("submit", handleFormSubmit);
    document.addEventListener("change", (e) => {
      const target = e.target;
      if (target.matches('input[name="selling_plan"], select[name="selling_plan"]')) {
        handleSellingPlanChange();
      }
    });
    return () => {
      document.removeEventListener("submit", handleFormSubmit);
    };
  }, [isEnabled, productFormId]);
  y$1(() => {
    if (!isEnabled) return;
    const validateExistingCart = async () => {
      try {
        const cartValidation = await membershipTierValidator.validateCart();
        if (!cartValidation.isValid && cartValidation.errors.length > 0) {
          console.warn("Cart validation errors:", cartValidation.errors);
        }
      } catch (error) {
        console.error("Error validating existing cart:", error);
      }
    };
    validateExistingCart();
  }, [isEnabled]);
  if (!isEnabled || !validationMessage && !isValidating) {
    return null;
  }
  return u$1("div", {
    className: `membership-validation-message rs-mt-4 rs-p-4 rs-border rs-rounded-lg ${className}`,
    children: isValidating ? u$1("div", {
      className: "rs-flex rs-items-center rs-text-yellow-700 rs-bg-yellow-50 rs-border-yellow-200",
      children: [u$1("div", {
        className: "rs-animate-spin rs-mr-3 rs-h-5 rs-w-5 rs-border-2 rs-border-yellow-600 rs-border-t-transparent rs-rounded-full"
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 154,
        columnNumber: 11
      }, this), u$1("span", {
        children: "Validating membership..."
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 155,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 153,
      columnNumber: 9
    }, this) : u$1("div", {
      className: `
          rs-flex rs-items-center rs-space-x-3
          ${messageType === "cart-change" ? "rs-text-orange-700 rs-bg-orange-50 rs-border-orange-200" : "rs-text-red-700 rs-bg-red-50 rs-border-red-200"}
        `,
      children: [u$1("div", {
        className: "rs-flex-shrink-0",
        children: u$1("svg", {
          className: "rs-h-5 rs-w-5",
          viewBox: "0 0 20 20",
          fill: "currentColor",
          children: u$1("path", {
            fillRule: "evenodd",
            d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
            clipRule: "evenodd"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 167,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 166,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 165,
        columnNumber: 11
      }, this), u$1("div", {
        className: "rs-flex-1",
        children: [u$1("p", {
          className: "rs-font-medium",
          children: validationMessage
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 171,
          columnNumber: 13
        }, this), messageType === "account-upgrade" && u$1("p", {
          className: "rs-mt-1 rs-text-sm rs-opacity-90",
          children: "Visit your account to manage your current membership."
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 173,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 170,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 158,
      columnNumber: 9
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 151,
    columnNumber: 5
  }, this);
}
register(MembershipAddToCartHandler, "membership-add-to-cart-handler", ["product-form-id", "is-membership-product", "class"], {
  shadow: false
});
function morph(from, to) {
  if (!from || !to) {
    console.warn("morph: Invalid elements provided");
    return;
  }
  morphAttributes(from, to);
  morphChildren(from, to);
}
function morphAttributes(from, to) {
  for (const attr of Array.from(from.attributes)) {
    if (!to.hasAttribute(attr.name)) {
      from.removeAttribute(attr.name);
    }
  }
  for (const attr of Array.from(to.attributes)) {
    if (from.getAttribute(attr.name) !== attr.value) {
      from.setAttribute(attr.name, attr.value);
    }
  }
}
function morphChildren(from, to) {
  const fromChildren = Array.from(from.children);
  const toChildren = Array.from(to.children);
  if (fromChildren.length !== toChildren.length || !childrenStructureMatches(fromChildren, toChildren)) {
    from.innerHTML = to.innerHTML;
    return;
  }
  for (let i2 = 0; i2 < fromChildren.length; i2++) {
    const fromChild = fromChildren[i2];
    const toChild = toChildren[i2];
    if (fromChild.tagName === toChild.tagName) {
      morph(fromChild, toChild);
    } else {
      fromChild.replaceWith(toChild.cloneNode(true));
    }
  }
}
function childrenStructureMatches(fromChildren, toChildren) {
  if (fromChildren.length !== toChildren.length) {
    return false;
  }
  return fromChildren.every((child, index) => {
    const toChild = toChildren[index];
    return child.tagName === toChild.tagName && child.id === toChild.id && child.className === toChild.className;
  });
}
class VariantSelectedEvent extends CustomEvent {
  constructor(detail) {
    super("variant:selected", {
      detail,
      bubbles: true,
      cancelable: true
    });
  }
}
class VariantUpdateEvent extends CustomEvent {
  constructor(productData, selectedOptionId, meta = {}) {
    super("variant:update", {
      detail: {
        productData,
        selectedOptionId,
        meta
      },
      bubbles: true,
      cancelable: true
    });
  }
}
class VariantPicker extends HTMLElement {
  constructor() {
    super(...arguments);
    /** @type {string | undefined} */
    __privateAdd(this, _pendingRequestUrl);
    /** @type {AbortController | undefined} */
    __privateAdd(this, _abortController);
    /** @type {HTMLElement | undefined} */
    __privateAdd(this, _productForm);
  }
  connectedCallback() {
    __privateSet(this, _productForm, this.closest("product-form"));
    this.addEventListener("change", this.variantChanged.bind(this));
    this.initializeDataAttributes();
    this.initializeInventoryStates();
    this.setupUnavailableOptionHandling();
    this.patchThemeMethods();
  }
  /**
   * Set up handling for unavailable options without breaking existing theme functionality
   */
  setupUnavailableOptionHandling() {
    if (this._unavailableHandlingSetup) return;
    const productForm = this.closest("product-form");
    if (productForm && productForm.productForm && productForm.productForm.onOptionChange) {
      const originalOnOptionChange = productForm.productForm.onOptionChange;
      this._unavailableHandlingSetup = true;
      productForm.productForm.onOptionChange = (evt) => {
        const input = evt.target;
        if (input && input.matches("[data-single-option-selector]")) {
          const wrapper = input.closest(".swatch-wrapper, .radio-wrapper");
          const isUnavailable = wrapper == null ? void 0 : wrapper.hasAttribute("data-unavailable");
          if (isUnavailable) {
            this.handleUnavailableSelection(input);
            return;
          }
        }
        if (originalOnOptionChange) {
          originalOnOptionChange.call(productForm.productForm, evt);
        }
      };
    } else {
      if (!this._setupAttempts) this._setupAttempts = 0;
      if (this._setupAttempts < 5) {
        this._setupAttempts++;
        setTimeout(() => {
          this.setupUnavailableOptionHandling();
        }, 200 * this._setupAttempts);
      } else {
        console.warn("Could not set up unavailable option handling - product form not found");
      }
    }
  }
  /**
   * Handle unavailable option selections
   * @param {HTMLElement} input - The selected input
   */
  handleUnavailableSelection(input) {
    input.checked = true;
    const customEvent = new CustomEvent("unavailable-variant-selected", {
      detail: {
        input,
        value: input.value,
        optionName: input.name,
        wrapper: input.closest(".swatch-wrapper, .radio-wrapper")
      },
      bubbles: true,
      cancelable: false
    });
    input.dispatchEvent(customEvent);
    const form = input.closest("form");
    if (form) {
      form.dispatchEvent(new CustomEvent("unavailable-option-selected", {
        detail: {
          input,
          value: input.value,
          optionName: input.name
        },
        bubbles: true
      }));
    }
    this.updateNotifyMeElements(input);
  }
  /**
   * Update notify me elements when unavailable option is selected
   * @param {HTMLElement} input - The selected input
   */
  updateNotifyMeElements(input) {
    const notifyMeButtons = this.querySelectorAll('[data-notify-me], .notify-me-button, [class*="notify"]');
    notifyMeButtons.forEach((button) => {
      button.style.display = "block";
      button.removeAttribute("hidden");
      if (button.dataset.unavailableOption !== input.value) {
        button.dataset.unavailableOption = input.value;
        button.dataset.unavailableVariant = "true";
      }
    });
    const addToCartButtons = document.querySelectorAll('[data-add-to-cart], .btn-add-to-cart, [name="add"]');
    addToCartButtons.forEach((button) => {
      button.dataset.selectedUnavailable = "true";
      button.classList.add("variant-unavailable");
    });
  }
  disconnectedCallback() {
    var _a;
    (_a = __privateGet(this, _abortController)) == null ? void 0 : _a.abort();
    if (this.urlUpdateTimeout) {
      clearTimeout(this.urlUpdateTimeout);
      this.urlUpdateTimeout = null;
    }
    this._unavailableHandlingSetup = false;
    this._setupAttempts = 0;
  }
  /**
   * Initialize data attributes from the current theme's structure
   */
  initializeDataAttributes() {
    const productScript = document.querySelector("[data-product-json]");
    if (productScript) {
      try {
        const productData = JSON.parse(productScript.textContent);
        if (!this.dataset.productId) {
          this.dataset.productId = productData.id;
        }
        if (!this.dataset.productUrl) {
          this.dataset.productUrl = window.location.pathname;
        }
        this.initialProductData = productData;
      } catch (e) {
        console.warn("Failed to parse product data:", e);
      }
    }
    if (!this.dataset.templateProductMatch) {
      this.dataset.templateProductMatch = window.location.pathname.includes("/products/") ? "true" : "false";
    }
  }
  /**
   * Initialize inventory states on component load
   */
  initializeInventoryStates() {
    requestAnimationFrame(() => {
      this.applyInitialInventoryStates();
    });
    setTimeout(() => {
      this.applyInitialInventoryStates();
    }, 100);
  }
  /**
   * Apply initial inventory states
   */
  applyInitialInventoryStates() {
    let productData = this.initialProductData;
    if (!productData) {
      const variantPickerScript = this.querySelector("script[data-variant-picker-product]");
      if (variantPickerScript && variantPickerScript.textContent) {
        try {
          productData = JSON.parse(variantPickerScript.textContent);
        } catch (e) {
          console.warn("Failed to parse variant picker product data:", e);
        }
      }
    }
    if (!productData) {
      const globalProductScript = document.querySelector("[data-product-json]");
      if (globalProductScript && globalProductScript.textContent) {
        try {
          productData = JSON.parse(globalProductScript.textContent);
        } catch (e) {
          console.warn("Failed to parse global product data:", e);
        }
      }
    }
    if (productData && productData.variants) {
      this.updateOptionAvailability(productData);
      this.updateVariantButtonStates(productData);
      this.updateManualSelloutStates(productData);
    } else {
      console.warn("No product data available for initial inventory states");
    }
  }
  /**
   * Handles the variant change event.
   * @param {Event} event - The variant change event.
   */
  variantChanged(event) {
    var _a;
    if (!(event.target instanceof HTMLElement)) return;
    const selectedOption = this.getSelectedOptionFromEvent(event);
    if (!selectedOption) return;
    const wrapper = selectedOption.closest(".swatch-wrapper, .radio-wrapper");
    const isUnavailableSelection = wrapper == null ? void 0 : wrapper.hasAttribute("data-unavailable");
    if (isUnavailableSelection) {
      return;
    }
    this.updateSelectedOption(event.target);
    this.dispatchEvent(new VariantSelectedEvent({
      id: selectedOption.dataset.optionValueId ?? selectedOption.value ?? "",
      unavailable: false
    }));
    const isOnProductPage = this.dataset.templateProductMatch === "true" && !event.target.closest("product-card") && !event.target.closest("quick-add-dialog");
    const connectedProductUrl = this.getConnectedProductUrl(selectedOption);
    const currentUrl2 = (_a = this.dataset.productUrl) == null ? void 0 : _a.split("?")[0];
    const loadsNewProduct = isOnProductPage && !!connectedProductUrl && connectedProductUrl !== currentUrl2;
    if (loadsNewProduct) {
      const requestUrl = this.buildRequestUrl(selectedOption);
      window.location.href = requestUrl;
    } else {
      this.ensureVariantDataForTheme();
    }
  }
  /**
   * Get selected option from event target
   */
  getSelectedOptionFromEvent(event) {
    const target = event.target;
    if (target instanceof HTMLSelectElement) {
      return target.options[target.selectedIndex];
    }
    if (target instanceof HTMLInputElement && target.type === "radio") {
      return target;
    }
    return target;
  }
  /**
   * Get connected product URL for combined listings
   */
  getConnectedProductUrl(selectedOption) {
    if (selectedOption.dataset.connectedProductUrl) {
      return selectedOption.dataset.connectedProductUrl;
    }
    const optionValue = selectedOption.value;
    const colorOptions = document.querySelectorAll('[name="options[Color]"]');
    for (let option of colorOptions) {
      if (option.value === optionValue && option.dataset.productUrl) {
        return option.dataset.productUrl;
      }
    }
    return null;
  }
  /**
   * Updates the selected option state
   * @param {string | Element} target - The target element or option value ID.
   */
  updateSelectedOption(target) {
    if (typeof target === "string") {
      const targetElement = this.querySelector(`[data-option-value-id="${target}"]`);
      if (!targetElement) throw new Error("Target element not found");
      target = targetElement;
    }
    if (target instanceof HTMLInputElement && target.type === "radio") {
      target.checked = true;
    }
    if (target instanceof HTMLSelectElement) {
      const newValue = target.value;
      const newSelectedOption = Array.from(target.options).find((option) => option.value === newValue);
      if (!newSelectedOption) throw new Error("Option not found");
      for (const option of target.options) {
        option.removeAttribute("selected");
      }
      newSelectedOption.setAttribute("selected", "selected");
    }
  }
  /**
   * Builds the request URL for fetching updated content
   */
  buildRequestUrl(selectedOption, source = null, sourceSelectedOptionsValues = []) {
    let productUrl = this.getConnectedProductUrl(selectedOption) || this.dataset.productUrl;
    if (!productUrl) {
      productUrl = __privateGet(this, _pendingRequestUrl) || this.dataset.productUrl;
    }
    const params = [];
    if (this.selectedOptionsValues.length && !source) {
      params.push(`option_values=${this.selectedOptionsValues.join(",")}`);
    } else if (source === "product-card") {
      if (this.selectedOptionsValues.length) {
        params.push(`option_values=${sourceSelectedOptionsValues.join(",")}`);
      } else {
        const optionValueId = selectedOption.dataset.optionValueId || selectedOption.value;
        if (optionValueId) {
          params.push(`option_values=${optionValueId}`);
        }
      }
    }
    if (this.closest("quick-add-component") || this.closest("swatches-variant-picker-component")) {
      if (productUrl == null ? void 0 : productUrl.includes("?")) {
        productUrl = productUrl.split("?")[0];
      }
      return `${productUrl}?section_id=section-rendering-product-card&${params.join("&")}`;
    }
    return `${productUrl}?${params.join("&")}`;
  }
  /**
   * Fetches the updated section content
   * @param {string} requestUrl - The request URL.
   * @param {boolean} shouldMorphMain - If the entire main content should be morphed.
   */
  fetchUpdatedSection(requestUrl, shouldMorphMain = false) {
    if (__privateGet(this, _abortController)) {
      __privateGet(this, _abortController).abort();
      __privateSet(this, _pendingRequestUrl, void 0);
    }
    __privateSet(this, _abortController, new AbortController());
    __privateSet(this, _pendingRequestUrl, requestUrl);
    const timeoutId = setTimeout(() => {
      if (__privateGet(this, _abortController)) {
        __privateGet(this, _abortController).abort();
        __privateSet(this, _pendingRequestUrl, void 0);
        console.warn("Request timed out for URL:", requestUrl);
      }
    }, 1e4);
    fetch(requestUrl, {
      signal: __privateGet(this, _abortController).signal
    }).then((response) => {
      clearTimeout(timeoutId);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    }).then((responseText) => {
      var _a, _b;
      __privateSet(this, _pendingRequestUrl, void 0);
      const html = new DOMParser().parseFromString(responseText, "text/html");
      (_a = html.querySelector("overflow-list[defer]")) == null ? void 0 : _a.removeAttribute("defer");
      const textContent = (_b = html.querySelector(`variant-picker script[type="application/json"]`)) == null ? void 0 : _b.textContent;
      if (shouldMorphMain) {
        this.updateMain(html);
      } else {
        console.log("morphing variant picker");
        const newProduct = this.updateVariantPicker(html);
        if (textContent && this.selectedOptionId) {
          const productData = JSON.parse(textContent);
          const selectedVariant = this.findSelectedVariant(productData);
          this.dispatchEvent(new VariantUpdateEvent(productData, this.selectedOptionId, {
            html,
            productId: this.dataset.productId ?? "",
            newProduct,
            selectedVariant
          }));
          if (selectedVariant) {
            this.dispatchThemeVariantChangeEvent(selectedVariant, productData);
          }
        }
      }
    }).catch((error) => {
      clearTimeout(timeoutId);
      __privateSet(this, _pendingRequestUrl, void 0);
      if (error.name === "AbortError") {
        console.warn("Fetch aborted for URL:", requestUrl);
      } else {
        console.error("Failed to fetch updated section:", error, "URL:", requestUrl);
      }
    });
  }
  /**
   * Updates the variant picker content
   */
  updateVariantPicker(newHtml) {
    let newProduct;
    const newVariantPickerSource = newHtml.querySelector(this.tagName.toLowerCase());
    if (!newVariantPickerSource) {
      const newProductFormSource = newHtml.querySelector("product-form");
      if (newProductFormSource) {
        this.updateProductForm(newProductFormSource);
        return;
      }
      throw new Error("No new variant picker source found");
    }
    if (newVariantPickerSource instanceof HTMLElement) {
      const newProductId = newVariantPickerSource.dataset.productId;
      const newProductUrl = newVariantPickerSource.dataset.productUrl;
      if (newProductId && newProductUrl && this.dataset.productId !== newProductId) {
        newProduct = {
          id: newProductId,
          url: newProductUrl
        };
      }
      this.dataset.productId = newProductId;
      this.dataset.productUrl = newProductUrl;
    }
    this.updateThemeProductData(newHtml);
    try {
      if (typeof morph === "function") {
        morph(this, newVariantPickerSource);
      } else {
        this.innerHTML = newVariantPickerSource.innerHTML;
      }
    } catch (error) {
      console.error("Error morphing variant picker content:", error);
      this.innerHTML = newVariantPickerSource.innerHTML;
    }
    this.updateInventoryStates(newHtml);
    setTimeout(() => {
      this.updateInventoryStates(newHtml);
    }, 50);
    return newProduct;
  }
  /**
   * Updates inventory/availability states for all options after product switch
   * @param {Document} newHtml - The new HTML content
   */
  updateInventoryStates(newHtml) {
    const newProductScript = newHtml.querySelector("[data-product-json], [data-variant-picker-product]");
    let newProductData = null;
    if (newProductScript && newProductScript.textContent) {
      try {
        newProductData = JSON.parse(newProductScript.textContent);
      } catch (e) {
        console.warn("Failed to parse new product data for inventory update:", e);
        return;
      }
    }
    if (!newProductData || !newProductData.variants) {
      console.warn("No product data available for inventory update");
      return;
    }
    this.updateOptionAvailability(newProductData);
    this.updateVariantButtonStates(newProductData);
    this.updateSelloutStates(newProductData);
  }
  /**
   * Update option availability based on product data
   * @param {Object} productData - The product data
   */
  updateOptionAvailability(productData) {
    const options = this.querySelectorAll("[data-single-option-selector]");
    options.forEach((option) => {
      var _a;
      const optionValue = option.value;
      const optionPosition = parseInt(((_a = option.dataset.index) == null ? void 0 : _a.replace("option", "")) || "1");
      const hasAvailableVariants = productData.variants.some((variant) => {
        return variant.available && variant.options[optionPosition - 1] === optionValue;
      });
      const wrapper = option.closest(".swatch-wrapper, .radio-wrapper");
      if (hasAvailableVariants) {
        wrapper == null ? void 0 : wrapper.classList.remove("option-unavailable", "soldout");
        wrapper == null ? void 0 : wrapper.removeAttribute("data-unavailable");
      } else {
        wrapper == null ? void 0 : wrapper.classList.add("soldout");
        wrapper == null ? void 0 : wrapper.setAttribute("data-unavailable", "true");
        option.disabled = false;
      }
    });
  }
  /**
   * Update variant button states
   * @param {Object} productData - The product data
   */
  updateVariantButtonStates(productData) {
    const variantButtons = this.querySelectorAll("[data-variant-buttons] .swatch-wrapper, [data-variant-buttons] .radio-wrapper");
    variantButtons.forEach((wrapper) => {
      var _a;
      const input = wrapper.querySelector('input[type="radio"]');
      if (!input) return;
      const optionValue = input.value;
      const optionPosition = parseInt(((_a = input.dataset.index) == null ? void 0 : _a.replace("option", "")) || "1");
      const variantsForOption = productData.variants.filter((variant) => {
        return variant.options[optionPosition - 1] === optionValue;
      });
      const hasAvailableVariants = variantsForOption.some((variant) => variant.available);
      if (hasAvailableVariants) {
        wrapper.classList.remove("soldout", "unavailable");
        wrapper.removeAttribute("data-unavailable");
        input.disabled = false;
      } else {
        wrapper.classList.add("soldout");
        wrapper.setAttribute("data-unavailable", "true");
        input.disabled = false;
      }
    });
  }
  /**
   * Update sellout states for integration with existing theme sellout system
   * @param {Object} productData - The product data
   */
  updateSelloutStates(productData) {
    const productForm = this.closest("product-form");
    if (productForm && productForm.sellout && typeof productForm.sellout.update === "function") {
      const currentVariant = this.getCurrentSelectedVariant(productData);
      if (currentVariant) {
        const formState = {
          variant: currentVariant,
          product: productData
        };
        productForm.sellout.update(formState);
      }
    }
    this.updateManualSelloutStates(productData);
  }
  /**
   * Manual sellout state updates
   * @param {Object} productData - The product data
   */
  updateManualSelloutStates(productData) {
    const soldoutElements = this.querySelectorAll(".soldout");
    soldoutElements.forEach((element) => {
      element.classList.remove("soldout");
      element.removeAttribute("data-unavailable");
    });
    const unavailableWrappers = this.querySelectorAll('[data-unavailable="true"]');
    unavailableWrappers.forEach((wrapper) => {
      wrapper.classList.add("soldout");
    });
  }
  /**
   * Get currently selected variant from product data
   * @param {Object} productData - The product data
   * @returns {Object|null} - The selected variant or null
   */
  getCurrentSelectedVariant(productData) {
    const selectedOptions = Array.from(this.querySelectorAll("[data-single-option-selector]:checked")).map((input) => input.value);
    if (selectedOptions.length === 0) return null;
    return productData.variants.find((variant) => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    }) || null;
  }
  /**
   * Updates the product form content (fallback)
   */
  updateProductForm(newProductFormSource) {
    const currentProductForm = this.closest("product-form") || document.querySelector("product-form");
    if (currentProductForm && newProductFormSource) {
      if (typeof morph === "function") {
        morph(currentProductForm, newProductFormSource);
      } else {
        currentProductForm.innerHTML = newProductFormSource.innerHTML;
      }
    }
  }
  /**
   * Updates the theme's product data to prevent null variant errors
   */
  updateThemeProductData(newHtml) {
    const productForm = this.closest("product-form");
    if (!productForm || !productForm.productForm) return;
    try {
      const newProductScript = newHtml.querySelector('[data-product-json], script[type="application/json"][data-product-json]');
      if (!newProductScript || !newProductScript.textContent) return;
      const newProductData = JSON.parse(newProductScript.textContent);
      if (!newProductData || !newProductData.variants) return;
      if (productForm.productForm.product) {
        productForm.productForm.product = newProductData;
      }
      const globalProductScript = document.querySelector(`#ProductJson-${newProductData.id}`);
      if (globalProductScript) {
        globalProductScript.textContent = JSON.stringify(newProductData);
      }
    } catch (error) {
      console.warn("Could not update theme product data:", error);
    }
  }
  /**
   * Find the currently selected variant from product data
   */
  findSelectedVariant(productData) {
    if (!productData || !productData.variants) return null;
    const selectedOptions = Array.from(this.querySelectorAll("[data-single-option-selector]:checked, [data-single-option-selector] option:checked")).map((input) => input.value);
    if (selectedOptions.length === 0) {
      return productData.variants.find((v2) => v2.available) || productData.variants[0];
    }
    return productData.variants.find((variant) => {
      return variant.options && selectedOptions.every((option, index) => {
        return variant.options[index] === option;
      });
    }) || productData.variants[0];
  }
  /**
   * Dispatch theme-compatible variant change event
   */
  dispatchThemeVariantChangeEvent(variant, productData) {
    if (!variant) return;
    const formState = {
      variant,
      options: variant.options || [],
      quantity: 1,
      properties: {},
      plan: null
    };
    document.dispatchEvent(new CustomEvent("theme:variant:change", {
      detail: formState,
      bubbles: true
    }));
    window.dispatchEvent(new CustomEvent("variantChange", {
      detail: formState,
      bubbles: true
    }));
  }
  /**
   * Ensure variant data is available for the theme's product form reader
   */
  ensureVariantDataForTheme() {
    const productForm = this.closest("product-form");
    if (!productForm || !productForm.productForm) return;
    try {
      if (productForm.productForm.variant && typeof productForm.productForm.variant === "function") {
        const currentVariant = productForm.productForm.variant();
        if (!currentVariant && productForm.productForm.product && productForm.productForm.product.variants) {
          const firstAvailableVariant = productForm.productForm.product.variants.find((v2) => v2.available);
          const fallbackVariant = firstAvailableVariant || productForm.productForm.product.variants[0];
          if (fallbackVariant) {
            this.selectVariantOptions(fallbackVariant);
          }
        }
      }
    } catch (error) {
      console.warn("Could not ensure variant data for theme:", error);
    }
  }
  /**
   * Select variant options to match a given variant
   */
  selectVariantOptions(variant) {
    if (!variant || !variant.options) return;
    const optionInputs = this.querySelectorAll("[data-single-option-selector]");
    optionInputs.forEach((input, index) => {
      const optionValue = variant.options[index];
      if (optionValue) {
        if (input.type === "radio" || input.type === "checkbox") {
          if (input.value === optionValue) {
            input.checked = true;
          }
        } else if (input.tagName === "SELECT") {
          input.value = optionValue;
        }
      }
    });
  }
  /**
   * Updates the entire main content for combined listings
   */
  updateMain(newHtml) {
    const main = document.querySelector("main");
    const newMain = newHtml.querySelector("main");
    if (!main || !newMain) {
      throw new Error("No main content found");
    }
    if (typeof morph === "function") {
      morph(main, newMain);
    } else {
      main.innerHTML = newMain.innerHTML;
    }
  }
  /**
   * Updates browser URL for combined listings and variant selection
   */
  updateBrowserUrl(selectedOption, isOnProductPage, loadsNewProduct, connectedProductUrl) {
    if (!loadsNewProduct) {
      return;
    }
    const url = new URL(window.location.href);
    if (loadsNewProduct && connectedProductUrl) {
      url.pathname = connectedProductUrl;
      url.searchParams.delete("variant");
    }
    if (url.href !== window.location.href) {
      if (this.urlUpdateTimeout) {
        clearTimeout(this.urlUpdateTimeout);
      }
      this.urlUpdateTimeout = setTimeout(() => {
        history.replaceState({}, "", url.toString());
        this.urlUpdateTimeout = null;
      }, 100);
    }
  }
  /**
   * Gets the currently selected option
   */
  get selectedOption() {
    const selectedOption = this.querySelector("select option[selected], fieldset input:checked");
    if (!(selectedOption instanceof HTMLInputElement || selectedOption instanceof HTMLOptionElement)) {
      return void 0;
    }
    return selectedOption;
  }
  /**
   * Gets the selected option ID
   */
  get selectedOptionId() {
    const {
      selectedOption
    } = this;
    if (!selectedOption) return void 0;
    const optionValueId = selectedOption.dataset.optionValueId || selectedOption.value;
    if (!optionValueId) {
      throw new Error("No option value ID found");
    }
    return optionValueId;
  }
  /**
   * Gets all selected options values
   */
  get selectedOptionsValues() {
    const selectedOptions = Array.from(this.querySelectorAll("select option[selected], fieldset input:checked"));
    return selectedOptions.map((option) => {
      const optionValueId = option.dataset.optionValueId || option.value;
      if (!optionValueId) throw new Error("No option value ID found");
      return optionValueId;
    });
  }
  /**
   * Patch theme methods to prevent null variant errors
   */
  patchThemeMethods() {
    this.applyGlobalThemePatches();
    this.patchProductFormInstance();
  }
  /**
   * Apply global patches to theme methods to prevent null variant errors
   */
  applyGlobalThemePatches() {
    if (window.__themeMethodsPatched) return;
    window.__themeMethodsPatched = true;
    if (customElements.get("product-form")) {
      this.patchProductFormPrototype();
    } else {
      const checkForProductForm = setInterval(() => {
        if (customElements.get("product-form")) {
          clearInterval(checkForProductForm);
          this.patchProductFormPrototype();
        }
      }, 100);
    }
    this.setupDOMObserverPatching();
  }
  /**
   * Patch the ProductForm prototype to handle null variants globally
   */
  patchProductFormPrototype() {
    const ProductFormClass = customElements.get("product-form");
    if (!ProductFormClass || !ProductFormClass.prototype) return;
    if (ProductFormClass.prototype.updateNotificationForm && !ProductFormClass.prototype._updateNotificationFormPatched) {
      const originalUpdateNotificationForm = ProductFormClass.prototype.updateNotificationForm;
      ProductFormClass.prototype.updateNotificationForm = function(formState) {
        if (!formState || !formState.variant || formState.variant === null || formState.variant === void 0) {
          console.warn("Skipping updateNotificationForm due to invalid formState or null variant:", formState);
          return;
        }
        if (typeof formState.variant !== "object" || formState.variant.title === null || formState.variant.title === void 0) {
          console.warn("Skipping updateNotificationForm due to invalid variant data:", formState.variant);
          return;
        }
        try {
          return originalUpdateNotificationForm.call(this, formState);
        } catch (error) {
          console.warn("Error in updateNotificationForm, skipping:", error);
        }
      };
      ProductFormClass.prototype._updateNotificationFormPatched = true;
    }
    if (ProductFormClass.prototype.pushState && !ProductFormClass.prototype._pushStatePatched) {
      const originalPushState = ProductFormClass.prototype.pushState;
      ProductFormClass.prototype.pushState = function(formState, init = false) {
        if (!formState) {
          console.warn("Skipping pushState due to null/undefined formState");
          return;
        }
        if (!formState.variant || formState.variant === null) {
          const validVariant = this.getValidVariantFromProduct();
          if (validVariant) {
            formState = {
              ...formState,
              variant: validVariant
            };
          } else {
            console.warn("Skipping pushState due to null variant and no valid fallback available");
            return;
          }
        }
        try {
          return originalPushState.call(this, formState, init);
        } catch (error) {
          console.warn("Error in pushState, attempting recovery:", error);
          if (this.productForm && typeof this.productForm.getFormState === "function") {
            try {
              const currentFormState = this.productForm.getFormState();
              if (currentFormState && currentFormState.variant) {
                return originalPushState.call(this, currentFormState, init);
              }
            } catch (recoveryError) {
              console.warn("Recovery attempt failed:", recoveryError);
            }
          }
        }
      };
      ProductFormClass.prototype.getValidVariantFromProduct = function() {
        if (!this.productForm || !this.productForm.product || !this.productForm.product.variants) {
          return null;
        }
        if (typeof this.productForm.variant === "function") {
          try {
            const currentVariant = this.productForm.variant();
            if (currentVariant && currentVariant.id) {
              return currentVariant;
            }
          } catch (e) {
          }
        }
        const availableVariant = this.productForm.product.variants.find((v2) => v2.available);
        if (availableVariant) {
          return availableVariant;
        }
        return this.productForm.product.variants[0] || null;
      };
      ProductFormClass.prototype._pushStatePatched = true;
    }
  }
  /**
   * Set up DOM observer to patch new product form instances
   */
  setupDOMObserverPatching() {
    if (window.__domObserverPatching) return;
    window.__domObserverPatching = true;
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const productForms = [];
            if (node.tagName === "PRODUCT-FORM") {
              productForms.push(node);
            }
            if (node.querySelectorAll) {
              productForms.push(...node.querySelectorAll("product-form"));
            }
            productForms.forEach((form) => {
              setTimeout(() => {
                this.patchProductFormInstanceDirect(form);
              }, 50);
            });
          }
        });
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  /**
   * Patch specific product form instance
   */
  patchProductFormInstance() {
    const productForm = this.closest("product-form");
    if (productForm) {
      this.patchProductFormInstanceDirect(productForm);
    }
  }
  /**
   * Direct patch of a specific product form instance
   */
  patchProductFormInstanceDirect(productForm) {
    if (!productForm || productForm._instancePatched) return;
    if (productForm.updateNotificationForm && !productForm._updateNotificationFormInstancePatched) {
      const originalMethod = productForm.updateNotificationForm.bind(productForm);
      productForm.updateNotificationForm = function(formState) {
        if (!formState || !formState.variant || formState.variant.title === null || formState.variant.title === void 0) {
          console.warn("Instance-level: Skipping updateNotificationForm due to invalid variant data:", formState);
          return;
        }
        try {
          return originalMethod(formState);
        } catch (error) {
          console.warn("Instance-level: Error in updateNotificationForm:", error);
        }
      };
      productForm._updateNotificationFormInstancePatched = true;
    }
    if (productForm.pushState && !productForm._pushStateInstancePatched) {
      const originalPushState = productForm.pushState.bind(productForm);
      productForm.pushState = function(formState, init = false) {
        var _a, _b;
        if (!formState) {
          console.warn("Instance-level: Skipping pushState due to null formState");
          return;
        }
        if (!formState.variant && productForm.productForm && productForm.productForm.product) {
          const fallbackVariant = ((_a = productForm.productForm.product.variants) == null ? void 0 : _a.find((v2) => v2.available)) || ((_b = productForm.productForm.product.variants) == null ? void 0 : _b[0]);
          if (fallbackVariant) {
            formState = {
              ...formState,
              variant: fallbackVariant
            };
          }
        }
        try {
          return originalPushState(formState, init);
        } catch (error) {
          console.warn("Instance-level: Error in pushState:", error);
        }
      };
      productForm._pushStateInstancePatched = true;
    }
    productForm._instancePatched = true;
  }
}
_pendingRequestUrl = new WeakMap();
_abortController = new WeakMap();
_productForm = new WeakMap();
if (!customElements.get("variant-picker")) {
  customElements.define("variant-picker", VariantPicker);
}
class MembersOnlyHandler {
  // 5 seconds cache
  constructor() {
    this.modal = null;
    this.currentProduct = null;
    this.currentVariantId = null;
    this.currentFormData = null;
    this.originalAddToCartHandler = null;
    this.cachedCart = null;
    this.cartCacheExpiry = 0;
    this.CART_CACHE_DURATION = 5e3;
    this.init();
  }
  resetState() {
    this.currentProduct = null;
    this.currentVariantId = null;
    this.currentFormData = null;
  }
  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    document.addEventListener("submit", (e) => {
      const form = e.target;
      if (form.matches('[action*="/cart/add"]') || form.action && form.action.includes("/cart/add")) {
        const submitButton = form.querySelector('[type="submit"]:focus');
        this.handleFormSubmit(e, submitButton || form.querySelector('[type="submit"]'));
      }
    }, true);
    document.addEventListener("click", (e) => {
      const button = e.target;
      console.log("[MembersOnlyHandler] click", button.matches && button.matches('[data-add-to-cart], [data-add-to-cart-bar], [data-action="add-to-cart"], .btn-add-to-cart, [type="submit"][name="add"], [name="add"], .product-form__cart-submit'), button);
      if (button.matches && button.matches('[data-add-to-cart], [data-add-to-cart-bar], [data-action="add-to-cart"], .btn-add-to-cart, [type="submit"][name="add"], [name="add"], .product-form__cart-submit')) {
        const productTags = button.getAttribute("data-product-tags") || "";
        const hasMembersOnlyTag = productTags.split(",").some((tag) => tag.trim().toLowerCase() === "members-only-product");
        if (hasMembersOnlyTag) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.handleAddToCartClick(e, button);
        }
      }
    }, true);
    document.addEventListener("popup-handlers:refresh", () => {
      this.invalidateCaches();
    });
    document.addEventListener("popup-handlers:content-updated", () => {
      this.invalidateCaches();
    });
    document.addEventListener("theme:recently-viewed:loaded", () => {
      this.invalidateCaches();
    });
    document.addEventListener("theme:complementary:loaded", () => {
      this.invalidateCaches();
    });
    if (typeof window !== "undefined") {
      window.membersOnlyModal = {
        show: (productTitle, productHandle) => this.showModal(productTitle, productHandle),
        hide: () => this.hideModal()
      };
    }
    document.addEventListener("members-only:close", () => {
      this.hideModal();
    });
    document.addEventListener("members-only:add-to-cart", () => {
      this.handleMembershipAddToCart();
    });
    document.addEventListener("members-only:upgrade", () => {
      this.handleMembershipAddToCart();
    });
    document.addEventListener("members-only:sign-in", () => {
      window.location.href = `https://autostraddle.forthem.com/login?return_to=${window.location.href}`;
    });
  }
  async handleFormSubmit(e, button) {
    var _a;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    this.resetState();
    console.log("handleFormSubmit", button);
    const productData = this.getProductData(button);
    if (!productData) {
      return;
    }
    const hasMembersOnlyTag = productData.tags.some((tag) => tag.toLowerCase() === "members-only-product");
    if (!hasMembersOnlyTag) {
      return;
    }
    this.currentProduct = productData;
    const form = e.target;
    if (form) {
      this.currentFormData = new FormData(form);
      this.currentVariantId = ((_a = this.currentFormData.get("id")) == null ? void 0 : _a.toString()) || null;
    }
    const shouldIntercept = await this.shouldInterceptAddToCart(button);
    if (shouldIntercept) {
      await this.handleMembersOnlyProduct(button);
    } else {
      await this.proceedWithAddToCart();
    }
  }
  async handleAddToCartClick(e, button) {
    var _a;
    this.resetState();
    const productData = this.getProductData(button);
    if (!productData) {
      return;
    }
    this.currentProduct = productData;
    const form = button.closest("form");
    if (form) {
      this.currentFormData = new FormData(form);
      this.currentVariantId = ((_a = this.currentFormData.get("id")) == null ? void 0 : _a.toString()) || null;
    }
    const shouldIntercept = await this.shouldInterceptAddToCart(button);
    if (shouldIntercept) {
      await this.handleMembersOnlyProduct(button);
    } else {
      await this.simulateOriginalAction(button);
    }
  }
  async simulateOriginalAction(button) {
    if (this.currentFormData) {
      await this.addToCartViaAjax();
      return;
    }
    const form = button.closest("form");
    if (form) {
      const formData = new FormData(form);
      this.currentFormData = formData;
      await this.addToCartViaAjax();
    } else {
      await this.addToCartViaAjax();
    }
  }
  invalidateCache() {
    this.cachedCart = null;
    this.cartCacheExpiry = 0;
  }
  // Public method to invalidate cache
  invalidateCaches() {
    this.invalidateCache();
  }
  captureCurrentProductData() {
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    if (productForms.length > 0) {
      const form = productForms[0];
      this.currentFormData = new FormData(form);
      const variantInput = form.querySelector('input[name="id"], select[name="id"]');
      if (variantInput && variantInput.value) {
        this.currentVariantId = variantInput.value;
      }
    }
    if (!this.currentProduct && window.product) {
      this.currentProduct = window.product;
    }
  }
  async updateCartCache() {
    try {
      const response = await fetch("/cart.js");
      this.cachedCart = await response.json();
      this.cartCacheExpiry = Date.now() + this.CART_CACHE_DURATION;
    } catch (error) {
      this.cachedCart = null;
      this.cartCacheExpiry = 0;
    }
  }
  /**
   * Get cart data, ensuring it's fresh
   */
  async getCartData() {
    try {
      const response = await fetch("/cart.js");
      if (response.ok) {
        const cart = await response.json();
        return cart;
      }
    } catch (error) {
    }
    return null;
  }
  getCachedCart() {
    if (!this.cachedCart || Date.now() > this.cartCacheExpiry) {
      this.updateCartCache();
      return null;
    }
    return this.cachedCart;
  }
  async shouldInterceptAddToCart(button) {
    console.log("shouldInterceptAddToCart", button);
    const productData = this.getProductData(button);
    if (!productData) return false;
    const hasMembersOnlyTag = productData.tags.some((tag) => tag.toLowerCase() === "members-only-product");
    if (!hasMembersOnlyTag) return false;
    const isLoggedIn = this.isCustomerLoggedIn();
    if (!isLoggedIn) {
      const hasCartBypass = await this.cartHasQualifyingSubscription(productData);
      if (hasCartBypass) {
        return false;
      }
      return true;
    }
    const hasRequiredMembership = await this.hasRequiredMembershipLevel(productData);
    if (!hasRequiredMembership) {
      const hasCartBypass = await this.cartHasQualifyingSubscription(productData);
      if (hasCartBypass) {
        return false;
      }
      return true;
    }
    return false;
  }
  /**
   * Check if the cart already contains a subscription that satisfies the membership requirement
   */
  async cartHasQualifyingSubscription(productData) {
    var _a, _b, _c;
    const cart = await this.getCartData();
    if (!cart || !cart.items || cart.items.length === 0) {
      return false;
    }
    const hasMembersOnlyTag = productData.tags.some((tag) => tag.toLowerCase() === "members-only-product");
    if (hasMembersOnlyTag) {
      for (const item of cart.items) {
        if (!item.selling_plan_allocation) continue;
        if (this.isKnownMembershipSubscription(item)) {
          return true;
        }
      }
      return false;
    }
    const requiredLevels = (_c = (_b = (_a = productData.metafields) == null ? void 0 : _a.subscription) == null ? void 0 : _b.required_membership_level) == null ? void 0 : _c.value;
    if (!requiredLevels) {
      return false;
    }
    const requiredLevelsArray = Array.isArray(requiredLevels) ? requiredLevels : [requiredLevels];
    for (const item of cart.items) {
      if (!item.selling_plan_allocation) continue;
      if (this.isKnownMembershipSubscription(item)) {
        const providedLevel = this.getMembershipLevelFromCartItem(item);
        if (providedLevel) {
          const hasMatchingLevel = requiredLevelsArray.some((requiredLevel) => providedLevel.toLowerCase() === requiredLevel.toLowerCase());
          if (hasMatchingLevel) {
            return true;
          }
        }
      }
    }
    return false;
  }
  /**
   * Check if a cart item is a known membership subscription
   */
  isKnownMembershipSubscription(cartItem) {
    var _a;
    const membershipVariantIds = ["44792925257894", "46214081347750"];
    const membershipHandles = ["af-membership", "support-the-community", "af-plus-toki"];
    return membershipVariantIds.includes((_a = cartItem.variant_id) == null ? void 0 : _a.toString()) || membershipHandles.includes(cartItem.handle);
  }
  /**
   * Get membership level provided by a cart item
   */
  getMembershipLevelFromCartItem(cartItem) {
    if (this.isKnownMembershipSubscription(cartItem)) {
      return "af-plus";
    }
    return null;
  }
  getProductData(button) {
    var _a, _b, _c, _d, _e, _f, _g;
    console.log("getProductData", button);
    if (button) {
      const productHandle = button.getAttribute("data-product-handle");
      const productTags = button.getAttribute("data-product-tags") || "";
      const productId = button.getAttribute("data-product-id");
      const productTitle = button.getAttribute("data-product-title");
      const productImage = button.getAttribute("data-product-image");
      if (productHandle && productTags) {
        const basicProductData = {
          id: productId || productHandle,
          handle: productHandle,
          title: productTitle || "Product",
          tags: productTags.split(",").map((tag) => tag.trim()).filter((tag) => tag.length > 0),
          metafields: {
            subscription: {}
          },
          featured_image: productImage || void 0
        };
        return basicProductData;
      }
      const gridItem = button.closest("[data-grid-item]") || button.closest(".product-item") || button.closest(".quick-add__holder");
      console.log("gridItem fallback", gridItem);
      if (gridItem) {
        const fallbackProductHandle = gridItem.getAttribute("data-product-handle") || ((_a = gridItem.querySelector("[data-product-handle]")) == null ? void 0 : _a.getAttribute("data-product-handle")) || ((_b = gridItem.querySelector("[data-quick-add-holder]")) == null ? void 0 : _b.getAttribute("data-product-handle"));
        const fallbackProductTags = gridItem.getAttribute("data-tags") || gridItem.getAttribute("data-product-tags") || ((_c = gridItem.querySelector("[data-product-tags]")) == null ? void 0 : _c.getAttribute("data-product-tags")) || "";
        const fallbackProductId = gridItem.getAttribute("data-product-id") || ((_d = gridItem.querySelector("[data-quick-add-holder]")) == null ? void 0 : _d.getAttribute("data-quick-add-holder"));
        const fallbackProductTitle = (_f = (_e = gridItem.querySelector(".product-item__title, .product-title, [data-product-title]")) == null ? void 0 : _e.textContent) == null ? void 0 : _f.trim();
        const fallbackFeaturedImage = (_g = gridItem.querySelector(".image-wrapper img")) == null ? void 0 : _g.getAttribute("src");
        if (fallbackProductHandle && fallbackProductTags) {
          const basicProductData = {
            id: fallbackProductId || fallbackProductHandle,
            handle: fallbackProductHandle,
            title: fallbackProductTitle || "Product",
            tags: fallbackProductTags.split(",").map((tag) => tag.trim()).filter((tag) => tag.length > 0),
            metafields: {
              subscription: {}
            },
            featured_image: fallbackFeaturedImage || void 0
          };
          return basicProductData;
        }
      }
      const form = button.closest('form[action*="/cart/add"]');
      if (form) {
        const formProductHandle = form.getAttribute("data-form-product-handle");
        const formProductTags = form.getAttribute("data-form-product-tags");
        const formProductId = form.getAttribute("data-form-product-id");
        if (formProductHandle && formProductTags) {
          return {
            id: formProductId || formProductHandle,
            handle: formProductHandle,
            title: "Product",
            tags: formProductTags.split(",").map((tag) => tag.trim()).filter((tag) => tag.length > 0),
            metafields: {
              subscription: {}
            }
          };
        }
      }
    }
    let productData = null;
    if (window.product) {
      productData = window.product;
    }
    if (!productData) {
      const productScript = document.querySelector("script[data-product-json]");
      if (productScript && productScript.textContent) {
        try {
          productData = JSON.parse(productScript.textContent);
        } catch (e) {
        }
      }
    }
    return productData;
  }
  isCustomerLoggedIn() {
    const customer = window.customer;
    if (customer && customer.id) return true;
    return document.body.classList.contains("customer-logged-in");
  }
  async hasRequiredMembershipLevel(productData) {
    var _a, _b, _c;
    if (!this.isCustomerLoggedIn()) {
      return false;
    }
    const hasMembersOnlyTag = productData.tags.some((tag) => tag.toLowerCase() === "members-only-product");
    if (hasMembersOnlyTag) {
      try {
        const membershipResult = await membershipService.getCurrentMembershipStatus();
        console.log({
          membershipResult
        });
        const membershipName = membershipResult.memberships[0].name.toLowerCase();
        return membershipName === FORTHEM_TIER_NAME_ALLACCESS.toLowerCase() || membershipName === FORTHEM_TIER_NAME_SUPPORT.toLowerCase();
      } catch (error) {
        return false;
      }
    }
    const requiredLevels = (_c = (_b = (_a = productData.metafields) == null ? void 0 : _a.subscription) == null ? void 0 : _b.required_membership_level) == null ? void 0 : _c.value;
    if (!requiredLevels) return true;
    const requiredLevelsArray = Array.isArray(requiredLevels) ? requiredLevels : [requiredLevels];
    try {
      const membershipResult = await membershipService.getCurrentMembershipStatus();
      return this.checkMembershipAgainstRequirements(membershipResult.status, requiredLevelsArray);
    } catch (error) {
      return false;
    }
  }
  checkMembershipAgainstRequirements(membershipStatus, requiredLevels) {
    if (membershipStatus === "not-member") {
      return false;
    }
    if (membershipStatus === "upgradable") {
      return false;
    }
    if (membershipStatus === "not-upgradeable") {
      return true;
    }
    return false;
  }
  async handleMembersOnlyProduct(button) {
    const productData = this.getProductData(button);
    if (!productData) {
      return;
    }
    this.currentProduct = productData;
    const form = button.closest("form");
    const quickViewModal = button.closest(".product-quick-add, [data-quick-add-modal]");
    if (quickViewModal) {
      const productIdFromModal = quickViewModal.getAttribute("data-product-id");
      if (productIdFromModal && form) {
        const variantInput = form.querySelector('input[name="id"], select[name="id"]');
        if (variantInput && variantInput.value) {
          this.currentVariantId = variantInput.value;
        }
      }
    }
    if (form && !this.currentVariantId) {
      const variantInput = form.querySelector('input[name="id"], select[name="id"]');
      if (variantInput) {
        this.currentVariantId = variantInput.value;
      }
      if (!this.currentVariantId) {
        const variantData = form.querySelector("[data-variant-id]");
        if (variantData) {
          this.currentVariantId = variantData.dataset.variantId || null;
        }
      }
    }
    if (!this.currentVariantId) {
      const urlParams = new URLSearchParams(window.location.search);
      const variantParam = urlParams.get("variant");
      if (variantParam) {
        this.currentVariantId = variantParam;
      }
    }
    if (!this.currentVariantId && productData.variants && productData.variants.length > 0) {
      this.currentVariantId = productData.variants[0].id.toString();
    }
    await this.showModal(productData.title, void 0, button);
  }
  async showModal(productTitle, productHandle, button) {
    let productImage = "";
    let finalProductTitle = productTitle;
    if (productHandle) {
      try {
        const fetchedProductData = await this.fetchProductData(productHandle);
        if (fetchedProductData) {
          finalProductTitle = fetchedProductData.title;
          if (this.currentVariantId && fetchedProductData.variants) {
            const variant = fetchedProductData.variants.find((v2) => v2.id.toString() === this.currentVariantId);
            if (variant == null ? void 0 : variant.featured_image) {
              productImage = variant.featured_image;
            }
          }
          if (!productImage && fetchedProductData.featured_image) {
            productImage = typeof fetchedProductData.featured_image === "string" ? fetchedProductData.featured_image : fetchedProductData.featured_image.src;
          }
          if (!productImage && fetchedProductData.images && fetchedProductData.images.length > 0) {
            productImage = fetchedProductData.images[0].src;
          }
          this.currentProduct = fetchedProductData;
        }
      } catch (error) {
      }
    } else {
      const productData = this.getProductData(button);
      if (productData) {
        if (this.currentVariantId && productData.variants) {
          const variant = productData.variants.find((v2) => v2.id.toString() === this.currentVariantId);
          if (variant == null ? void 0 : variant.featured_image) {
            productImage = variant.featured_image;
          }
        }
        if (!productImage && productData.featured_image) {
          productImage = typeof productData.featured_image === "string" ? productData.featured_image : productData.featured_image.src;
        }
        if (!productImage && productData.images && productData.images.length > 0) {
          productImage = productData.images[0].src;
        }
      }
    }
    if (!this.modal) {
      this.modal = document.createElement("members-only-modal");
      this.modal.setAttribute("product-title", finalProductTitle);
      this.modal.setAttribute("product-image", productImage || "");
      document.body.appendChild(this.modal);
    }
    this.modal.setAttribute("is-open", "false");
    requestAnimationFrame(() => {
      if (!this.modal) return;
      this.modal.setAttribute("is-open", "true");
      this.modal.setAttribute("product-title", productTitle);
      this.modal.setAttribute("product-image", productImage || "");
      this.modal.style.display = "block";
      this.modal.style.zIndex = "9999";
      this.modal.style.position = "fixed";
      this.modal.style.top = "0";
      this.modal.style.left = "0";
      this.modal.style.width = "100%";
      this.modal.style.height = "100%";
      requestAnimationFrame(() => {
        var _a;
        const dialog = (_a = this.modal) == null ? void 0 : _a.querySelector("dialog");
        if (dialog && !dialog.open) {
          try {
            dialog.showModal();
          } catch (error) {
            dialog.setAttribute("open", "");
          }
        }
      });
    });
  }
  hideModal() {
    if (this.modal) {
      this.modal.setAttribute("is-open", "false");
      requestAnimationFrame(() => {
        if (this.modal && this.modal.parentNode) {
          this.modal.parentNode.removeChild(this.modal);
          this.modal = null;
        }
      });
    }
  }
  async proceedWithAddToCart() {
    this.hideModal();
    await this.addToCartViaAjax();
  }
  async addToCartViaAjax() {
    try {
      let variantId = null;
      let quantity = 1;
      let sellingPlan = null;
      if (this.currentFormData) {
        const formVariantId = this.currentFormData.get("id");
        const formQuantity = this.currentFormData.get("quantity");
        const formSellingPlan = this.currentFormData.get("selling_plan");
        if (formVariantId) {
          variantId = formVariantId.toString();
        }
        if (formQuantity) {
          quantity = parseInt(formQuantity.toString()) || 1;
        }
        if (formSellingPlan) {
          sellingPlan = formSellingPlan.toString();
        }
      }
      if (!variantId && this.currentVariantId) {
        variantId = this.currentVariantId;
      }
      if (!variantId && this.currentProduct && this.currentProduct.variants && this.currentProduct.variants.length > 0) {
        variantId = this.currentProduct.variants[0].id.toString();
      }
      if (!variantId) {
        alert("Sorry, there was an error adding the item to your cart. Please try again.");
        return false;
      }
      const item = {
        id: variantId,
        quantity
      };
      if (sellingPlan) {
        item.selling_plan = sellingPlan;
      }
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          items: [item]
        })
      });
      if (response.ok) {
        const data = await response.json();
        this.invalidateCache();
        const freshCart = await this.getCartData();
        document.dispatchEvent(new CustomEvent("theme:cart:refresh", {
          bubbles: true,
          detail: {
            cart: freshCart
          }
        }));
        document.dispatchEvent(new CustomEvent("theme:product:added", {
          bubbles: true,
          detail: {
            cart: freshCart
          }
        }));
        window.dispatchEvent(new CustomEvent("cart:added", {
          detail: {
            item: data,
            cart: freshCart
          }
        }));
        window.dispatchEvent(new CustomEvent("cart:updated", {
          detail: {
            cart: freshCart
          }
        }));
        document.dispatchEvent(new CustomEvent("theme:cart:change", {
          bubbles: true,
          detail: {
            cart: freshCart
          }
        }));
        return true;
      } else {
        const errorData = await response.json();
        alert("Sorry, there was an error adding the item to your cart. Please try again.");
        return false;
      }
    } catch (error) {
      alert("Sorry, there was an error. Please try again.");
      return false;
    }
  }
  async handleMembershipAddToCart() {
    if (!this.currentFormData && !this.currentVariantId) {
      this.captureCurrentProductData();
    }
    try {
      const items = [];
      let originalProductAdded = false;
      if (this.currentFormData) {
        const variantId = this.currentFormData.get("id");
        const quantity = this.currentFormData.get("quantity") || "1";
        const sellingPlan = this.currentFormData.get("selling_plan");
        if (variantId) {
          const originalItem = {
            id: variantId,
            quantity: parseInt(quantity.toString())
          };
          if (sellingPlan) {
            originalItem.selling_plan = sellingPlan;
          }
          const properties = {};
          this.currentFormData.forEach((value, key) => {
            const propertyMatch = key.match(/^properties\[(.+)\]$/);
            if (propertyMatch && value) {
              properties[propertyMatch[1]] = value.toString();
            }
          });
          if (Object.keys(properties).length > 0) {
            originalItem.properties = properties;
          }
          items.push(originalItem);
          originalProductAdded = true;
        }
      }
      if (!originalProductAdded) {
        if (this.currentVariantId) {
          items.push({
            id: this.currentVariantId,
            quantity: 1
          });
          originalProductAdded = true;
        } else if (this.currentProduct && this.currentProduct.variants && this.currentProduct.variants.length > 0) {
          const firstVariant = this.currentProduct.variants[0];
          items.push({
            id: firstVariant.id.toString(),
            quantity: 1
          });
          originalProductAdded = true;
        }
      }
      const membershipItem = {
        id: "44792925257894",
        // AF+ membership variant ID
        quantity: 1,
        selling_plan: "1574961318"
        // AF+ subscription selling plan
      };
      items.push(membershipItem);
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          items
        })
      });
      if (response.ok) {
        const data = await response.json();
        this.hideModal();
        document.dispatchEvent(new CustomEvent("theme:cart:refresh", {
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent("theme:product:added", {
          bubbles: true
        }));
        window.dispatchEvent(new CustomEvent("cart:added", {
          detail: {
            item: data
          }
        }));
        this.invalidateCache();
      } else {
        const errorData = await response.json();
        alert("Sorry, there was an error adding the items to your cart. Please try again.");
      }
    } catch (error) {
      alert("Sorry, there was an error. Please try again.");
    }
  }
  submitStoredFormData() {
    if (!this.currentFormData) return;
    const tempForm = document.createElement("form");
    tempForm.method = "POST";
    tempForm.action = "/cart/add";
    tempForm.style.display = "none";
    const formDataKeys = Array.from(this.currentFormData.keys());
    formDataKeys.forEach((key) => {
      const value = this.currentFormData.get(key);
      if (value !== null) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value.toString();
        tempForm.appendChild(input);
      }
    });
    document.body.appendChild(tempForm);
    tempForm.submit();
    document.body.removeChild(tempForm);
    this.currentFormData = null;
  }
  clickOriginalAddToCartButton() {
    const addToCartButton = document.querySelector('[data-action="add-to-cart"], .btn-add-to-cart, [type="submit"][name="add"]');
    if (addToCartButton) {
      addToCartButton.click();
    }
  }
  // Clear membership cache when customer logs in/out (no-op since we removed caching)
  clearMembershipCache() {
  }
  // Fetch product data for members-only products when we don't have complete info
  async fetchProductData(handle) {
    if (!handle) return null;
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (response.ok) {
        const productData = await response.json();
        return {
          id: productData.id,
          handle: productData.handle,
          title: productData.title,
          tags: productData.tags || [],
          featured_image: productData.featured_image,
          images: productData.images || [],
          variants: productData.variants || [],
          metafields: productData.metafields || {}
        };
      }
    } catch (error) {
      console.error("Failed to fetch product data:", error);
    }
    return null;
  }
}
const membersOnlyHandler = new MembersOnlyHandler();
window.membersOnlyHandler = membersOnlyHandler;
if (typeof window !== "undefined") {
  window.invalidateMembersOnlyCache = () => {
    membersOnlyHandler.invalidateCaches();
  };
  window.testProductDataExtraction = (buttonSelector) => {
    const button = document.querySelector(buttonSelector);
    if (button) {
      const productData = membersOnlyHandler.getProductData(button);
      return productData;
    } else {
      return null;
    }
  };
}
class FreeProductWithMembershipHandler {
  constructor() {
    this.modal = null;
    this.currentProduct = null;
    this.currentVariantId = null;
    this.currentFormData = null;
    this.init();
  }
  resetState() {
    this.currentProduct = null;
    this.currentVariantId = null;
    this.currentFormData = null;
  }
  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    document.addEventListener("submit", (e) => {
      const form = e.target;
      if (form.matches('[action*="/cart/add"]') || form.action && form.action.includes("/cart/add")) {
        const submitButton = form.querySelector('[type="submit"]:focus');
        this.handleFormSubmit(e, submitButton || form.querySelector('[type="submit"]'));
      }
    }, true);
    document.addEventListener("click", (e) => {
      const button = e.target;
      if (button.closest("dialog, .drawer, [data-modal], .modal, cart-drawer, header-drawer")) {
        return;
      }
      if (button.matches('[data-action="add-to-cart"], .btn-add-to-cart, [type="submit"][name="add"], [name="add"], .product-form__cart-submit')) {
        this.handleAddToCartClick(e, button);
      }
    }, true);
    document.addEventListener("popup-handlers:refresh", () => {
      this.resetState();
    });
    document.addEventListener("popup-handlers:content-updated", () => {
      this.resetState();
    });
    document.addEventListener("theme:recently-viewed:loaded", () => {
      this.resetState();
    });
    document.addEventListener("theme:complementary:loaded", () => {
      this.resetState();
    });
    if (typeof window !== "undefined") {
      window.freeProductWithMembershipModal = {
        show: (productTitle, productHandle, productPrice) => this.showModal(productTitle, productHandle, productPrice),
        hide: () => this.hideModal()
      };
    }
    document.addEventListener("free-product-with-membership:close", () => {
      this.hideModal();
    });
    document.addEventListener("free-product-with-membership:add-to-cart", () => {
      this.handleMembershipAddToCart();
    });
    document.addEventListener("free-product-with-membership:sign-in", () => {
      window.location.href = `https://autostraddle.forthem.com/login?return_to=${window.location.href}`;
    });
    document.addEventListener("free-product-with-membership:pay-full-price", () => {
      this.handlePayFullPrice();
    });
  }
  async handleFormSubmit(e, button) {
    var _a;
    this.resetState();
    const productData = this.getProductData(button);
    if (!productData) {
      return;
    }
    if (!this.isFreeProductWithMembership(productData)) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const form = e.target;
    this.currentFormData = new FormData(form);
    this.currentProduct = productData;
    this.currentVariantId = ((_a = this.currentFormData.get("id")) == null ? void 0 : _a.toString()) || null;
    const shouldShowModal = await this.shouldShowModal(productData);
    if (shouldShowModal) {
      const price = this.getProductPrice(productData, this.currentVariantId);
      await this.showModal(productData.title, productData.handle, price);
    } else {
      await this.addToCartFromFormData(this.currentFormData);
      window.location.href = "/cart";
    }
  }
  async handleAddToCartClick(e, button) {
    var _a, _b, _c, _d;
    this.resetState();
    const productData = this.getProductData(button);
    if (!productData) {
      return;
    }
    if (!this.isFreeProductWithMembership(productData)) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    this.currentProduct = productData;
    const form = button.closest("form");
    if (form) {
      this.currentFormData = new FormData(form);
      this.currentVariantId = ((_a = this.currentFormData.get("id")) == null ? void 0 : _a.toString()) || null;
    }
    const shouldShowModal = await this.shouldShowModal(productData);
    if (shouldShowModal) {
      const price = this.getProductPrice(productData, this.currentVariantId);
      await this.showModal(productData.title, productData.handle, price);
    } else {
      if (this.currentFormData) {
        await this.addToCartFromFormData(this.currentFormData);
      } else {
        const variantId = button.getAttribute("data-variant-id") || button.getAttribute("data-product-variant-id") || ((_d = (_c = (_b = productData.variants) == null ? void 0 : _b[0]) == null ? void 0 : _c.id) == null ? void 0 : _d.toString());
        if (variantId) {
          await this.addToCart(variantId);
        }
      }
      window.location.href = "/cart";
    }
  }
  isFreeProductWithMembership(productData) {
    if (!productData || !productData.tags) return false;
    return productData.tags.some((tag) => tag.toLowerCase() === "free-product-with-membership");
  }
  async shouldShowModal(productData) {
    if (!this.isCustomerLoggedIn()) {
      return true;
    }
    try {
      const membershipResult = await membershipService.getCurrentMembershipStatus();
      return membershipResult.status === "not-member" || membershipResult.status === "upgradable";
    } catch (error) {
      console.error("Error checking membership status:", error);
      return true;
    }
  }
  isCustomerLoggedIn() {
    return document.body.classList.contains("customer-logged-in") || window.customer && !!window.customer.id || document.querySelector(".customer-logged-in") !== null;
  }
  getProductData(button) {
    var _a, _b, _c, _d, _e;
    if (button) {
      const gridItem = button.closest("[data-grid-item]") || button.closest(".product-item") || button.closest("quick-add-product");
      if (gridItem) {
        const productHandle = gridItem.getAttribute("data-product-handle") || ((_a = gridItem.querySelector("[data-product-handle]")) == null ? void 0 : _a.getAttribute("data-product-handle"));
        const productTags = gridItem.getAttribute("data-tags") || gridItem.getAttribute("data-product-tags") || "";
        const productId = gridItem.getAttribute("data-product-id") || ((_b = gridItem.querySelector("[data-quick-add-holder]")) == null ? void 0 : _b.getAttribute("data-quick-add-holder"));
        const productTitle = (_d = (_c = gridItem.querySelector(".product-item__title, .product-title, [data-product-title]")) == null ? void 0 : _c.textContent) == null ? void 0 : _d.trim();
        if (productHandle && productTags) {
          const basicProductData = {
            id: productId || productHandle,
            handle: productHandle,
            title: productTitle || "Product",
            tags: productTags.split(",").map((tag) => tag.trim()),
            featured_image: "",
            images: [],
            variants: []
          };
          const imageContainer = gridItem.querySelector("[data-product-image]");
          if (imageContainer) {
            const mainImg = imageContainer.querySelector("img");
            if (mainImg && mainImg.src) {
              basicProductData.featured_image = mainImg.src;
              basicProductData.images = [{
                src: mainImg.src
              }];
            }
            const allImages = imageContainer.querySelectorAll("img");
            if (allImages.length > 1) {
              basicProductData.images = Array.from(allImages).map((img) => ({
                src: img.src
              })).filter((img, index, arr) => (
                // Remove duplicates by checking if this src appears earlier in the array
                arr.findIndex((item) => item.src === img.src) === index
              ));
            }
          }
          let extractedPrice = "0";
          const priceElement = gridItem.querySelector(".price, [data-price], .product-item__price, .money");
          if (priceElement) {
            const priceData = priceElement.getAttribute("data-price") || priceElement.getAttribute("data-price-min") || priceElement.getAttribute("data-money-price");
            if (priceData) {
              extractedPrice = priceData;
            } else {
              const priceText = ((_e = priceElement.textContent) == null ? void 0 : _e.trim()) || "";
              const priceMatch = priceText.match(/[\d.,]+/);
              if (priceMatch) {
                extractedPrice = priceMatch[0];
              }
            }
          }
          basicProductData.price = extractedPrice;
          const form = gridItem.querySelector('form[action*="/cart/add"]');
          if (form) {
            const variantInput = form.querySelector('input[name="id"], select[name="id"]');
            if (variantInput && variantInput.value) {
              basicProductData.variants = [{
                id: parseInt(variantInput.value),
                price: extractedPrice,
                // Use extracted price
                featured_image: basicProductData.featured_image || void 0
              }];
            }
          }
          return basicProductData;
        }
      }
    }
    if (window.product) {
      return window.product;
    }
    const productMetaTag = document.querySelector('meta[name="product"]');
    if (productMetaTag) {
      try {
        return JSON.parse(productMetaTag.getAttribute("content") || "{}");
      } catch (e) {
        console.warn("Failed to parse product meta tag content");
      }
    }
    const productScript = document.querySelector('script[type="application/json"][data-product-json]') || document.querySelector('script[type="application/json"][id*="product"]');
    if (productScript) {
      try {
        return JSON.parse(productScript.textContent || "{}");
      } catch (e) {
        console.warn("Failed to parse product JSON from script tag");
      }
    }
    return null;
  }
  getProductPrice(productData, variantId) {
    if (variantId && productData.variants) {
      const variant = productData.variants.find((v2) => v2.id.toString() === variantId);
      if (variant && variant.price) {
        return this.formatPrice(variant.price);
      }
    }
    if (productData.price) {
      return this.formatPrice(productData.price);
    }
    return "25";
  }
  formatPrice(price) {
    if (typeof price === "number") {
      return (price / 100).toFixed(0);
    }
    const numPrice = parseFloat(price);
    if (!isNaN(numPrice)) {
      if (numPrice > 100) {
        return (numPrice / 100).toFixed(0);
      }
      return numPrice.toFixed(0);
    }
    return price;
  }
  getProductImage(productData, variantId) {
    if (variantId && productData.variants) {
      const variant = productData.variants.find((v2) => v2.id.toString() === variantId);
      if (variant && variant.featured_image) {
        return variant.featured_image;
      }
    }
    if (productData.featured_image) {
      return productData.featured_image;
    }
    if (productData.images && productData.images.length > 0) {
      return productData.images[0].src;
    }
    return "";
  }
  async showModal(productTitle, productHandle, productPrice) {
    this.modal = document.querySelector("free-product-with-membership-modal");
    if (!this.modal) {
      this.modal = document.createElement("free-product-with-membership-modal");
      document.body.appendChild(this.modal);
    }
    this.modal.setAttribute("is-open", "true");
    this.modal.setAttribute("product-title", productTitle);
    if (productPrice) {
      this.modal.setAttribute("product-price", productPrice);
    }
    const productData = this.currentProduct || this.getProductData();
    if (productData) {
      const imageUrl = this.getProductImage(productData, this.currentVariantId);
      if (imageUrl) {
        this.modal.setAttribute("product-image", imageUrl);
      }
    }
  }
  hideModal() {
    if (this.modal) {
      this.modal.setAttribute("is-open", "false");
      this.modal.remove();
      this.modal = null;
    }
    this.currentProduct = null;
    this.currentVariantId = null;
    this.currentFormData = null;
  }
  async handleMembershipAddToCart() {
    if (!this.currentFormData && !this.currentVariantId) {
      this.captureCurrentProductData();
    }
    try {
      const items = [];
      let originalProductAdded = false;
      if (this.currentFormData) {
        const variantId = this.currentFormData.get("id");
        const quantity = this.currentFormData.get("quantity") || "1";
        const sellingPlan = this.currentFormData.get("selling_plan");
        if (variantId) {
          const originalItem = {
            id: variantId,
            quantity: parseInt(quantity.toString())
          };
          if (sellingPlan) {
            originalItem.selling_plan = sellingPlan;
          }
          const properties = {};
          this.currentFormData.forEach((value, key) => {
            const propertyMatch = key.match(/^properties\[(.+)\]$/);
            if (propertyMatch && value) {
              properties[propertyMatch[1]] = value.toString();
            }
          });
          if (Object.keys(properties).length > 0) {
            originalItem.properties = properties;
          }
          items.push(originalItem);
          originalProductAdded = true;
        }
      }
      if (!originalProductAdded) {
        if (this.currentVariantId) {
          items.push({
            id: this.currentVariantId,
            quantity: 1
          });
          originalProductAdded = true;
        } else if (this.currentProduct && this.currentProduct.variants && this.currentProduct.variants.length > 0) {
          const firstVariant = this.currentProduct.variants[0];
          items.push({
            id: firstVariant.id.toString(),
            quantity: 1
          });
          originalProductAdded = true;
        }
      }
      const membershipItem = {
        id: "44792925257894",
        // AF+ membership variant ID
        quantity: 1,
        selling_plan: "1580236966"
        // AF+ subscription selling plan
      };
      items.push(membershipItem);
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          items
        })
      });
      if (response.ok) {
        const data = await response.json();
        this.hideModal();
        await this.refreshCartAndDispatchEvents();
      } else {
        const errorData = await response.json();
        console.error("Cart add error:", errorData);
        alert("Sorry, there was an error adding the items to your cart. Please try again.");
      }
    } catch (error) {
      console.error("Error adding products to cart:", error);
      alert("Sorry, there was an error. Please try again.");
    }
  }
  async handlePayFullPrice() {
    try {
      const items = [];
      if (this.currentFormData) {
        const variantId = this.currentFormData.get("id");
        const quantity = this.currentFormData.get("quantity") || "1";
        const sellingPlan = this.currentFormData.get("selling_plan");
        if (variantId) {
          const originalItem = {
            id: variantId,
            quantity: parseInt(quantity.toString())
          };
          if (sellingPlan) {
            originalItem.selling_plan = sellingPlan;
          }
          const properties = {};
          this.currentFormData.forEach((value, key) => {
            const propertyMatch = key.match(/^properties\[(.+)\]$/);
            if (propertyMatch && value) {
              properties[propertyMatch[1]] = value.toString();
            }
          });
          if (Object.keys(properties).length > 0) {
            originalItem.properties = properties;
          }
          items.push(originalItem);
        }
      } else if (this.currentVariantId) {
        items.push({
          id: this.currentVariantId,
          quantity: 1
        });
      } else if (this.currentProduct && this.currentProduct.variants && this.currentProduct.variants.length > 0) {
        const firstVariant = this.currentProduct.variants[0];
        items.push({
          id: firstVariant.id.toString(),
          quantity: 1
        });
      }
      if (items.length === 0) {
        alert("Sorry, there was an error adding the item to your cart. Please try again.");
        return;
      }
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          items
        })
      });
      if (response.ok) {
        const data = await response.json();
        this.hideModal();
        await this.refreshCartAndDispatchEvents();
      } else {
        const errorData = await response.json();
        console.error("Cart add error:", errorData);
        alert("Sorry, there was an error adding the item to your cart. Please try again.");
      }
    } catch (error) {
      console.error("Error adding product to cart at full price:", error);
      alert("Sorry, there was an error. Please try again.");
    }
  }
  async addToCart(variantId, quantity = 1) {
    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", quantity.toString());
    return this.addToCartFromFormData(formData);
  }
  async addToCartFromFormData(formData) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      body: formData
    });
    if (!response.ok) {
      throw new Error("Failed to add product to cart");
    }
    return response.json();
  }
  captureCurrentProductData() {
    if (!this.currentProduct) {
      this.currentProduct = this.getProductData();
    }
    if (!this.currentVariantId) {
      const variantInputs = document.querySelectorAll('input[name="id"], select[name="id"]');
      for (let i2 = 0; i2 < variantInputs.length; i2++) {
        const input = variantInputs[i2];
        const value = input.value;
        if (value && value !== "") {
          this.currentVariantId = value;
          break;
        }
      }
      if (!this.currentVariantId) {
        const productElement = document.querySelector("[data-product-variant], [data-variant-id]");
        if (productElement) {
          this.currentVariantId = productElement.getAttribute("data-product-variant") || productElement.getAttribute("data-variant-id");
        }
      }
    }
    if (!this.currentFormData && this.currentVariantId) {
      this.currentFormData = new FormData();
      this.currentFormData.append("id", this.currentVariantId);
      this.currentFormData.append("quantity", "1");
    }
  }
  async refreshCartAndDispatchEvents() {
    try {
      const cartResponse = await fetch("/cart.js");
      const cartData = cartResponse.ok ? await cartResponse.json() : null;
      document.dispatchEvent(new CustomEvent("theme:cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartData
        }
      }));
      document.dispatchEvent(new CustomEvent("theme:product:added", {
        bubbles: true,
        detail: {
          cart: cartData
        }
      }));
      window.dispatchEvent(new CustomEvent("cart:added", {
        detail: {
          cart: cartData
        }
      }));
      window.dispatchEvent(new CustomEvent("cart:updated", {
        detail: {
          cart: cartData
        }
      }));
      document.dispatchEvent(new CustomEvent("theme:cart:change", {
        bubbles: true,
        detail: {
          cart: cartData
        }
      }));
      await this.openCartDrawerSafely();
    } catch (error) {
      console.error("Error refreshing cart:", error);
    }
  }
  async openCartDrawerSafely() {
    try {
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        const CartDrawerClass = customElements.get("cart-drawer");
        if (CartDrawerClass && cartDrawer instanceof CartDrawerClass) {
          cartDrawer.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
          return;
        } else {
          await customElements.whenDefined("cart-drawer");
          cartDrawer.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
          return;
        }
      }
      document.dispatchEvent(new CustomEvent("theme:cart-drawer:show", {
        bubbles: true
      }));
      requestAnimationFrame(() => {
        const delayedCartDrawer = document.querySelector("cart-drawer");
        if (delayedCartDrawer) {
          delayedCartDrawer.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
        }
      });
    } catch (error) {
      console.error("Error opening cart drawer:", error);
      requestAnimationFrame(() => {
        window.location.href = "/cart";
      });
    }
  }
}
const freeProductWithMembershipHandler = new FreeProductWithMembershipHandler();
window.freeProductWithMembershipHandler = freeProductWithMembershipHandler;
class GlobalMembershipCache {
  constructor() {
    this.state = {
      status: "not-member",
      memberships: [],
      customerId: null,
      isLoading: false,
      lastUpdated: 0
    };
    this.listeners = /* @__PURE__ */ new Set();
    this.CACHE_DURATION = 5 * 60 * 1e3;
    this.initPromise = null;
    this.initialize();
  }
  async initialize() {
    if (this.initPromise) return this.initPromise;
    this.initPromise = (async () => {
      if (typeof window !== "undefined" && this.isCustomerLoggedIn()) {
        await this.refresh();
      }
    })();
    return this.initPromise;
  }
  isCustomerLoggedIn() {
    return document.body.classList.contains("customer-logged-in") || !!(window.customer && window.customer.id);
  }
  notifyListeners() {
    this.listeners.forEach((listener) => listener({
      ...this.state
    }));
  }
  /**
   * Get current membership state (synchronous)
   * Returns cached data or defaults if not available
   */
  getState() {
    return {
      ...this.state
    };
  }
  /**
   * Get current membership state with automatic refresh if stale
   */
  async getStateAsync() {
    await this.initialize();
    if (this.isStale() && !this.state.isLoading) {
      await this.refresh();
    }
    return {
      ...this.state
    };
  }
  /**
   * Get just the membership status (most common use case)
   */
  getMembershipStatus() {
    return this.state.status;
  }
  /**
   * Get membership status with auto-refresh if needed
   */
  async getMembershipStatusAsync() {
    const state = await this.getStateAsync();
    return state.status;
  }
  /**
   * Check if cached data is stale
   */
  isStale() {
    if (this.state.lastUpdated === 0) return true;
    return Date.now() - this.state.lastUpdated > this.CACHE_DURATION;
  }
  /**
   * Refresh membership data from API
   */
  async refresh() {
    if (this.state.isLoading) return;
    try {
      this.state.isLoading = true;
      this.notifyListeners();
      const result = await membershipService.getCurrentMembershipStatus();
      this.state = {
        status: result.status,
        memberships: result.memberships,
        customerId: result.customerId,
        isLoading: false,
        lastUpdated: Date.now()
      };
      this.notifyListeners();
    } catch (error) {
      console.error("Error refreshing global membership cache:", error);
      this.state = {
        status: "not-member",
        memberships: [],
        customerId: this.state.customerId,
        isLoading: false,
        lastUpdated: Date.now()
      };
      this.notifyListeners();
    }
  }
  /**
   * Subscribe to membership state changes
   */
  subscribe(listener) {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
  /**
   * Clear the cache and reset state
   */
  clear() {
    if (this.state.customerId) {
      membershipService.clearCache(this.state.customerId);
    }
    this.state = {
      status: "not-member",
      memberships: [],
      customerId: null,
      isLoading: false,
      lastUpdated: 0
    };
    this.notifyListeners();
  }
  /**
   * Force immediate refresh (clears cache first)
   */
  async forceRefresh() {
    this.clear();
    await this.refresh();
  }
  /**
   * Quick synchronous check for common use cases
   */
  isUpgradable() {
    return this.state.status === "upgradable";
  }
  isMember() {
    return this.state.status === "upgradable" || this.state.status === "not-upgradeable";
  }
  hasFullAccess() {
    return this.state.status === "not-upgradeable";
  }
  isNotMember() {
    return this.state.status === "not-member";
  }
}
const globalMembershipCache = new GlobalMembershipCache();
const getMembershipStatus = () => globalMembershipCache.getMembershipStatus();
const getMembershipStatusAsync = () => globalMembershipCache.getMembershipStatusAsync();
const refreshMembershipStatus = () => globalMembershipCache.refresh();
const isUpgradableMember = () => globalMembershipCache.isUpgradable();
const isMember = () => globalMembershipCache.isMember();
const hasFullAccess = () => globalMembershipCache.hasFullAccess();
const isNotMember = () => globalMembershipCache.isNotMember();
if (typeof window !== "undefined") {
  window.membershipCache = {
    getStatus: getMembershipStatus,
    getStatusAsync: getMembershipStatusAsync,
    refresh: refreshMembershipStatus,
    isUpgradable: isUpgradableMember,
    isMember,
    hasFullAccess,
    isNotMember
  };
}
class MembershipUpgradeHandler {
  // REMOVED: mutationObserver - was only used for quick add integration
  constructor() {
    this.modal = null;
    this.currentProduct = null;
    this.currentVariantId = null;
    this.currentFormData = null;
    this.setupModal();
    this.setupEventListeners();
    window.membershipUpgradeModal = {
      show: this.showModal.bind(this),
      hide: this.hideModal.bind(this)
    };
    window.membershipUpgradeHandler = this;
    this.cleanupExistingModals();
  }
  resetState() {
    this.currentProduct = null;
    this.currentVariantId = null;
    this.currentFormData = null;
  }
  cleanupExistingModals() {
    const existingModals = document.querySelectorAll("membership-upgrade-modal");
    existingModals.forEach((modal) => {
      modal.setAttribute("is-open", "false");
      modal.style.pointerEvents = "none";
      const dialog = modal.querySelector("dialog");
      if (dialog && dialog.open) {
        try {
          dialog.close();
        } catch (e) {
          dialog.removeAttribute("open");
        }
      }
    });
    document.body.style.overflow = "";
  }
  // Public method for handling membership upgrade from quick add buttons and other external calls
  async handleMembershipUpgrade(button, productData) {
    var _a, _b;
    if (productData && typeof productData === "object") {
      this.currentVariantId = productData.variantId;
      if (productData.variantId) {
        this.currentFormData = new FormData();
        this.currentFormData.append("id", productData.variantId);
        this.currentFormData.append("quantity", ((_a = productData.quantity) == null ? void 0 : _a.toString()) || "1");
        if (productData.properties) {
          Object.entries(productData.properties).forEach(([key, value]) => {
            this.currentFormData.append(`properties[${key}]`, value);
          });
        }
        if (productData.sellingPlan) {
          this.currentFormData.append("selling_plan", productData.sellingPlan);
        }
      }
      const fullProductData = await this.getProductData(productData.handle);
      if (fullProductData && await this.shouldShowUpgradeModal(fullProductData)) {
        this.currentProduct = fullProductData;
        const membershipData = await globalMembershipCache.getState();
        const membershipStatus = (membershipData == null ? void 0 : membershipData.status) || "not-member";
        await this.showModal(productData.title, productData.handle, void 0, void 0, membershipStatus);
      }
      return;
    }
    if (typeof productData === "string") {
      await this.showModal(productData, void 0, void 0, void 0, "not-member");
      return;
    }
    const gridItem = button.closest("[data-grid-item]") || button.closest(".product-item");
    const titleElement = gridItem == null ? void 0 : gridItem.querySelector(".product-item__title, .product-title, [data-product-title]");
    const title = ((_b = titleElement == null ? void 0 : titleElement.textContent) == null ? void 0 : _b.trim()) || "this product";
    await this.showModal(title, void 0, void 0, void 0, "not-member");
  }
  // REMOVED: setupQuickAddIntegration method - this was causing the bug where
  // members-only popups were triggering on quick add buttons instead of add-to-cart buttons
  // Quick synchronous check based on product tags
  shouldShowUpgradeModalSync(productTags) {
    const tags = productTags.toLowerCase();
    return !tags.includes("members-only-product") && !tags.includes("free-product-with-membership") && !tags.includes("membership") && !tags.includes("af+") && !tags.includes("subscription") && !tags.includes("magazine");
  }
  setupModal() {
    if (customElements.get("membership-upgrade-modal")) {
      this.createModalElement();
    } else {
      customElements.whenDefined("membership-upgrade-modal").then(() => {
        this.createModalElement();
      }).catch(() => {
        this.createFallbackModal();
      });
    }
  }
  createModalElement() {
    this.modal = document.createElement("membership-upgrade-modal");
    this.modal.setAttribute("is-open", "false");
    this.modal.setAttribute("product-title", "");
    this.modal.setAttribute("product-handle", "");
    this.modal.style.position = "fixed";
    this.modal.style.top = "0";
    this.modal.style.left = "0";
    this.modal.style.width = "100%";
    this.modal.style.height = "100%";
    this.modal.style.pointerEvents = "none";
    this.modal.style.zIndex = "9999";
    document.body.appendChild(this.modal);
  }
  createFallbackModal() {
    var _a, _b, _c, _d;
    this.modal = document.createElement("div");
    this.modal.id = "membership-upgrade-modal-fallback";
    this.modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 9999;
      display: none;
      justify-content: center;
      align-items: center;
    `;
    this.modal.innerHTML = `
      <div style="background: black; color: white; padding: 40px; border-radius: 8px; max-width: 400px; text-align: center;">
        <h2 style="font-size: 60px; margin-bottom: 20px;">Save 30%</h2>
        <p style="margin-bottom: 30px;">Become a Member to get 30% off every order.</p>
        <button id="upgrade-modal-add-membership" style="background: #baba00; color: black; padding: 14px 28px; border: none; border-radius: 8px; font-weight: bold; cursor: pointer; margin-bottom: 20px; width: 100%;">ADD MEMBERSHIP</button>
        <div style="font-size: 14px; margin-bottom: 10px;">
          <span>Already a member? </span>
          <a href="https://autostraddle.forthem.com/login?return_to=${window.location.href}" id="upgrade-modal-sign-in" style="color: white; text-decoration: underline;">Sign In</a>
        </div>
        <button id="upgrade-modal-pay-full-price" style="background: transparent; color: white; border: none; text-decoration: underline; cursor: pointer;">I prefer to pay full price.</button>
        <button id="upgrade-modal-close" style="position: absolute; top: 10px; right: 10px; background: transparent; color: white; border: none; font-size: 24px; cursor: pointer;">×</button>
      </div>
    `;
    document.body.appendChild(this.modal);
    (_a = this.modal.querySelector("#upgrade-modal-close")) == null ? void 0 : _a.addEventListener("click", () => this.hideModal());
    (_b = this.modal.querySelector("#upgrade-modal-add-membership")) == null ? void 0 : _b.addEventListener("click", () => this.handleAddMembership());
    (_c = this.modal.querySelector("#upgrade-modal-sign-in")) == null ? void 0 : _c.addEventListener("click", () => this.handleSignIn());
    (_d = this.modal.querySelector("#upgrade-modal-pay-full-price")) == null ? void 0 : _d.addEventListener("click", () => this.handlePayFullPrice());
  }
  setupEventListeners() {
    document.addEventListener("submit", (e) => {
      const form = e.target;
      if (form.matches('[action*="/cart/add"]') || form.action && form.action.includes("/cart/add")) {
        const submitButton = form.querySelector('[type="submit"]:focus');
        this.handleFormSubmit(e, submitButton || form.querySelector('[type="submit"]'));
      }
    }, true);
    document.addEventListener("click", (e) => {
      const button = e.target;
      if (button.matches('[data-add-to-cart], [data-action="add-to-cart"], .btn-add-to-cart, [type="submit"][name="add"], [name="add"], .product-form__cart-submit, [data-add-to-cart-bar]')) {
        if (e._bypassUpgradeHandler) {
          console.log("[upgrade-handler] bypassing upgrade handler");
          return;
        }
        this.handleAddToCartClick(e, button);
      }
    }, true);
    document.addEventListener("popup-handlers:refresh", () => {
      this.resetState();
    });
    document.addEventListener("popup-handlers:content-updated", () => {
      this.resetState();
    });
    document.addEventListener("theme:recently-viewed:loaded", () => {
      this.resetState();
    });
    document.addEventListener("theme:complementary:loaded", () => {
      this.resetState();
    });
    if (typeof window !== "undefined") {
      window.membershipUpgradeModal = {
        show: this.showModal.bind(this),
        hide: this.hideModal.bind(this)
      };
      window.testMembershipUpgradeModal = () => {
        this.showModal("Test Product", void 0, void 0, void 0, "upgradable");
      };
      window.testGridItemMembershipModal = () => {
        const testProduct = {
          handle: "test-product",
          title: "Test Grid Item Product",
          tags: ["regular-product"]
          // Not a members-only or free-product-with-membership
        };
        this.currentProduct = testProduct;
        this.currentFormData = null;
        this.currentVariantId = null;
        this.showModal(testProduct.title, testProduct.handle, void 0, void 0, "not-member");
      };
      window.testMembershipUpgradeTagLogic = () => {
        const testProducts = [{
          title: "Regular Product",
          tags: ["clothing", "sale"],
          shouldShow: true
        }, {
          title: "Members Only Product",
          tags: ["members-only-product"],
          shouldShow: false
        }, {
          title: "Free Product with Membership",
          tags: ["free-product-with-membership"],
          shouldShow: false
        }, {
          title: "AF+ Product",
          tags: ["af+"],
          shouldShow: false
        }, {
          title: "Membership Product",
          tags: ["membership"],
          shouldShow: false
        }, {
          title: "Subscription Product",
          tags: ["subscription"],
          shouldShow: false
        }, {
          title: "Magazine Product",
          tags: ["magazine"],
          shouldShow: false
        }, {
          title: "Mixed Tags Product",
          tags: ["clothing", "members-only-product", "sale"],
          shouldShow: false
        }, {
          title: "Another Regular Product",
          tags: ["accessories"],
          shouldShow: true
        }];
        testProducts.forEach((product) => {
          const isExcluded = this.isExcludedProduct(product);
          const shouldShow = !isExcluded;
          shouldShow === product.shouldShow ? "PASS" : "FAIL";
        });
      };
      window.testModalStateReset = () => {
        this.resetState();
        this.currentProduct = {
          title: "Product A",
          handle: "product-a",
          tags: ["clothing"]
        };
        this.currentVariantId = "12345";
        this.resetState();
        this.currentProduct = {
          title: "Product B",
          handle: "product-b",
          tags: ["accessories"]
        };
        this.currentVariantId = "67890";
        this.currentProduct.title === "Product B" && this.currentVariantId === "67890";
      };
      window.testGridItemAddToCart = () => {
        const addToCartButtons = document.querySelectorAll("[data-add-to-cart]");
        addToCartButtons.forEach((button, index) => {
          const productData = this.getProductDataFromPage(button);
          if (productData) {
            this.isExcludedProduct(productData);
          }
        });
      };
      window.forceTestMembershipModal = (productTitle = "Test Product") => {
        this.resetState();
        this.currentProduct = {
          title: productTitle,
          handle: "test-product",
          tags: ["regular"]
        };
        this.showModal(productTitle, "test-product", void 0, void 0, "not-member");
      };
      window.debugMembershipUpgradeState = () => {
      };
      window.forceShowMembershipModal = () => {
        if (this.modal) {
          const dialog = this.modal.querySelector("dialog");
          if (dialog) {
            dialog.setAttribute("open", "");
            dialog.style.display = "flex";
          }
        }
      };
      window.forceCloseMembershipModal = () => {
        this.cleanupExistingModals();
        if (this.modal) {
          this.modal.setAttribute("is-open", "false");
          this.modal.style.pointerEvents = "none";
          const dialog = this.modal.querySelector("dialog");
          if (dialog) {
            if (dialog.open) {
              dialog.close();
            }
            dialog.removeAttribute("open");
            dialog.style.display = "none";
          }
        }
      };
      window.debugMembershipModal = () => {
      };
    }
  }
  async handleFormSubmit(e, button) {
    var _a;
    this.resetState();
    e.preventDefault();
    e.stopPropagation();
    const productData = this.getProductDataFromPage(button);
    if (!productData) {
      this.proceedWithOriginalFormSubmit(e.target, button);
      return;
    }
    if (this.isExcludedProduct(productData)) {
      this.proceedWithOriginalFormSubmit(e.target, button);
      return;
    }
    try {
      const shouldShow = await this.shouldShowUpgradeModal(productData);
      if (shouldShow) {
        const membershipData = await globalMembershipCache.getState();
        const membershipStatus = (membershipData == null ? void 0 : membershipData.status) || "not-member";
        const form = e.target;
        this.currentFormData = new FormData(form);
        this.currentProduct = productData;
        this.currentVariantId = ((_a = this.currentFormData.get("id")) == null ? void 0 : _a.toString()) || null;
        this.showModal(productData.title, productData.handle, this.currentVariantId || void 0, this.currentFormData, membershipStatus);
      } else {
        this.proceedWithOriginalFormSubmit(e.target, button);
      }
    } catch (error) {
      this.proceedWithOriginalFormSubmit(e.target, button);
    }
  }
  async handleAddToCartClick(event, button) {
    var _a;
    this.resetState();
    console.log("[upgrade-handler] handleAddToCartClick", button);
    event.preventDefault();
    event.stopPropagation();
    const productData = this.getProductDataFromPage(button);
    if (!productData) {
      const form = button.closest("form");
      if (form) {
        this.proceedWithOriginalButtonClick(button, form);
      }
      return;
    }
    try {
      const shouldShow = await this.shouldShowUpgradeModal(productData);
      if (shouldShow) {
        const membershipData = await globalMembershipCache.getState();
        const membershipStatus = (membershipData == null ? void 0 : membershipData.status) || "not-member";
        const form = button.closest("form");
        if (form) {
          this.currentFormData = new FormData(form);
          this.currentVariantId = ((_a = this.currentFormData.get("id")) == null ? void 0 : _a.toString()) || null;
        } else {
          this.currentFormData = null;
          this.currentVariantId = null;
        }
        this.currentProduct = productData;
        this.showModal(productData.title, productData.handle, this.currentVariantId || void 0, this.currentFormData || void 0, membershipStatus);
      } else {
        const form = button.closest("form");
        if (form) {
          this.proceedWithOriginalButtonClick(button, form);
        }
      }
    } catch (error) {
      const form = button.closest("form");
      if (form) {
        this.proceedWithOriginalButtonClick(button, form);
      }
    }
  }
  // Method to proceed with original form submission when modal shouldn't show
  proceedWithOriginalFormSubmit(form, button) {
    requestAnimationFrame(() => {
      const bypassEvent = new Event("submit", {
        bubbles: true,
        cancelable: true
      });
      bypassEvent._bypassUpgradeHandler = true;
      document.dispatchEvent(new CustomEvent("theme:cart:add", {
        detail: {
          button
        },
        bubbles: true
      }));
    });
  }
  // Method to proceed with original button click behavior when modal shouldn't show
  proceedWithOriginalButtonClick(button, form) {
    requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent("theme:cart:add", {
        detail: {
          button
        },
        bubbles: true
      }));
    });
  }
  // Method to proceed with original quick add button click when modal shouldn't show
  proceedWithOriginalQuickAddClick(button) {
    requestAnimationFrame(() => {
      const bypassEvent = new MouseEvent("click", {
        bubbles: true,
        cancelable: true
      });
      bypassEvent._bypassUpgradeHandler = true;
      button.dispatchEvent(bypassEvent);
    });
  }
  getProductHandleFromForm(form) {
    const action = form.getAttribute("action");
    if (action && action.includes("/products/")) {
      const match = action.match(/\/products\/([^\/]+)/);
      if (match) return match[1];
    }
    return window.location.pathname.split("/").pop() || "";
  }
  async getProductData(productHandle) {
    try {
      if (window.product && window.product.handle === productHandle) {
        return window.product;
      }
      const response = await fetch(`/products/${productHandle}.js`);
      if (response.ok) {
        return await response.json();
      }
    } catch (error) {
    }
    return null;
  }
  getProductDataFromPage(button) {
    if (button) {
      const productHandle = button.getAttribute("data-product-handle");
      const productTags = button.getAttribute("data-product-tags") || "";
      const productId = button.getAttribute("data-product-id");
      const productTitle = button.getAttribute("data-product-title");
      if (productHandle && productTags !== null) {
        const basicProductData = {
          id: productId || productHandle,
          handle: productHandle,
          title: productTitle || "Product",
          tags: productTags.split(",").map((tag) => tag.trim()).filter((tag) => tag.length > 0),
          variants: []
        };
        const form = button.closest('form[action*="/cart/add"]');
        if (form) {
          const variantInput = form.querySelector('input[name="id"], select[name="id"]');
          if (variantInput && variantInput.value) {
            basicProductData.variants = [{
              id: parseInt(variantInput.value)
            }];
          }
        }
        return basicProductData;
      }
    }
    if (window.product) {
      return window.product;
    }
    return null;
  }
  isExcludedProduct(productData) {
    var _a, _b;
    const excludedTags = ["members-only-product", "free-product-with-membership", "membership", "af+", "subscription", "magazine"];
    const hasExcludedTag = productData.tags.some((tag) => {
      const lowerTag = tag.toLowerCase();
      return excludedTags.some((excludedTag) => {
        if (excludedTag === "membership" || excludedTag === "af+") {
          return lowerTag.includes(excludedTag);
        }
        return lowerTag === excludedTag;
      });
    });
    if (hasExcludedTag) {
      return true;
    }
    if (((_b = (_a = window.product) == null ? void 0 : _a.selling_plan_groups) == null ? void 0 : _b.length) > 0) {
      return true;
    }
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]:checked, select[name="selling_plan"]');
    if (sellingPlanInput == null ? void 0 : sellingPlanInput.value) {
      return true;
    }
    return false;
  }
  /**
   * Get cart data, ensuring it's fresh
   */
  async getCartData() {
    try {
      const response = await fetch("/cart.js");
      if (response.ok) {
        const cart = await response.json();
        return cart;
      }
    } catch (error) {
      console.log("MembershipUpgradeHandler - Error fetching cart data:", error);
    }
    return null;
  }
  /**
   * Check if the cart already contains a subscription that satisfies the membership requirement
   */
  async cartHasQualifyingSubscription(productData) {
    const cart = await this.getCartData();
    if (!cart || !cart.items || cart.items.length === 0) {
      return false;
    }
    for (const item of cart.items) {
      if (item.selling_plan_allocation) {
        if (this.isKnownMembershipSubscription(item)) {
          return true;
        }
      } else {
        if (this.isKnownMembershipSubscription(item)) {
          return true;
        }
      }
    }
    return false;
  }
  /**
   * Check if a cart item is a known membership subscription
   */
  isKnownMembershipSubscription(cartItem) {
    var _a, _b, _c, _d;
    const membershipVariantIds = ["44792925257894", "46214081347750"];
    const membershipHandles = ["af-membership", "support-the-community", "af-plus-toki"];
    const variantIdMatch = membershipVariantIds.includes((_a = cartItem.variant_id) == null ? void 0 : _a.toString()) || membershipVariantIds.includes((_b = cartItem.id) == null ? void 0 : _b.toString());
    const handleMatch = membershipHandles.includes(cartItem.handle) || membershipHandles.includes(cartItem.product_handle);
    const title = ((_c = cartItem.title) == null ? void 0 : _c.toLowerCase()) || "";
    const productTitle = ((_d = cartItem.product_title) == null ? void 0 : _d.toLowerCase()) || "";
    const titleMatch = (
      // Specific membership names that should bypass the modal
      title.includes(FORTHEM_TIER_NAME_ALLACCESS.toLowerCase()) || productTitle.includes(FORTHEM_TIER_NAME_ALLACCESS.toLowerCase()) || title.includes(FORTHEM_TIER_NAME_SUPPORT.toLowerCase()) || productTitle.includes(FORTHEM_TIER_NAME_SUPPORT.toLowerCase()) || title.includes("all access") || productTitle.includes("all access") || // General membership keywords
      title.includes("membership") || productTitle.includes("membership") || title.includes("support the community") || productTitle.includes("support the community")
    );
    const isMatch = variantIdMatch || handleMatch || titleMatch;
    return isMatch;
  }
  async shouldShowUpgradeModal(productData) {
    if (this.isExcludedProduct(productData)) {
      return false;
    }
    const hasCartBypass = await this.cartHasQualifyingSubscription(productData);
    if (hasCartBypass) {
      return false;
    }
    const isLoggedIn = document.body.classList.contains("customer-logged-in") || window.customer && window.customer.id;
    if (!isLoggedIn) {
      return true;
    }
    try {
      const membershipData = await globalMembershipCache.getState();
      if ((membershipData == null ? void 0 : membershipData.memberships) && membershipData.memberships.length > 0) {
        const membershipName = membershipData.memberships[0].name.toLowerCase();
        if (membershipName === FORTHEM_TIER_NAME_ALLACCESS.toLowerCase() || membershipName === FORTHEM_TIER_NAME_SUPPORT.toLowerCase() || membershipName === "all access") {
          return false;
        }
      }
      const membershipStatus = await getMembershipStatusAsync();
      const shouldShow = membershipStatus === "not-member" || membershipStatus === "upgradable";
      return shouldShow;
    } catch (error) {
      return true;
    }
  }
  async showModal(productTitle, productHandle, variantId, formData, membershipStatus) {
    if (!this.modal) {
      this.createFallbackModal();
    }
    if (!this.modal) {
      return;
    }
    if (this.modal.tagName.toLowerCase() === "membership-upgrade-modal") {
      this.modal.setAttribute("is-open", "true");
      this.modal.setAttribute("product-title", productTitle);
      this.modal.setAttribute("product-handle", productHandle || "");
      this.modal.setAttribute("membership-status", membershipStatus || "not-member");
      this.modal.style.pointerEvents = "auto";
      this.modal.onClose = this.hideModal.bind(this);
      this.modal.onAddMembership = this.handleAddMembership.bind(this);
      this.modal.onSignIn = this.handleSignIn.bind(this);
      this.modal.onPayFullPrice = this.handlePayFullPrice.bind(this);
    } else {
      const titleElement = this.modal.querySelector("h2");
      if (titleElement && productTitle !== "this product") {
        titleElement.textContent = `Save 30% on ${productTitle}`;
      }
    }
    if (this.modal.id === "membership-upgrade-modal-fallback") {
      this.modal.style.display = "flex";
      document.body.style.overflow = "hidden";
    }
  }
  hideModal() {
    if (!this.modal) return;
    if (this.modal.tagName.toLowerCase() === "membership-upgrade-modal") {
      this.modal.setAttribute("is-open", "false");
      this.modal.style.pointerEvents = "none";
    } else if (this.modal.id === "membership-upgrade-modal-fallback") {
      this.modal.style.display = "none";
    }
    document.body.style.overflow = "";
    this.currentProduct = null;
    this.currentVariantId = null;
    this.currentFormData = null;
  }
  async handleAddMembership() {
    var _a, _b, _c, _d;
    try {
      const items = [];
      if (this.currentFormData) {
        const variantId = (_a = this.currentFormData.get("id")) == null ? void 0 : _a.toString();
        const quantity = parseInt(((_b = this.currentFormData.get("quantity")) == null ? void 0 : _b.toString()) || "1");
        const sellingPlan = (_c = this.currentFormData.get("selling_plan")) == null ? void 0 : _c.toString();
        if (variantId) {
          const item = {
            id: variantId,
            quantity
          };
          if (sellingPlan) {
            item.selling_plan = sellingPlan;
          }
          items.push(item);
        }
      } else if (this.currentVariantId) {
        items.push({
          id: this.currentVariantId,
          quantity: 1
        });
      }
      const membershipItem = {
        id: "44792925257894",
        // AF+ membership variant ID
        quantity: 1,
        selling_plan: "1574961318"
        // AF+ subscription selling plan
      };
      items.push(membershipItem);
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          items
        })
      });
      if (response.ok) {
        if (!this.currentFormData && !this.currentVariantId && ((_d = this.currentProduct) == null ? void 0 : _d.handle)) {
          const quickAddButton = document.querySelector(`[data-quick-add-modal-handle="${this.currentProduct.handle}"]`);
          if (quickAddButton) {
            this.hideModal();
            setTimeout(() => {
              const bypassEvent = new MouseEvent("click", {
                bubbles: true,
                cancelable: true
              });
              bypassEvent._bypassUpgradeHandler = true;
              quickAddButton.dispatchEvent(bypassEvent);
            }, 300);
            return;
          }
        }
        await this.refreshCartAndOpenDrawer();
      } else {
        alert("Sorry, there was an error adding items to your cart. Please try again.");
      }
    } catch (error) {
      alert("Sorry, there was an error. Please try again.");
    }
  }
  handleSignIn() {
    window.location.href = `https://autostraddle.forthem.com/login?return_to=${window.location.href}`;
  }
  async handlePayFullPrice() {
    var _a, _b, _c, _d;
    try {
      if (!this.currentFormData) {
        const quickAddButton = document.querySelector(`[data-quick-add-modal-handle="${(_a = this.currentProduct) == null ? void 0 : _a.handle}"]`);
        if (quickAddButton) {
          this.hideModal();
          requestAnimationFrame(() => {
            const bypassEvent = new MouseEvent("click", {
              bubbles: true,
              cancelable: true
            });
            bypassEvent._bypassUpgradeHandler = true;
            quickAddButton.dispatchEvent(bypassEvent);
          });
          return;
        }
      }
      const items = [];
      if (this.currentFormData) {
        const variantId = (_b = this.currentFormData.get("id")) == null ? void 0 : _b.toString();
        const quantity = parseInt(((_c = this.currentFormData.get("quantity")) == null ? void 0 : _c.toString()) || "1");
        const sellingPlan = (_d = this.currentFormData.get("selling_plan")) == null ? void 0 : _d.toString();
        if (variantId) {
          const item = {
            id: variantId,
            quantity
          };
          if (sellingPlan) {
            item.selling_plan = sellingPlan;
          }
          items.push(item);
        }
      } else if (this.currentVariantId) {
        items.push({
          id: this.currentVariantId,
          quantity: 1
        });
      }
      if (items.length > 0) {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            items
          })
        });
        if (response.ok) {
          await this.refreshCartAndOpenDrawer();
        } else {
          alert("Sorry, there was an error adding the item to your cart. Please try again.");
        }
      }
    } catch (error) {
      alert("Sorry, there was an error. Please try again.");
    }
  }
  async refreshCartAndOpenDrawer() {
    try {
      const cartResponse = await fetch("/cart.js");
      const cartData = cartResponse.ok ? await cartResponse.json() : null;
      document.dispatchEvent(new CustomEvent("theme:cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartData
        }
      }));
      document.dispatchEvent(new CustomEvent("theme:product:added", {
        bubbles: true,
        detail: {
          cart: cartData
        }
      }));
      window.dispatchEvent(new CustomEvent("cart:added", {
        detail: {
          cart: cartData
        }
      }));
      window.dispatchEvent(new CustomEvent("cart:updated", {
        detail: {
          cart: cartData
        }
      }));
      await this.openCartDrawerSafely();
    } catch (error) {
    }
  }
  async openCartDrawerSafely() {
    try {
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        const CartDrawerClass = customElements.get("cart-drawer");
        if (CartDrawerClass && cartDrawer instanceof CartDrawerClass) {
          cartDrawer.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
          return;
        } else {
          await customElements.whenDefined("cart-drawer");
          cartDrawer.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
          return;
        }
      }
      document.dispatchEvent(new CustomEvent("theme:cart-drawer:show", {
        bubbles: true
      }));
      requestAnimationFrame(() => {
        const delayedCartDrawer = document.querySelector("cart-drawer");
        if (delayedCartDrawer) {
          delayedCartDrawer.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
        }
      });
    } catch (error) {
      console.error("Error opening cart drawer:", error);
      requestAnimationFrame(() => {
        window.location.href = "/cart";
      });
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  new MembershipUpgradeHandler();
});
class PopupHandlerManager {
  constructor() {
    this.isInitialized = false;
    this.observedElements = /* @__PURE__ */ new WeakSet();
    this.debounceTimer = null;
    this.init();
  }
  init() {
    if (this.isInitialized) return;
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.setupHandlers());
    } else {
      this.setupHandlers();
    }
    this.isInitialized = true;
  }
  setupHandlers() {
    this.setupMutationObserver();
    this.setupThemeEventListeners();
    this.reinitializeExistingContent();
  }
  setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      let shouldReinitialize = false;
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const element = node;
              if (this.isProductContent(element)) {
                shouldReinitialize = true;
              }
            }
          });
        }
      });
      if (shouldReinitialize) {
        this.debounceReinitialize();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  isProductContent(element) {
    return !!(element.querySelector("[data-grid-item], .product-item, quick-add-product") || element.matches("[data-grid-item], .product-item, quick-add-product") || element.querySelector('[data-add-to-cart], [data-action="add-to-cart"], [name="add"]') || element.matches('[data-add-to-cart], [data-action="add-to-cart"], [name="add"]') || element.classList.contains("grid") || element.classList.contains("product-upsell") || element.hasAttribute("data-related-section") || element.hasAttribute("data-recently-viewed-wrapper"));
  }
  debounceReinitialize() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = window.setTimeout(() => {
      this.reinitializeHandlers();
      this.debounceTimer = null;
    }, 100);
  }
  setupThemeEventListeners() {
    const events = ["theme:recently-viewed:loaded", "theme:complementary:loaded", "theme:cart-drawer:opened", "theme:quick-add:loaded", "shopify:section:load", "shopify:section:reorder"];
    events.forEach((eventName) => {
      document.addEventListener(eventName, () => {
        this.debounceReinitialize();
      });
    });
    document.addEventListener("cart:item-added", () => {
      this.debounceReinitialize();
    });
  }
  reinitializeExistingContent() {
    this.reinitializeHandlers();
  }
  reinitializeHandlers() {
    try {
      document.dispatchEvent(new CustomEvent("popup-handlers:refresh", {
        bubbles: true,
        detail: {
          source: "popup-handler-manager"
        }
      }));
      document.dispatchEvent(new CustomEvent("popup-handlers:content-updated", {
        bubbles: true,
        detail: {
          source: "popup-handler-manager"
        }
      }));
    } catch (error) {
      console.warn("Error reinitializing popup handlers:", error);
    }
  }
  // Public method to manually trigger reinitialization
  refresh() {
    this.reinitializeHandlers();
  }
}
const popupHandlerManager = new PopupHandlerManager();
window.popupHandlerManager = popupHandlerManager;
class EnhancedProductForm {
  constructor() {
    this.init();
  }
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      this.setupVariantPickerIntegration();
      this.setupCombinedListingsSupport();
      setTimeout(() => {
        this.applyInitialInventoryStates();
      }, 200);
    });
  }
  /**
   * Apply initial inventory states to all variant pickers on the page
   */
  applyInitialInventoryStates() {
    const variantPickers = document.querySelectorAll("variant-picker");
    variantPickers.forEach((picker) => {
      if (picker.applyInitialInventoryStates) {
        picker.applyInitialInventoryStates();
      }
    });
  }
  /**
   * Set up integration between variant-picker and existing product-form
   */
  setupVariantPickerIntegration() {
    const variantPickers = document.querySelectorAll("variant-picker");
    variantPickers.forEach((picker) => {
      this.enhanceVariantPicker(picker);
    });
  }
  /**
   * Enhance a variant picker with combined listings support
   */
  enhanceVariantPicker(picker) {
    const productForm = picker.closest("product-form");
    if (!productForm) return;
    picker.addEventListener("variant:selected", (event) => {
      this.handleVariantSelected(event, picker, productForm);
    });
    picker.addEventListener("variant:update", (event) => {
      this.handleVariantUpdate(event, picker, productForm);
    });
    this.integrateWithExistingHandlers(picker, productForm);
  }
  /**
   * Handle variant selection events
   */
  handleVariantSelected(event, picker, productForm) {
    const {
      id: optionValueId,
      unavailable
    } = event.detail;
    if (unavailable) {
      console.log("Unavailable variant selected - preserving selection for notify me functionality");
      return;
    }
    const input = picker.querySelector(`[data-option-value-id="${optionValueId}"], [value="${optionValueId}"]`);
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event("change", {
        bubbles: true
      }));
    }
  }
  /**
   * Handle variant update events (when switching between products in combined listings)
   */
  handleVariantUpdate(event, picker, productForm) {
    const {
      productData,
      selectedOptionId,
      meta
    } = event.detail;
    if (meta.newProduct) {
      this.updateProductFormData(productForm, meta.newProduct, productData);
    }
    this.updateInventoryStates(picker, productForm, productData);
    this.refreshProductFormState(productForm, productData);
    this.notifyThemeSystems(productData, selectedOptionId);
  }
  /**
   * Update product form data when switching products in combined listings
   */
  updateProductFormData(productForm, newProduct, productData) {
    if (productForm.container) {
      const container = productForm.container;
      const productIdElements = container.querySelectorAll("[data-product-id]");
      productIdElements.forEach((element) => {
        element.dataset.productId = newProduct.id;
      });
      const productJsonElement = container.querySelector("[data-product-json]");
      if (productJsonElement && productData) {
        productJsonElement.textContent = JSON.stringify(productData);
      }
      const forms = container.querySelectorAll('form[action*="/cart/add"]');
      forms.forEach((form) => {
        form.setAttribute("data-current-product-id", newProduct.id);
      });
    }
  }
  /**
   * Integrate with existing option change handlers
   */
  integrateWithExistingHandlers(picker, productForm) {
    picker.addEventListener("change", (event) => {
      const input = event.target;
      if (!input.matches("[data-single-option-selector]")) return;
      const connectedProductUrl = this.getConnectedProductUrl(input);
      if (connectedProductUrl) {
        if (!input.dataset.connectedProductUrl) {
          input.dataset.connectedProductUrl = connectedProductUrl;
        }
      }
    });
  }
  /**
   * Set up general combined listings support
   */
  setupCombinedListingsSupport() {
    this.enhanceSwatchInteractions();
    this.setupUrlUpdating();
    this.setupProductDataUpdating();
  }
  /**
   * Enhance existing swatch interactions to support combined listings
   */
  enhanceSwatchInteractions() {
    document.addEventListener("change", (event) => {
      const input = event.target;
      if (!input.matches("[data-single-option-selector]")) return;
      const wrapper = input.closest(".swatch-wrapper, .radio-wrapper");
      const isUnavailableSelection = wrapper == null ? void 0 : wrapper.hasAttribute("data-unavailable");
      if (isUnavailableSelection) {
        console.log("Unavailable selection reached enhanced-product-form - this should be intercepted");
        return;
      }
    });
  }
  /**
   * Handle combined listing option changes
   */
  handleCombinedListingChange(input, connectedProductUrl) {
    if (connectedProductUrl !== currentUrl) {
      console.log("Combined listing product switch detected:", {
        from: currentUrl,
        to: connectedProductUrl,
        option: input.value
      });
    }
  }
  /**
   * Get connected product URL from input element
   */
  getConnectedProductUrl(input) {
    if (input.dataset.connectedProductUrl) {
      return input.dataset.connectedProductUrl;
    }
    if (input.dataset.productUrl) {
      return input.dataset.productUrl;
    }
    return null;
  }
  /**
   * Set up URL updating for combined listings
   */
  setupUrlUpdating() {
  }
  /**
   * Set up product data updating
   */
  setupProductDataUpdating() {
    document.addEventListener("variant:update", (event) => {
      const {
        productData,
        meta
      } = event.detail;
      if (meta.newProduct) {
        if (window.product) {
          window.product = productData;
        }
        const productScripts = document.querySelectorAll("[data-product-json]");
        productScripts.forEach((script) => {
          script.textContent = JSON.stringify(productData);
        });
        this.updateAllProductForms(productData);
        this.refreshThemeSystems(productData, meta.selectedVariant);
      }
    });
  }
  /**
   * Update all product forms with new product data
   */
  updateAllProductForms(productData) {
    const productForms = document.querySelectorAll("product-form");
    productForms.forEach((form) => {
      if (form.productForm && form.productForm.product) {
        form.productForm.product = productData;
      }
    });
  }
  /**
   * Refresh theme systems after product switch
   */
  refreshThemeSystems(productData, selectedVariant) {
    try {
      if (selectedVariant) {
        const formState = {
          variant: selectedVariant,
          options: selectedVariant.options || [],
          quantity: 1,
          properties: {},
          plan: null
        };
        document.dispatchEvent(new CustomEvent("theme:product:updated", {
          detail: {
            productData,
            formState
          },
          bubbles: true
        }));
      }
    } catch (error) {
      console.warn("Error refreshing theme systems:", error);
    }
  }
  /**
   * Update inventory states when switching products
   * @param {HTMLElement} picker - The variant picker element
   * @param {HTMLElement} productForm - The product form element
   * @param {Object} productData - The new product data
   */
  updateInventoryStates(picker, productForm, productData) {
    if (!productData || !productData.variants) return;
    this.updateOptionStates(picker, productData);
    this.updateThemeVariantStates(productForm, productData);
    this.updateInventoryDisplays(picker, productData);
  }
  /**
   * Update option states based on variant availability
   * @param {HTMLElement} picker - The variant picker element
   * @param {Object} productData - The product data
   */
  updateOptionStates(picker, productData) {
    const allOptions = picker.querySelectorAll("[data-single-option-selector]");
    allOptions.forEach((option) => {
      const optionValue = option.value;
      const optionIndex = this.getOptionIndex(option);
      const hasAvailableVariants = productData.variants.some((variant) => {
        return variant.available && variant.options[optionIndex] === optionValue;
      });
      this.updateSingleOptionState(option, hasAvailableVariants);
    });
  }
  /**
   * Get option index from data attributes
   * @param {HTMLElement} option - The option element
   * @returns {number} - The option index
   */
  getOptionIndex(option) {
    if (option.dataset.index) {
      const match = option.dataset.index.match(/option(\d+)/);
      if (match) {
        return parseInt(match[1]) - 1;
      }
    }
    return 0;
  }
  /**
   * Update a single option's state
   * @param {HTMLElement} option - The option element
   * @param {boolean} isAvailable - Whether the option has available variants
   */
  updateSingleOptionState(option, isAvailable) {
    const wrapper = option.closest(".swatch-wrapper, .radio-wrapper, .option-wrapper");
    if (isAvailable) {
      wrapper == null ? void 0 : wrapper.classList.remove("soldout", "unavailable", "option-unavailable");
      wrapper == null ? void 0 : wrapper.removeAttribute("data-unavailable");
    } else {
      wrapper == null ? void 0 : wrapper.classList.add("soldout");
      wrapper == null ? void 0 : wrapper.setAttribute("data-unavailable", "true");
      option.disabled = false;
      option.removeAttribute("disabled");
    }
  }
  /**
   * Update existing theme's variant states
   * @param {HTMLElement} productForm - The product form element
   * @param {Object} productData - The product data
   */
  updateThemeVariantStates(productForm, productData) {
    const hiddenSelects = productForm.querySelectorAll('select[name="id"]');
    hiddenSelects.forEach((select) => {
      select.innerHTML = "";
      productData.variants.forEach((variant) => {
        const option = document.createElement("option");
        option.value = variant.id;
        option.textContent = variant.title;
        option.disabled = !variant.available;
        if (!variant.available) {
          option.setAttribute("disabled", "disabled");
        }
        select.appendChild(option);
      });
    });
    if (productForm.container) {
      const container = productForm.container;
      const variantAvailabilityElements = container.querySelectorAll("[data-variant-availability]");
      variantAvailabilityElements.forEach((element) => {
        const variantId = element.dataset.variantId;
        const variant = productData.variants.find((v2) => v2.id.toString() === variantId);
        if (variant) {
          element.dataset.variantAvailability = variant.available ? "true" : "false";
        }
      });
    }
  }
  /**
   * Update inventory displays
   * @param {HTMLElement} picker - The variant picker element
   * @param {Object} productData - The product data
   */
  updateInventoryDisplays(picker, productData) {
    const inventoryElements = picker.querySelectorAll("[data-inventory-count]");
    inventoryElements.forEach((element) => {
      const variantId = element.dataset.variantId;
      const variant = productData.variants.find((v2) => v2.id.toString() === variantId);
      if (variant && variant.inventory_quantity !== void 0) {
        element.textContent = variant.inventory_quantity;
        element.dataset.inventoryCount = variant.inventory_quantity;
      }
    });
    const stockMessages = picker.querySelectorAll("[data-stock-message]");
    stockMessages.forEach((element) => {
      const variantId = element.dataset.variantId;
      const variant = productData.variants.find((v2) => v2.id.toString() === variantId);
      if (variant) {
        const isLowStock = variant.inventory_quantity > 0 && variant.inventory_quantity <= 10;
        const isOutOfStock = !variant.available;
        if (isOutOfStock) {
          element.textContent = "Out of stock";
          element.classList.add("out-of-stock");
          element.classList.remove("low-stock");
        } else if (isLowStock) {
          element.textContent = `Only ${variant.inventory_quantity} left`;
          element.classList.add("low-stock");
          element.classList.remove("out-of-stock");
        } else {
          element.textContent = "";
          element.classList.remove("low-stock", "out-of-stock");
        }
      }
    });
  }
  /**
   * Refresh the existing product form state with new data
   * @param {HTMLElement} productForm - The product form element
   * @param {Object} productData - The new product data
   */
  refreshProductFormState(productForm, productData) {
    if (productForm.productForm && typeof productForm.productForm.updateProduct === "function") {
      productForm.productForm.updateProduct(productData);
    }
    const form = productForm.querySelector("form");
    if (form) {
      let productJsonElement = form.querySelector("[data-product-json]");
      if (productJsonElement) {
        productJsonElement.textContent = JSON.stringify(productData);
      }
      form.dispatchEvent(new CustomEvent("product:data-updated", {
        detail: {
          productData
        },
        bubbles: true
      }));
    }
    this.updateCurrentVariantSelection(productForm, productData);
  }
  /**
   * Update current variant selection after product switch
   * @param {HTMLElement} productForm - The product form element
   * @param {Object} productData - The product data
   */
  updateCurrentVariantSelection(productForm, productData) {
    const selectedOptions = Array.from(productForm.querySelectorAll("[data-single-option-selector]:checked")).map((input) => input.value);
    if (selectedOptions.length > 0) {
      const matchingVariant = productData.variants.find((variant) => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });
      if (matchingVariant) {
        const variantIdInput = productForm.querySelector('input[name="id"]');
        if (variantIdInput) {
          variantIdInput.value = matchingVariant.id;
          variantIdInput.dispatchEvent(new Event("change", {
            bubbles: true
          }));
        }
        this.updateVariantRelatedElements(productForm, matchingVariant, productData);
      }
    }
  }
  /**
   * Update variant-related elements with new variant data
   * @param {HTMLElement} productForm - The product form element
   * @param {Object} variant - The selected variant
   * @param {Object} productData - The product data
   */
  updateVariantRelatedElements(productForm, variant, productData) {
    const priceElements = productForm.querySelectorAll("[data-product-price]");
    priceElements.forEach((element) => {
      if (variant.price !== void 0) {
        element.textContent = this.formatPrice(variant.price);
      }
    });
    const comparePriceElements = productForm.querySelectorAll("[data-compare-price]");
    comparePriceElements.forEach((element) => {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        element.textContent = this.formatPrice(variant.compare_at_price);
        element.style.display = "";
      } else {
        element.style.display = "none";
      }
    });
    const skuElements = productForm.querySelectorAll("[data-variant-sku]");
    skuElements.forEach((element) => {
      element.textContent = variant.sku || "";
    });
    const availabilityElements = productForm.querySelectorAll("[data-variant-availability]");
    availabilityElements.forEach((element) => {
      element.textContent = variant.available ? "In stock" : "Out of stock";
      element.classList.toggle("available", variant.available);
      element.classList.toggle("unavailable", !variant.available);
    });
  }
  /**
   * Format price for display
   * @param {number} price - Price in cents
   * @returns {string} - Formatted price string
   */
  formatPrice(price) {
    if (window.theme && window.theme.formatMoney) {
      return window.theme.formatMoney(price, window.theme.moneyFormat || "${{amount}}");
    }
    return `$${(price / 100).toFixed(2)}`;
  }
  /**
   * Notify existing theme systems about variant changes
   */
  notifyThemeSystems(productData, selectedOptionId) {
    document.dispatchEvent(new CustomEvent("product:updated", {
      detail: {
        productData,
        selectedOptionId
      }
    }));
    if (window.membershipHandler) {
      window.membershipHandler.handleProductUpdate(productData);
    }
    if (window.subscriptionHandler) {
      window.subscriptionHandler.handleProductUpdate(productData);
    }
    const productForms = document.querySelectorAll("product-form");
    productForms.forEach((form) => {
      if (form.productForm && typeof form.productForm.getFormState === "function") {
        const formState = form.productForm.getFormState();
        if (form.pushState) {
          form.pushState(formState);
        }
      }
    });
  }
}
new EnhancedProductForm();
class CombinedListingsRecovery {
  constructor() {
    this.pendingRequests = /* @__PURE__ */ new Map();
    this.requestTimeouts = /* @__PURE__ */ new Map();
    this.maxRequestTime = 15e3;
    this.recoveryAttempts = /* @__PURE__ */ new Map();
    this.maxRecoveryAttempts = 3;
    this.init();
  }
  init() {
    this.setupRequestMonitoring();
    this.setupPeriodicHealthCheck();
    this.setupErrorRecovery();
  }
  /**
   * Monitor variant picker requests for stuck states
   */
  setupRequestMonitoring() {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const [url] = args;
      const urlString = typeof url === "string" ? url : url.toString();
      if (urlString.includes("/products/") && urlString.includes("section_id=")) {
        const requestId = this.generateRequestId();
        this.trackRequest(requestId, urlString);
        try {
          const response = await originalFetch.apply(window, args);
          this.completeRequest(requestId);
          return response;
        } catch (error) {
          this.handleRequestError(requestId, error);
          throw error;
        }
      }
      return originalFetch.apply(window, args);
    };
  }
  /**
   * Track a request and set timeout
   */
  trackRequest(requestId, url) {
    this.pendingRequests.set(requestId, {
      url,
      startTime: Date.now(),
      recovered: false
    });
    const timeout = setTimeout(() => {
      this.handleRequestTimeout(requestId);
    }, this.maxRequestTime);
    this.requestTimeouts.set(requestId, timeout);
  }
  /**
   * Complete a successful request
   */
  completeRequest(requestId) {
    this.pendingRequests.delete(requestId);
    const timeout = this.requestTimeouts.get(requestId);
    if (timeout) {
      clearTimeout(timeout);
      this.requestTimeouts.delete(requestId);
    }
  }
  /**
   * Handle request timeout (stuck request)
   */
  handleRequestTimeout(requestId) {
    const request = this.pendingRequests.get(requestId);
    if (!request || request.recovered) return;
    console.warn(`Combined listings request timed out: ${request.url}`);
    request.recovered = true;
    this.attemptRecovery(request.url);
    this.completeRequest(requestId);
  }
  /**
   * Handle request errors
   */
  handleRequestError(requestId, error) {
    const request = this.pendingRequests.get(requestId);
    if (request) {
      console.warn(`Combined listings request failed: ${request.url}`, error);
      this.attemptRecovery(request.url);
    }
    this.completeRequest(requestId);
  }
  /**
   * Attempt to recover from stuck state
   */
  attemptRecovery(failedUrl) {
    const attemptKey = failedUrl;
    const attempts = this.recoveryAttempts.get(attemptKey) || 0;
    if (attempts >= this.maxRecoveryAttempts) {
      console.warn(`Max recovery attempts reached for: ${failedUrl}`);
      return;
    }
    this.recoveryAttempts.set(attemptKey, attempts + 1);
    console.log(`Attempting recovery ${attempts + 1}/${this.maxRecoveryAttempts} for: ${failedUrl}`);
    setTimeout(() => {
      this.executeRecovery(failedUrl, attempts);
    }, 1e3 * (attempts + 1));
  }
  /**
   * Execute recovery strategies
   */
  executeRecovery(failedUrl, attemptNumber) {
    const variantPickers = document.querySelectorAll("variant-picker");
    variantPickers.forEach((picker) => {
      try {
        switch (attemptNumber) {
          case 0:
            this.clearPendingRequests(picker);
            break;
          case 1:
            this.resetPickerState(picker);
            break;
          case 2:
            this.forceRefreshPicker(picker);
            break;
        }
      } catch (error) {
        console.warn("Recovery strategy failed:", error);
      }
    });
  }
  /**
   * Clear pending requests from variant picker
   */
  clearPendingRequests(picker) {
    if (picker.abortController) {
      picker.abortController.abort();
    }
    if (picker._pendingRequestUrl !== void 0) {
      picker._pendingRequestUrl = void 0;
    }
  }
  /**
   * Reset picker state to initial state
   */
  resetPickerState(picker) {
    this.clearPendingRequests(picker);
    if (typeof picker.initializeInventoryStates === "function") {
      picker.initializeInventoryStates();
    }
  }
  /**
   * Force refresh picker content
   */
  forceRefreshPicker(picker) {
    this.resetPickerState(picker);
    this.safeRefreshPicker(picker);
  }
  /**
   * Safely refresh picker without triggering problematic events
   */
  safeRefreshPicker(picker) {
    var _a;
    try {
      if (typeof picker.initializeInventoryStates === "function") {
        picker.initializeInventoryStates();
      }
      this.refreshThemeProductData(picker);
      const productForm = picker.closest("product-form");
      if (productForm && productForm.productForm && productForm.productForm.product) {
        const currentVariant = (_a = productForm.productForm.product.variants) == null ? void 0 : _a.find((v2) => v2 && v2.available);
        if (currentVariant) {
          const firstOption = picker.querySelector("[data-single-option-selector]:checked");
          if (firstOption) {
            console.log("[CombinedListingsRecovery] Triggering safe picker refresh");
            firstOption.dispatchEvent(new Event("change", {
              bubbles: true
            }));
          }
        } else {
          console.warn("[CombinedListingsRecovery] Skipping change event trigger - no valid variants available");
        }
      } else {
        console.warn("[CombinedListingsRecovery] Skipping change event trigger - product form not ready");
      }
    } catch (error) {
      console.warn("[CombinedListingsRecovery] Safe refresh failed:", error);
    }
  }
  /**
   * Periodic health check to detect stuck states
   */
  setupPeriodicHealthCheck() {
    setInterval(() => {
      this.performHealthCheck();
    }, 3e4);
  }
  /**
   * Perform health check on variant pickers
   */
  performHealthCheck() {
    const variantPickers = document.querySelectorAll("variant-picker");
    variantPickers.forEach((picker) => {
      const twoMinutesAgo = Date.now() - 2 * 60 * 1e3;
      this.pendingRequests.forEach((request, requestId) => {
        if (request.startTime < twoMinutesAgo && !request.recovered) {
          console.warn("Detected very old pending request, forcing recovery");
          this.handleRequestTimeout(requestId);
        }
      });
    });
  }
  /**
   * Set up global error recovery
   */
  setupErrorRecovery() {
    let errorRecoveryAttempts = 0;
    const maxErrorRecoveryAttempts = 2;
    window.addEventListener("error", (event) => {
      if (event.message && event.message.includes("Cannot read properties of null")) {
        const isVariantRelated = event.filename && (event.filename.includes("theme.dev.js") || event.filename.includes("variant-picker"));
        if (isVariantRelated && errorRecoveryAttempts < maxErrorRecoveryAttempts) {
          errorRecoveryAttempts++;
          console.warn(`[CombinedListingsRecovery] Detected variant-related null error (attempt ${errorRecoveryAttempts}/${maxErrorRecoveryAttempts}), attempting recovery`);
          setTimeout(() => {
            this.executeGlobalRecovery();
          }, 200);
        } else if (isVariantRelated) {
          console.warn("[CombinedListingsRecovery] Max error recovery attempts reached, skipping recovery");
        }
      }
    });
  }
  /**
   * Execute global recovery for critical errors
   */
  executeGlobalRecovery() {
    console.log("[CombinedListingsRecovery] Executing global recovery for null variant errors");
    const variantPickers = document.querySelectorAll("variant-picker");
    variantPickers.forEach((picker) => {
      try {
        this.refreshThemeProductData(picker);
        setTimeout(() => {
          try {
            this.safeRefreshPicker(picker);
          } catch (error) {
            console.warn("[CombinedListingsRecovery] Safe refresh failed during global recovery:", error);
          }
        }, 100);
      } catch (error) {
        console.warn("[CombinedListingsRecovery] Global recovery failed for picker:", error);
      }
    });
  }
  /**
   * Refresh theme product data
   */
  refreshThemeProductData(picker) {
    const productForm = picker.closest("product-form");
    if (!productForm || !productForm.productForm) return;
    try {
      const productScript = document.querySelector("[data-product-json]");
      if (productScript && productScript.textContent) {
        const productData = JSON.parse(productScript.textContent);
        if (productData && productData.variants) {
          productForm.productForm.product = productData;
        }
      }
    } catch (error) {
      console.warn("Could not refresh theme product data:", error);
    }
  }
  /**
   * Generate unique request ID
   */
  generateRequestId() {
    return `req_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
}
let combinedListingsRecovery;
document.addEventListener("DOMContentLoaded", () => {
  combinedListingsRecovery = new CombinedListingsRecovery();
});
window.combinedListingsRecovery = () => combinedListingsRecovery;
class PopupContentManager {
  constructor() {
    this.loadedUrls = /* @__PURE__ */ new Set();
    if (customElements.get("popup-component")) {
      console.log("[PopupContentFetcher] popup-component already defined, initializing");
      this.init();
    } else {
      console.log("[PopupContentFetcher] Waiting for popup-component to be defined");
      customElements.whenDefined("popup-component").then(() => {
        console.log("[PopupContentFetcher] popup-component now defined, initializing");
        this.init();
      });
    }
  }
  static getInstance() {
    if (!PopupContentManager.instance) {
      PopupContentManager.instance = new PopupContentManager();
    }
    return PopupContentManager.instance;
  }
  init() {
    console.log("[PopupContentFetcher] Initializing...");
    document.addEventListener("click", (event) => {
      const target = event.target;
      if (target.matches("[data-popup-open]")) {
        console.log("[PopupContentFetcher] Popup open button clicked:", target);
        const popupComponent = target.closest("popup-component");
        if (popupComponent) {
          console.log("[PopupContentFetcher] Found popup component, scheduling content load");
          setTimeout(() => this.handlePopupOpen(popupComponent), 300);
        }
      }
    }, true);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "open") {
          const dialog = mutation.target;
          if (dialog.open && dialog.closest("popup-component")) {
            console.log("[PopupContentFetcher] Dialog opened via MutationObserver:", dialog);
            const popupComponent = dialog.closest("popup-component");
            if (popupComponent) {
              setTimeout(() => this.handlePopupOpen(popupComponent), 100);
            }
          }
        }
      });
    });
    const observeDialogs = () => {
      const dialogs = document.querySelectorAll("dialog");
      console.log(`[PopupContentFetcher] Found ${dialogs.length} dialogs to observe`);
      dialogs.forEach((dialog, index) => {
        console.log(`[PopupContentFetcher] Observing dialog ${index + 1}:`, dialog);
        observer.observe(dialog, {
          attributes: true,
          attributeFilter: ["open"]
        });
      });
      const globalObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const element = node;
              const newDialogs = element.matches("dialog") ? [element] : element.querySelectorAll("dialog");
              newDialogs.forEach((dialog) => {
                console.log("[PopupContentFetcher] Observing newly added dialog:", dialog);
                observer.observe(dialog, {
                  attributes: true,
                  attributeFilter: ["open"]
                });
              });
            }
          });
        });
      });
      globalObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    };
    if (document.readyState !== "loading") {
      observeDialogs();
    } else {
      document.addEventListener("DOMContentLoaded", observeDialogs);
    }
  }
  async handlePopupOpen(popupComponent) {
    console.log("[PopupContentFetcher] handlePopupOpen called for:", popupComponent);
    const dialog = popupComponent.querySelector("dialog");
    const contentContainer = popupComponent.querySelector("[data-popup-content]");
    console.log("[PopupContentFetcher] Found dialog:", dialog);
    console.log("[PopupContentFetcher] Found content container:", contentContainer);
    if (!dialog || !contentContainer) {
      console.warn("[PopupContentFetcher] Missing dialog or content container");
      return;
    }
    const url = dialog.getAttribute("data-popup-url");
    const text = dialog.getAttribute("data-popup-text");
    const debug = dialog.getAttribute("data-popup-debug");
    console.log("[PopupContentFetcher] URL:", url);
    console.log("[PopupContentFetcher] Text:", text);
    console.log("[PopupContentFetcher] Debug:", debug);
    const dataAttributes = Array.from(dialog.attributes).filter((attr) => attr.name.startsWith("data-")).map((attr) => `${attr.name}: ${attr.value}`);
    console.log("[PopupContentFetcher] All data attributes:", dataAttributes);
    const config = {
      url: url || void 0,
      text: text || void 0,
      container: contentContainer
    };
    if (config.url && this.loadedUrls.has(config.url)) {
      console.log("[PopupContentFetcher] Content already loaded for URL:", config.url);
      return;
    }
    console.log("[PopupContentFetcher] Loading content with config:", config);
    await this.loadContent(config);
  }
  async loadContent(config) {
    const {
      url,
      text,
      container
    } = config;
    console.log("[PopupContentFetcher] loadContent called with:", config);
    if (text && !url) {
      console.log("[PopupContentFetcher] Using text content");
      container.innerHTML = `<div class="popup-text-content">${text}</div>`;
      return;
    }
    if (!url) {
      console.log("[PopupContentFetcher] No URL provided");
      container.innerHTML = '<div class="popup-error">No content available</div>';
      return;
    }
    try {
      console.log("[PopupContentFetcher] Starting fetch for URL:", url);
      this.showLoading(container);
      const response = await fetch(url);
      console.log("[PopupContentFetcher] Fetch response:", response.status, response.statusText);
      if (!response.ok) {
        throw new Error(`Failed to fetch content: ${response.status}`);
      }
      const html = await response.text();
      console.log("[PopupContentFetcher] Got HTML response, length:", html.length);
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const mainContent = doc.querySelector("#MainContent");
      console.log("[PopupContentFetcher] Found MainContent:", !!mainContent);
      if (mainContent) {
        const contentClone = mainContent.cloneNode(true);
        container.innerHTML = "";
        container.appendChild(contentClone);
      } else {
        throw new Error("MainContent not found in the fetched page");
      }
    } catch (error) {
      console.error("Error loading popup content:", error);
      this.showError(container, error instanceof Error ? error.message : "Failed to load content");
    }
  }
  showLoading(container) {
    container.innerHTML = `
      <div class="popup-loading" style="text-align: center; padding: 2rem;">
        <div class="rs-animate-spin rs-inline-block rs-w-6 rs-h-6 rs-border-2 rs-border-solid rs-border-current rs-border-r-transparent rs-rounded-full"></div>
        <p class="rs-mt-2">Loading...</p>
      </div>
    `;
  }
  showError(container, message) {
    container.innerHTML = `
      <div class="popup-error" style="text-align: center; padding: 2rem; color: #dc2626;">
        <p><strong>Error:</strong> ${message}</p>
      </div>
    `;
  }
  processContent(container, baseUrl) {
    const base = new URL(baseUrl);
    const images = container.querySelectorAll("img[src]");
    images.forEach((img) => {
      const src = img.getAttribute("src");
      if (src && src.startsWith("/")) {
        img.setAttribute("src", `${base.origin}${src}`);
      }
    });
    const links = container.querySelectorAll("a[href]");
    links.forEach((link) => {
      const href = link.getAttribute("href");
      if (href && href.startsWith("/")) {
        link.setAttribute("href", `${base.origin}${href}`);
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
      }
    });
    const scripts = container.querySelectorAll("script");
    scripts.forEach((script) => script.remove());
  }
  // Public method for manual testing/debugging
  testPopupContentLoad() {
    console.log("[PopupContentFetcher] Manual test triggered");
    const popupComponents = document.querySelectorAll("popup-component");
    console.log(`[PopupContentFetcher] Found ${popupComponents.length} popup components`);
    popupComponents.forEach((popup, index) => {
      console.log(`[PopupContentFetcher] Testing popup ${index + 1}:`, popup);
      this.handlePopupOpen(popup);
    });
  }
}
document.addEventListener("DOMContentLoaded", () => {
  console.log("[PopupContentFetcher] DOM Content Loaded, initializing...");
  const popupComponents = document.querySelectorAll("popup-component");
  console.log(`[PopupContentFetcher] Found ${popupComponents.length} popup-component elements`);
  PopupContentManager.getInstance();
});
if (document.readyState !== "loading") {
  console.log("[PopupContentFetcher] DOM already loaded, initializing immediately...");
  const popupComponents = document.querySelectorAll("popup-component");
  console.log(`[PopupContentFetcher] Found ${popupComponents.length} popup-component elements`);
  PopupContentManager.getInstance();
}
window.PopupContentManager = PopupContentManager;
window.testPopupContent = () => {
  const manager = PopupContentManager.getInstance();
  manager.testPopupContentLoad();
};
var t = {};
function a(e) {
  return e.type === k ? "Fragment" : "function" == typeof e.type ? e.type.displayName || e.type.name : "string" == typeof e.type ? e.type : "#text";
}
var i = [], s = [];
function c() {
  return i.length > 0 ? i[i.length - 1] : null;
}
var l = true;
function u(e) {
  return "function" == typeof e.type && e.type != k;
}
function f(n) {
  for (var e = [n], o = n; null != o.__o; ) e.push(o.__o), o = o.__o;
  return e.reduce(function(n2, e2) {
    n2 += "  in " + a(e2);
    var o2 = e2.__source;
    return o2 ? n2 += " (at " + o2.fileName + ":" + o2.lineNumber + ")" : l && console.warn("Add @babel/plugin-transform-react-jsx-source to get a more detailed component stack. Note that you should not add it to production builds of your App for bundle size reasons."), l = false, n2 + "\n";
  }, "");
}
var d = "function" == typeof WeakMap;
function p(n) {
  var e = [];
  return n.__k ? (n.__k.forEach(function(n2) {
    n2 && "function" == typeof n2.type ? e.push.apply(e, p(n2)) : n2 && "string" == typeof n2.type && e.push(n2.type);
  }), e) : e;
}
function h(n) {
  return n ? "function" == typeof n.type ? null == n.__ ? null != n.__e && null != n.__e.parentNode ? n.__e.parentNode.localName : "" : h(n.__) : n.type : "";
}
var v = x.prototype.setState;
function y(n) {
  return "table" === n || "tfoot" === n || "tbody" === n || "thead" === n || "td" === n || "tr" === n || "th" === n;
}
x.prototype.setState = function(n, e) {
  return null == this.__v && null == this.state && console.warn('Calling "this.setState" inside the constructor of a component is a no-op and might be a bug in your application. Instead, set "this.state = {}" directly.\n\n' + f(c())), v.call(this, n, e);
};
var m = /^(address|article|aside|blockquote|details|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|main|menu|nav|ol|p|pre|search|section|table|ul)$/, b = x.prototype.forceUpdate;
function w(n) {
  var e = n.props, o = a(n), t2 = "";
  for (var r2 in e) if (e.hasOwnProperty(r2) && "children" !== r2) {
    var i2 = e[r2];
    "function" == typeof i2 && (i2 = "function " + (i2.displayName || i2.name) + "() {}"), i2 = Object(i2) !== i2 || i2.toString ? i2 + "" : Object.prototype.toString.call(i2), t2 += " " + r2 + "=" + JSON.stringify(i2);
  }
  var s2 = e.children;
  return "<" + o + t2 + (s2 && s2.length ? ">..</" + o + ">" : " />");
}
x.prototype.forceUpdate = function(n) {
  return null == this.__v ? console.warn('Calling "this.forceUpdate" inside the constructor of a component is a no-op and might be a bug in your application.\n\n' + f(c())) : null == this.__P && console.warn(`Can't call "this.forceUpdate" on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in the componentWillUnmount method.

` + f(this.__v)), b.call(this, n);
}, l$1.__m = function(n, e) {
  var o = n.type, t2 = e.map(function(n2) {
    return n2 && n2.localName;
  }).filter(Boolean);
  console.error('Expected a DOM node of type "' + o + '" but found "' + t2.join(", ") + `" as available DOM-node(s), this is caused by the SSR'd HTML containing different DOM-nodes compared to the hydrated one.

` + f(n));
}, function() {
  !function() {
    var n2 = l$1.__b, o2 = l$1.diffed, t2 = l$1.__, r3 = l$1.vnode, a2 = l$1.__r;
    l$1.diffed = function(n3) {
      u(n3) && s.pop(), i.pop(), o2 && o2(n3);
    }, l$1.__b = function(e) {
      u(e) && i.push(e), n2 && n2(e);
    }, l$1.__ = function(n3, e) {
      s = [], t2 && t2(n3, e);
    }, l$1.vnode = function(n3) {
      n3.__o = s.length > 0 ? s[s.length - 1] : null, r3 && r3(n3);
    }, l$1.__r = function(n3) {
      u(n3) && s.push(n3), a2 && a2(n3);
    };
  }();
  var n = false, o = l$1.__b, r2 = l$1.diffed, c2 = l$1.vnode, l2 = l$1.__r, v2 = l$1.__e, b2 = l$1.__, g2 = l$1.__h, E2 = d ? { useEffect: /* @__PURE__ */ new WeakMap(), useLayoutEffect: /* @__PURE__ */ new WeakMap(), lazyPropTypes: /* @__PURE__ */ new WeakMap() } : null, k2 = [];
  l$1.__e = function(n2, e, o2, t2) {
    if (e && e.__c && "function" == typeof n2.then) {
      var r3 = n2;
      n2 = new Error("Missing Suspense. The throwing component was: " + a(e));
      for (var i2 = e; i2; i2 = i2.__) if (i2.__c && i2.__c.__c) {
        n2 = r3;
        break;
      }
      if (n2 instanceof Error) throw n2;
    }
    try {
      (t2 = t2 || {}).componentStack = f(e), v2(n2, e, o2, t2), "function" != typeof n2.then && setTimeout(function() {
        throw n2;
      });
    } catch (n3) {
      throw n3;
    }
  }, l$1.__ = function(n2, e) {
    if (!e) throw new Error("Undefined parent passed to render(), this is the second argument.\nCheck if the element is available in the DOM/has the correct id.");
    var o2;
    switch (e.nodeType) {
      case 1:
      case 11:
      case 9:
        o2 = true;
        break;
      default:
        o2 = false;
    }
    if (!o2) {
      var t2 = a(n2);
      throw new Error("Expected a valid HTML node as a second argument to render.	Received " + e + " instead: render(<" + t2 + " />, " + e + ");");
    }
    b2 && b2(n2, e);
  }, l$1.__b = function(e) {
    var r3 = e.type;
    if (n = true, void 0 === r3) throw new Error("Undefined component passed to createElement()\n\nYou likely forgot to export your component or might have mixed up default and named imports" + w(e) + "\n\n" + f(e));
    if (null != r3 && "object" == typeof r3) {
      if (void 0 !== r3.__k && void 0 !== r3.__e) throw new Error("Invalid type passed to createElement(): " + r3 + "\n\nDid you accidentally pass a JSX literal as JSX twice?\n\n  let My" + a(e) + " = " + w(r3) + ";\n  let vnode = <My" + a(e) + " />;\n\nThis usually happens when you export a JSX literal and not the component.\n\n" + f(e));
      throw new Error("Invalid type passed to createElement(): " + (Array.isArray(r3) ? "array" : r3));
    }
    if (void 0 !== e.ref && "function" != typeof e.ref && "object" != typeof e.ref && !("$$typeof" in e)) throw new Error(`Component's "ref" property should be a function, or an object created by createRef(), but got [` + typeof e.ref + "] instead\n" + w(e) + "\n\n" + f(e));
    if ("string" == typeof e.type) {
      for (var i2 in e.props) if ("o" === i2[0] && "n" === i2[1] && "function" != typeof e.props[i2] && null != e.props[i2]) throw new Error(`Component's "` + i2 + '" property should be a function, but got [' + typeof e.props[i2] + "] instead\n" + w(e) + "\n\n" + f(e));
    }
    if ("function" == typeof e.type && e.type.propTypes) {
      if ("Lazy" === e.type.displayName && E2 && !E2.lazyPropTypes.has(e.type)) {
        var s2 = "PropTypes are not supported on lazy(). Use propTypes on the wrapped component itself. ";
        try {
          var c3 = e.type();
          E2.lazyPropTypes.set(e.type, true), console.warn(s2 + "Component wrapped in lazy() is " + a(c3));
        } catch (n2) {
          console.warn(s2 + "We will log the wrapped component's name once it is loaded.");
        }
      }
      var l3 = e.props;
      e.type.__f && delete (l3 = function(n2, e2) {
        for (var o2 in e2) n2[o2] = e2[o2];
        return n2;
      }({}, l3)).ref, function(n2, e2, o2, r4, a2) {
        Object.keys(n2).forEach(function(o3) {
          var i3;
          try {
            i3 = n2[o3](e2, o3, r4, "prop", null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (n3) {
            i3 = n3;
          }
          i3 && !(i3.message in t) && (t[i3.message] = true, console.error("Failed prop type: " + i3.message + (a2 && "\n" + a2() || "")));
        });
      }(e.type.propTypes, l3, 0, a(e), function() {
        return f(e);
      });
    }
    o && o(e);
  };
  var T2, _2 = 0;
  l$1.__r = function(e) {
    l2 && l2(e), n = true;
    var o2 = e.__c;
    if (o2 === T2 ? _2++ : _2 = 1, _2 >= 25) throw new Error("Too many re-renders. This is limited to prevent an infinite loop which may lock up your browser. The component causing this is: " + a(e));
    T2 = o2;
  }, l$1.__h = function(e, o2, t2) {
    if (!e || !n) throw new Error("Hook can only be invoked from render methods.");
    g2 && g2(e, o2, t2);
  };
  var O2 = function(n2, e) {
    return { get: function() {
      var o2 = "get" + n2 + e;
      k2 && k2.indexOf(o2) < 0 && (k2.push(o2), console.warn("getting vnode." + n2 + " is deprecated, " + e));
    }, set: function() {
      var o2 = "set" + n2 + e;
      k2 && k2.indexOf(o2) < 0 && (k2.push(o2), console.warn("setting vnode." + n2 + " is not allowed, " + e));
    } };
  }, I = { nodeName: O2("nodeName", "use vnode.type"), attributes: O2("attributes", "use vnode.props"), children: O2("children", "use vnode.props.children") }, M = Object.create({}, I);
  l$1.vnode = function(n2) {
    var e = n2.props;
    if (null !== n2.type && null != e && ("__source" in e || "__self" in e)) {
      var o2 = n2.props = {};
      for (var t2 in e) {
        var r3 = e[t2];
        "__source" === t2 ? n2.__source = r3 : "__self" === t2 ? n2.__self = r3 : o2[t2] = r3;
      }
    }
    n2.__proto__ = M, c2 && c2(n2);
  }, l$1.diffed = function(e) {
    var o2, t2 = e.type, i2 = e.__;
    if (e.__k && e.__k.forEach(function(n2) {
      if ("object" == typeof n2 && n2 && void 0 === n2.type) {
        var o3 = Object.keys(n2).join(",");
        throw new Error("Objects are not valid as a child. Encountered an object with the keys {" + o3 + "}.\n\n" + f(e));
      }
    }), e.__c === T2 && (_2 = 0), "string" == typeof t2 && (y(t2) || "p" === t2 || "a" === t2 || "button" === t2)) {
      var s2 = h(i2);
      if ("" !== s2 && y(t2)) "table" === t2 && "td" !== s2 && y(s2) ? console.error("Improper nesting of table. Your <table> should not have a table-node parent." + w(e) + "\n\n" + f(e)) : "thead" !== t2 && "tfoot" !== t2 && "tbody" !== t2 || "table" === s2 ? "tr" === t2 && "thead" !== s2 && "tfoot" !== s2 && "tbody" !== s2 ? console.error("Improper nesting of table. Your <tr> should have a <thead/tbody/tfoot> parent." + w(e) + "\n\n" + f(e)) : "td" === t2 && "tr" !== s2 ? console.error("Improper nesting of table. Your <td> should have a <tr> parent." + w(e) + "\n\n" + f(e)) : "th" === t2 && "tr" !== s2 && console.error("Improper nesting of table. Your <th> should have a <tr>." + w(e) + "\n\n" + f(e)) : console.error("Improper nesting of table. Your <thead/tbody/tfoot> should have a <table> parent." + w(e) + "\n\n" + f(e));
      else if ("p" === t2) {
        var c3 = p(e).filter(function(n2) {
          return m.test(n2);
        });
        c3.length && console.error("Improper nesting of paragraph. Your <p> should not have " + c3.join(", ") + " as child-elements." + w(e) + "\n\n" + f(e));
      } else "a" !== t2 && "button" !== t2 || -1 !== p(e).indexOf(t2) && console.error("Improper nesting of interactive content. Your <" + t2 + "> should not have other " + ("a" === t2 ? "anchor" : "button") + " tags as child-elements." + w(e) + "\n\n" + f(e));
    }
    if (n = false, r2 && r2(e), null != e.__k) for (var l3 = [], u2 = 0; u2 < e.__k.length; u2++) {
      var d2 = e.__k[u2];
      if (d2 && null != d2.key) {
        var v3 = d2.key;
        if (-1 !== l3.indexOf(v3)) {
          console.error('Following component has two or more children with the same key attribute: "' + v3 + '". This may cause glitches and misbehavior in rendering process. Component: \n\n' + w(e) + "\n\n" + f(e));
          break;
        }
        l3.push(v3);
      }
    }
    if (null != e.__c && null != e.__c.__H) {
      var b3 = e.__c.__H.__;
      if (b3) for (var g3 = 0; g3 < b3.length; g3 += 1) {
        var E3 = b3[g3];
        if (E3.__H) {
          for (var k3 = 0; k3 < E3.__H.length; k3++) if ((o2 = E3.__H[k3]) != o2) {
            var O3 = a(e);
            console.warn("Invalid argument passed to hook. Hooks should not be called with NaN in the dependency array. Hook index " + g3 + " in component " + O3 + " was called with NaN.");
          }
        }
      }
    }
  };
}();
(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
